var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _g4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g5, _path31, _path32, _path33, _path34, _path35, _path36, _g6, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g7, _path56, _path57, _path58, _path59, _g8, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g9, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g10, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyArtLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6094",
    "data-name": "Rectangle 6094",
    width: 200,
    height: 200,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5988",
    "data-name": "Rectangle 5988",
    width: 73.975,
    height: 40.679,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17672",
    "data-name": "Path 17672",
    d: "M279.006,461.16l-55.413-30.839c-2.057-.915-5.078-1.779-7.1-.582l-5.161,3.064c-1.038.616-4.452,2.662-2.169,3.872,6.718,3.56,49.644,28,56.466,31.614a9.792,9.792,0,0,0,5.159.771,13.217,13.217,0,0,0,5.587-1.622l2.061-1.239c1.457-.876,2.264-1.832,2.342-2.75.076-.9-.515-1.728-1.778-2.289",
    transform: "translate(-208.397 -429.153)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5989",
    "data-name": "Rectangle 5989",
    width: 56.309,
    height: 52.715,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6083",
    "data-name": "Rectangle 6083",
    width: 31.917,
    height: 16.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17820",
    "data-name": "Path 17820",
    d: "M31.917,470.186,13.7,484.941,0,477.249l25.428-7.577,4.99-1.686Z",
    transform: "translate(0 -467.987)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6084",
    "data-name": "Rectangle 6084",
    width: 48.335,
    height: 64.552,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6085",
    "data-name": "Rectangle 6085",
    width: 5.166,
    height: 21.534,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6086",
    "data-name": "Rectangle 6086",
    width: 3.729,
    height: 8.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6089",
    "data-name": "Rectangle 6089",
    width: 37.865,
    height: 9.619,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18115",
    "data-name": "Path 18115",
    d: "M268.747,610.358h-7.23c-6.007,0-11.577.973-14.691,2.568l-3.413,1.748c-2.762,1.414-1.811,3.241,2.245,4.314a31.13,31.13,0,0,0,10.115.668l4.659-.426a19.517,19.517,0,0,0,5.828-1.3l8.716-3.856c3.538-1.565-.07-3.718-6.231-3.718",
    transform: "translate(-241.839 -610.358)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6090",
    "data-name": "Rectangle 6090",
    width: 4.974,
    height: 5.947,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6091",
    "data-name": "Rectangle 6091",
    width: 6.091,
    height: 28.319,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6092",
    "data-name": "Rectangle 6092",
    width: 5.866,
    height: 7.823,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11730",
    "data-name": "Group 11730",
    transform: "translate(-640 -289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11691",
    "data-name": "Group 11691",
    transform: "translate(640 289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11729",
    "data-name": "Group 11729",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11728",
    "data-name": "Group 11728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11727",
    "data-name": "Group 11727",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17456",
    "data-name": "Path 17456",
    d: "M388.694,21.092a11.786,11.786,0,0,1,4.215,3.9c-.015-.3-.029.79-.02-.889s.943-5.347,2.424-6.567,3.523-1.378,5.781-.175a15.129,15.129,0,0,1,5.787,6.362,26.042,26.042,0,0,1,2.409,9.222c0,1.7-.009.587-.026.872,1.257-.367,2.385-.363,4.326.683a16.843,16.843,0,0,1,5.9,6.494,20.792,20.792,0,0,1,2.482,9.378,9.69,9.69,0,0,1-1.543,5.741,8.586,8.586,0,0,1-4.229,2.594c-3.86,1.307-11.3-6.32-15.231-8.486q-6.251-3.448-12.438-6.857a15.164,15.164,0,0,1-5.706-6.421,20.24,20.24,0,0,1-2.279-9.149c.017-1.786-1.323-4.466.411-5.75,2.7-1.994,5.575-2.119,7.734-.955",
    transform: "translate(-258.408 -11.38)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17457",
    "data-name": "Path 17457",
    d: "M414.56,58.472c-2.8,0-6.615-2.934-10.032-5.56a41.255,41.255,0,0,0-4.392-3.116L387.7,42.938a15.379,15.379,0,0,1-5.835-6.554,20.434,20.434,0,0,1-2.313-9.291,9.428,9.428,0,0,0-.222-1.71c-.288-1.531-.615-3.267.761-4.284,2.613-1.933,5.635-2.3,8.082-.98a11.331,11.331,0,0,1,3.722,3.2c.041-1.656.941-5.4,2.537-6.716,1.656-1.364,3.836-1.438,6.141-.21a15.355,15.355,0,0,1,5.918,6.493,26.1,26.1,0,0,1,2.445,9.366c0,.185,0,.336,0,.46a5.55,5.55,0,0,1,4.136.823,17.285,17.285,0,0,1,6.032,6.624,20.956,20.956,0,0,1,2.517,9.52,10.024,10.024,0,0,1-1.6,5.921,8.5,8.5,0,0,1-4.39,2.71,3.314,3.314,0,0,1-1.065.166M385.046,19.963a7.749,7.749,0,0,0-4.572,1.632c-1.062.786-.785,2.255-.518,3.676a9.837,9.837,0,0,1,.233,1.828,19.814,19.814,0,0,0,2.246,9.007,14.759,14.759,0,0,0,5.578,6.289l12.438,6.857a41.482,41.482,0,0,1,4.473,3.17c3.561,2.736,7.992,6.14,10.495,5.294a8.023,8.023,0,0,0,4.072-2.479,9.428,9.428,0,0,0,1.484-5.56,20.34,20.34,0,0,0-2.446-9.236,16.6,16.6,0,0,0-5.773-6.364,4.836,4.836,0,0,0-3.871-.714.274.274,0,0,1-.271.168.353.353,0,0,1-.171-.042l-.2.06.027-.445a.49.49,0,0,1,.023-.128c0-.19,0-.471,0-.727a25.84,25.84,0,0,0-2.374-9.08,14.731,14.731,0,0,0-5.655-6.23c-2.057-1.1-3.981-1.046-5.421.139-1.418,1.168-2.3,4.762-2.311,6.331,0,.263,0,.554,0,.742a.5.5,0,0,1,.022.13l.053,1.074-.493-.683a.3.3,0,0,1-.215-.3,11.3,11.3,0,0,0-4.035-3.708,5.888,5.888,0,0,0-2.813-.7",
    transform: "translate(-257.729 -10.679)",
    fill: "#09f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17458",
    "data-name": "Path 17458",
    d: "M384.887,24.055a11.779,11.779,0,0,1,4.215,3.9c-.015-.3-.029.79-.02-.889s.943-5.347,2.424-6.567,3.523-1.378,5.781-.175a15.135,15.135,0,0,1,5.787,6.361,26.057,26.057,0,0,1,2.409,9.223c0,1.7-.009.587-.026.872,1.257-.368,2.384-.363,4.326.683a16.841,16.841,0,0,1,5.9,6.494,20.741,20.741,0,0,1,2.482,9.378c.008,3.151-.935,5.5-2.456,6.732s-3.618,1.347-5.929.073l-12.617-6.957q-6.251-3.448-12.439-6.857a15.16,15.16,0,0,1-5.706-6.421,20.242,20.242,0,0,1-2.279-9.149c.029-3.057.949-5.329,2.418-6.54a5.294,5.294,0,0,1,5.728-.164",
    transform: "translate(-256.144 -13.418)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17459",
    "data-name": "Path 17459",
    d: "M412.253,60.653a6.9,6.9,0,0,1-3.309-.938l-12.617-6.957-8.1-4.466L383.89,45.9a15.379,15.379,0,0,1-5.835-6.554,20.434,20.434,0,0,1-2.313-9.291c.029-3.047.928-5.454,2.531-6.775a5.63,5.63,0,0,1,6.089-.2,11.335,11.335,0,0,1,3.721,3.2c.041-1.657.942-5.4,2.537-6.715,1.656-1.363,3.837-1.438,6.142-.21a15.355,15.355,0,0,1,5.918,6.493,26.082,26.082,0,0,1,2.445,9.366c0,.185,0,.336,0,.46a5.545,5.545,0,0,1,4.135.822,17.281,17.281,0,0,1,6.032,6.624,20.957,20.957,0,0,1,2.518,9.521c.007,3.143-.906,5.619-2.571,6.972a4.644,4.644,0,0,1-2.983,1.043M381.288,22.912a4.07,4.07,0,0,0-2.6.844c-1.459,1.2-2.277,3.442-2.3,6.305a19.818,19.818,0,0,0,2.246,9.007,14.763,14.763,0,0,0,5.578,6.289l4.338,2.391q4.036,2.225,8.1,4.466l12.617,6.957c2.12,1.169,4.1,1.153,5.566-.041,1.517-1.232,2.348-3.537,2.341-6.492a20.337,20.337,0,0,0-2.447-9.236,16.6,16.6,0,0,0-5.773-6.364,4.837,4.837,0,0,0-3.871-.714.273.273,0,0,1-.271.168.329.329,0,0,1-.171-.042l-.2.06.026-.444a.489.489,0,0,1,.023-.128c0-.19,0-.472,0-.728a25.833,25.833,0,0,0-2.374-9.08,14.733,14.733,0,0,0-5.655-6.23c-2.056-1.1-3.982-1.046-5.421.139-1.417,1.167-2.3,4.762-2.311,6.331,0,.262,0,.553,0,.741a.512.512,0,0,1,.022.131l.053,1.074-.493-.682a.3.3,0,0,1-.215-.3,11.3,11.3,0,0,0-4.035-3.708,5.883,5.883,0,0,0-2.763-.715",
    transform: "translate(-255.464 -12.717)",
    fill: "#09f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17460",
    "data-name": "Path 17460",
    d: "M425.519,68.014l-3.08-1.732,4.844,8.174,4.875-2.707-3.078-1.733.009-7.7-3.56-2Z",
    transform: "translate(-287.214 -41.503)",
    fill: "#09f",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11695",
    "data-name": "Group 11695",
    transform: "translate(65.197 133.249)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11694",
    "data-name": "Group 11694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11693",
    "data-name": "Group 11693",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11692",
    "data-name": "Group 11692",
    transform: "translate(1.512 0.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11691-2",
    "data-name": "Group 11691",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17461",
    "data-name": "Path 17461",
    d: "M203.673,457.7l56.857,31.164H203.673Z",
    transform: "translate(-205.185 -448.794)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17462",
    "data-name": "Path 17462",
    d: "M203.673,457.484l56.979,31.231h-.122l-56.857-31.164Z",
    transform: "translate(-205.185 -448.647)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17463",
    "data-name": "Path 17463",
    d: "M203.673,457.27l57.1,31.3h-.122l-56.979-31.231Z",
    transform: "translate(-205.185 -448.5)",
    fill: "#feffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17464",
    "data-name": "Path 17464",
    d: "M203.673,457.057l57.222,31.364h-.122l-57.1-31.3Z",
    transform: "translate(-205.185 -448.353)",
    fill: "#fdfeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17465",
    "data-name": "Path 17465",
    d: "M203.673,456.843l57.344,31.431h-.122L203.673,456.91Z",
    transform: "translate(-205.185 -448.206)",
    fill: "#fcfeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17466",
    "data-name": "Path 17466",
    d: "M203.673,456.629l57.465,31.5h-.122L203.673,456.7Z",
    transform: "translate(-205.185 -448.059)",
    fill: "#fbfdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17467",
    "data-name": "Path 17467",
    d: "M203.673,456.415,261.26,487.98h-.122l-57.465-31.5Z",
    transform: "translate(-205.185 -447.912)",
    fill: "#fafdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17468",
    "data-name": "Path 17468",
    d: "M203.673,456.2l57.709,31.631h-.122l-57.587-31.564Z",
    transform: "translate(-205.185 -447.765)",
    fill: "#f9fdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17469",
    "data-name": "Path 17469",
    d: "M203.673,455.988l57.83,31.7h-.122l-57.709-31.631Z",
    transform: "translate(-205.185 -447.618)",
    fill: "#f8fcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17470",
    "data-name": "Path 17470",
    d: "M203.673,455.774l57.952,31.764H261.5l-57.83-31.7Z",
    transform: "translate(-205.185 -447.471)",
    fill: "#f7fcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17471",
    "data-name": "Path 17471",
    d: "M203.673,455.561l58.073,31.831h-.122l-57.952-31.764Z",
    transform: "translate(-205.185 -447.324)",
    fill: "#f6fbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17472",
    "data-name": "Path 17472",
    d: "M203.673,455.347l58.195,31.9h-.122l-58.073-31.831Z",
    transform: "translate(-205.185 -447.177)",
    fill: "#f5fbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17473",
    "data-name": "Path 17473",
    d: "M203.673,455.133,261.989,487.1h-.122l-58.195-31.9Z",
    transform: "translate(-205.185 -447.03)",
    fill: "#f4fbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17474",
    "data-name": "Path 17474",
    d: "M203.673,454.919l58.438,32.031h-.122l-58.317-31.964Z",
    transform: "translate(-205.185 -446.883)",
    fill: "#f3faff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17475",
    "data-name": "Path 17475",
    d: "M203.673,454.706l58.56,32.1h-.122l-58.438-32.03Z",
    transform: "translate(-205.185 -446.736)",
    fill: "#f2faff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17476",
    "data-name": "Path 17476",
    d: "M203.673,454.492l58.682,32.164h-.122l-58.56-32.1Z",
    transform: "translate(-205.185 -446.588)",
    fill: "#f1f9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17477",
    "data-name": "Path 17477",
    d: "M203.673,454.278l58.8,32.231h-.122l-58.682-32.164Z",
    transform: "translate(-205.185 -446.441)",
    fill: "#f0f9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17478",
    "data-name": "Path 17478",
    d: "M203.673,454.065l58.925,32.3h-.122l-58.8-32.23Z",
    transform: "translate(-205.185 -446.294)",
    fill: "#eff9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17479",
    "data-name": "Path 17479",
    d: "M203.673,453.851l59.046,32.364H262.6l-58.925-32.3Z",
    transform: "translate(-205.185 -446.147)",
    fill: "#eef8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17480",
    "data-name": "Path 17480",
    d: "M203.673,453.637l59.168,32.431h-.122L203.673,453.7Z",
    transform: "translate(-205.185 -446)",
    fill: "#edf8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17481",
    "data-name": "Path 17481",
    d: "M203.673,453.423l59.29,32.5h-.122L203.673,453.49Z",
    transform: "translate(-205.185 -445.853)",
    fill: "#ecf7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17482",
    "data-name": "Path 17482",
    d: "M203.673,453.21l59.411,32.564h-.122l-59.29-32.5Z",
    transform: "translate(-205.185 -445.706)",
    fill: "#ebf7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17483",
    "data-name": "Path 17483",
    d: "M203.673,453l59.533,32.631h-.122l-59.411-32.564Z",
    transform: "translate(-205.185 -445.559)",
    fill: "#eaf7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17484",
    "data-name": "Path 17484",
    d: "M203.673,452.782l59.655,32.7h-.122l-59.533-32.631Z",
    transform: "translate(-205.185 -445.412)",
    fill: "#e9f6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17485",
    "data-name": "Path 17485",
    d: "M203.673,452.569l59.776,32.764h-.122l-59.655-32.7Z",
    transform: "translate(-205.185 -445.265)",
    fill: "#e8f6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17486",
    "data-name": "Path 17486",
    d: "M203.673,452.355l59.9,32.831h-.122l-59.776-32.764Z",
    transform: "translate(-205.185 -445.118)",
    fill: "#e7f5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17487",
    "data-name": "Path 17487",
    d: "M203.673,452.141l60.019,32.9h-.121l-59.9-32.831Z",
    transform: "translate(-205.185 -444.971)",
    fill: "#e6f5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17488",
    "data-name": "Path 17488",
    d: "M203.673,451.927l60.141,32.964h-.122l-60.019-32.9Z",
    transform: "translate(-205.185 -444.824)",
    fill: "#e5f5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17489",
    "data-name": "Path 17489",
    d: "M203.673,451.714l60.262,33.03h-.122l-60.141-32.964Z",
    transform: "translate(-205.185 -444.677)",
    fill: "#e4f4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17490",
    "data-name": "Path 17490",
    d: "M203.673,451.5l60.384,33.1h-.122l-60.262-33.03Z",
    transform: "translate(-205.185 -444.53)",
    fill: "#e3f4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17491",
    "data-name": "Path 17491",
    d: "M203.673,451.286l60.506,33.164h-.122l-60.384-33.1Z",
    transform: "translate(-205.185 -444.383)",
    fill: "#e2f3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17492",
    "data-name": "Path 17492",
    d: "M203.673,451.073,264.3,484.3h-.122l-60.506-33.164Z",
    transform: "translate(-205.185 -444.236)",
    fill: "#e1f3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17493",
    "data-name": "Path 17493",
    d: "M203.673,450.859l60.749,33.3H264.3l-60.627-33.23Z",
    transform: "translate(-205.185 -444.088)",
    fill: "#e0f3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17494",
    "data-name": "Path 17494",
    d: "M203.673,450.645l60.871,33.364h-.122l-60.749-33.3Z",
    transform: "translate(-205.185 -443.941)",
    fill: "#dff2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17495",
    "data-name": "Path 17495",
    d: "M203.673,450.431l60.992,33.431h-.122L203.673,450.5Z",
    transform: "translate(-205.185 -443.794)",
    fill: "#def2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17496",
    "data-name": "Path 17496",
    d: "M203.673,450.218l61.114,33.5h-.122l-60.992-33.43Z",
    transform: "translate(-205.185 -443.647)",
    fill: "#ddf1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17497",
    "data-name": "Path 17497",
    d: "M203.673,450l61.236,33.564h-.122l-61.114-33.5Z",
    transform: "translate(-205.185 -443.5)",
    fill: "#dcf1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17498",
    "data-name": "Path 17498",
    d: "M203.673,449.79l61.357,33.631h-.122l-61.236-33.564Z",
    transform: "translate(-205.185 -443.353)",
    fill: "#dbf1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17499",
    "data-name": "Path 17499",
    d: "M203.673,449.577l61.479,33.7h-.122l-61.357-33.63Z",
    transform: "translate(-205.185 -443.206)",
    fill: "#daf0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17500",
    "data-name": "Path 17500",
    d: "M203.673,449.363l61.6,33.764h-.122l-61.479-33.7Z",
    transform: "translate(-205.185 -443.059)",
    fill: "#d9f0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17501",
    "data-name": "Path 17501",
    d: "M203.673,449.149l61.722,33.831h-.122l-61.6-33.764Z",
    transform: "translate(-205.185 -442.912)",
    fill: "#d8efff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17502",
    "data-name": "Path 17502",
    d: "M203.673,448.935l61.844,33.9h-.122L203.673,449Z",
    transform: "translate(-205.185 -442.765)",
    fill: "#d7efff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17503",
    "data-name": "Path 17503",
    d: "M203.673,448.722l61.965,33.964h-.122l-61.844-33.9Z",
    transform: "translate(-205.185 -442.618)",
    fill: "#d6efff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17504",
    "data-name": "Path 17504",
    d: "M203.673,448.508l62.087,34.03h-.121l-61.965-33.964Z",
    transform: "translate(-205.185 -442.471)",
    fill: "#d5eeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17505",
    "data-name": "Path 17505",
    d: "M203.673,448.294l62.208,34.1h-.122l-62.087-34.031Z",
    transform: "translate(-205.185 -442.324)",
    fill: "#d4eeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17506",
    "data-name": "Path 17506",
    d: "M203.673,448.081,266,482.245h-.122l-62.208-34.1Z",
    transform: "translate(-205.185 -442.177)",
    fill: "#d3edff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17507",
    "data-name": "Path 17507",
    d: "M203.673,447.867l62.452,34.23H266l-62.33-34.164Z",
    transform: "translate(-205.185 -442.03)",
    fill: "#d2edff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17508",
    "data-name": "Path 17508",
    d: "M203.673,447.653l62.573,34.3h-.122l-62.452-34.23Z",
    transform: "translate(-205.185 -441.883)",
    fill: "#d1edff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17509",
    "data-name": "Path 17509",
    d: "M203.673,447.439,266.367,481.8h-.122l-62.573-34.3Z",
    transform: "translate(-205.185 -441.736)",
    fill: "#d0ecff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17510",
    "data-name": "Path 17510",
    d: "M203.673,447.226l62.817,34.43h-.122l-62.695-34.364Z",
    transform: "translate(-205.185 -441.589)",
    fill: "#cfecff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17511",
    "data-name": "Path 17511",
    d: "M203.673,447.012l62.938,34.5h-.122l-62.817-34.43Z",
    transform: "translate(-205.185 -441.441)",
    fill: "#ceebff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17512",
    "data-name": "Path 17512",
    d: "M203.673,446.8l63.06,34.564h-.122l-62.938-34.5Z",
    transform: "translate(-205.185 -441.294)",
    fill: "#cdebff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17513",
    "data-name": "Path 17513",
    d: "M203.673,446.584l63.182,34.631h-.122l-63.06-34.564Z",
    transform: "translate(-205.185 -441.147)",
    fill: "#ccebff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17514",
    "data-name": "Path 17514",
    d: "M203.673,446.371l63.3,34.7h-.122l-63.182-34.63Z",
    transform: "translate(-205.185 -441)",
    fill: "#cbeaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17515",
    "data-name": "Path 17515",
    d: "M203.673,446.157,267.1,480.921h-.122l-63.3-34.7Z",
    transform: "translate(-205.185 -440.853)",
    fill: "#caeaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17516",
    "data-name": "Path 17516",
    d: "M203.673,445.943l63.546,34.831H267.1L203.673,446.01Z",
    transform: "translate(-205.185 -440.706)",
    fill: "#c9e9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17517",
    "data-name": "Path 17517",
    d: "M203.673,445.73l63.668,34.9h-.122L203.673,445.8Z",
    transform: "translate(-205.185 -440.559)",
    fill: "#c8e9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17518",
    "data-name": "Path 17518",
    d: "M203.673,445.516l63.79,34.964h-.122l-63.668-34.9Z",
    transform: "translate(-205.185 -440.412)",
    fill: "#c7e9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17519",
    "data-name": "Path 17519",
    d: "M203.673,445.306v0l63.91,35.03h-.122l-63.79-34.964Z",
    transform: "translate(-205.185 -440.267)",
    fill: "#c6e8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17520",
    "data-name": "Path 17520",
    d: "M203.676,445.193l.029-.051,64,35.08h-.121Z",
    transform: "translate(-205.187 -440.155)",
    fill: "#c5e8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17521",
    "data-name": "Path 17521",
    d: "M203.767,445.03l.029-.051,64.1,35.131h-.122Z",
    transform: "translate(-205.249 -440.043)",
    fill: "#c4e7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17522",
    "data-name": "Path 17522",
    d: "M203.858,444.868l.029-.051L268.075,480h-.122Z",
    transform: "translate(-205.311 -439.931)",
    fill: "#c3e7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17523",
    "data-name": "Path 17523",
    d: "M203.949,444.705l.029-.051,64.28,35.232h-.122Z",
    transform: "translate(-205.373 -439.82)",
    fill: "#c2e7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17524",
    "data-name": "Path 17524",
    d: "M204.041,444.543l.029-.051,64.372,35.283h-.122Z",
    transform: "translate(-205.435 -439.708)",
    fill: "#c1e6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17525",
    "data-name": "Path 17525",
    d: "M204.132,444.381l.029-.051,64.465,35.334H268.5Z",
    transform: "translate(-205.497 -439.596)",
    fill: "#c0e6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17526",
    "data-name": "Path 17526",
    d: "M204.223,444.218l.029-.051,64.557,35.384h-.122Z",
    transform: "translate(-205.559 -439.485)",
    fill: "#bfe5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17527",
    "data-name": "Path 17527",
    d: "M204.315,444.056l.029-.051,64.65,35.435h-.122Z",
    transform: "translate(-205.622 -439.373)",
    fill: "#bee5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17528",
    "data-name": "Path 17528",
    d: "M204.406,443.894l.029-.051,64.742,35.486h-.121Z",
    transform: "translate(-205.684 -439.261)",
    fill: "#bde4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17529",
    "data-name": "Path 17529",
    d: "M204.5,443.731l.029-.051,64.834,35.536h-.122Z",
    transform: "translate(-205.746 -439.149)",
    fill: "#bce4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17530",
    "data-name": "Path 17530",
    d: "M204.589,443.569l.029-.051,64.927,35.587h-.122Z",
    transform: "translate(-205.808 -439.038)",
    fill: "#bbe4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17531",
    "data-name": "Path 17531",
    d: "M204.68,443.407l.029-.051,65.019,35.637h-.122Z",
    transform: "translate(-205.87 -438.926)",
    fill: "#bae3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17532",
    "data-name": "Path 17532",
    d: "M204.771,443.244l.029-.051,65.111,35.688h-.122Z",
    transform: "translate(-205.932 -438.814)",
    fill: "#b9e3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17533",
    "data-name": "Path 17533",
    d: "M204.863,443.082l.029-.051,65.2,35.739h-.122Z",
    transform: "translate(-205.994 -438.703)",
    fill: "#b8e2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17534",
    "data-name": "Path 17534",
    d: "M204.954,442.92l.029-.051,65.3,35.789h-.122Z",
    transform: "translate(-206.056 -438.591)",
    fill: "#b7e2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17535",
    "data-name": "Path 17535",
    d: "M205.045,442.757l.029-.051,65.389,35.84h-.122Z",
    transform: "translate(-206.118 -438.479)",
    fill: "#b6e2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17536",
    "data-name": "Path 17536",
    d: "M205.137,442.595l.029-.051,65.481,35.891h-.122Z",
    transform: "translate(-206.18 -438.367)",
    fill: "#b5e1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17537",
    "data-name": "Path 17537",
    d: "M205.228,442.433l.029-.051,65.573,35.941h-.122Z",
    transform: "translate(-206.242 -438.256)",
    fill: "#b4e1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17538",
    "data-name": "Path 17538",
    d: "M205.319,442.27l.029-.051,65.666,35.992h-.122Z",
    transform: "translate(-206.304 -438.144)",
    fill: "#b3e0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17539",
    "data-name": "Path 17539",
    d: "M205.411,442.108l.029-.051L271.2,478.1h-.122Z",
    transform: "translate(-206.367 -438.032)",
    fill: "#b2e0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17540",
    "data-name": "Path 17540",
    d: "M205.5,441.945l.029-.051,65.851,36.093h-.122Z",
    transform: "translate(-206.429 -437.921)",
    fill: "#b1e0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17541",
    "data-name": "Path 17541",
    d: "M205.593,441.783l.029-.051,65.943,36.144h-.122Z",
    transform: "translate(-206.491 -437.809)",
    fill: "#b0dfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17542",
    "data-name": "Path 17542",
    d: "M205.685,441.621l.029-.051,66.035,36.195h-.122Z",
    transform: "translate(-206.553 -437.697)",
    fill: "#afdfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17543",
    "data-name": "Path 17543",
    d: "M205.776,441.458l.029-.051,66.128,36.245h-.122Z",
    transform: "translate(-206.615 -437.585)",
    fill: "#aedeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17544",
    "data-name": "Path 17544",
    d: "M205.867,441.3l.029-.051,66.22,36.3h-.122Z",
    transform: "translate(-206.677 -437.474)",
    fill: "#addeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17545",
    "data-name": "Path 17545",
    d: "M205.959,441.134l.029-.051L272.3,477.43h-.122Z",
    transform: "translate(-206.739 -437.362)",
    fill: "#acdeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17546",
    "data-name": "Path 17546",
    d: "M206.05,440.971l.029-.051,66.405,36.4h-.122Z",
    transform: "translate(-206.801 -437.25)",
    fill: "#abddff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17547",
    "data-name": "Path 17547",
    d: "M206.141,440.809l.029-.051,66.5,36.448h-.122Z",
    transform: "translate(-206.863 -437.139)",
    fill: "#adf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17548",
    "data-name": "Path 17548",
    d: "M206.232,440.647l.029-.051,66.59,36.5h-.122Z",
    transform: "translate(-206.925 -437.027)",
    fill: "#a9dcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17549",
    "data-name": "Path 17549",
    d: "M206.324,440.484l.029-.051,66.682,36.549h-.121Z",
    transform: "translate(-206.988 -436.915)",
    fill: "#a8dcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17550",
    "data-name": "Path 17550",
    d: "M206.415,440.322l.029-.051,66.774,36.6H273.1Z",
    transform: "translate(-207.05 -436.803)",
    fill: "#a7dcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17551",
    "data-name": "Path 17551",
    d: "M206.507,440.16l.029-.051,66.867,36.65h-.122Z",
    transform: "translate(-207.112 -436.692)",
    fill: "#a6dbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17552",
    "data-name": "Path 17552",
    d: "M206.6,440l.029-.051,66.959,36.7h-.122Z",
    transform: "translate(-207.174 -436.58)",
    fill: "#a5dbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17553",
    "data-name": "Path 17553",
    d: "M206.689,439.835l.029-.051,67.052,36.752h-.122Z",
    transform: "translate(-207.236 -436.468)",
    fill: "#a4daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17554",
    "data-name": "Path 17554",
    d: "M206.78,439.673l.029-.051,67.144,36.8h-.122Z",
    transform: "translate(-207.298 -436.357)",
    fill: "#a3daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17555",
    "data-name": "Path 17555",
    d: "M206.872,439.51l.029-.051,67.236,36.853h-.122Z",
    transform: "translate(-207.36 -436.245)",
    fill: "#a2daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17556",
    "data-name": "Path 17556",
    d: "M206.963,439.348l.029-.051,67.329,36.9H274.2Z",
    transform: "translate(-207.422 -436.133)",
    fill: "#a1d9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17557",
    "data-name": "Path 17557",
    d: "M207.054,439.186l.029-.051L274.5,476.089h-.121Z",
    transform: "translate(-207.484 -436.022)",
    fill: "#a0d9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17558",
    "data-name": "Path 17558",
    d: "M207.146,439.023l.029-.051,67.514,37h-.122Z",
    transform: "translate(-207.546 -435.91)",
    fill: "#9fd8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17559",
    "data-name": "Path 17559",
    d: "M207.237,438.861l.029-.051,67.606,37.055h-.122Z",
    transform: "translate(-207.608 -435.798)",
    fill: "#9ed8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17560",
    "data-name": "Path 17560",
    d: "M207.328,438.7l.029-.051,67.7,37.106h-.122Z",
    transform: "translate(-207.67 -435.686)",
    fill: "#9dd8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17561",
    "data-name": "Path 17561",
    d: "M207.42,438.536l.029-.051,67.791,37.156h-.122Z",
    transform: "translate(-207.733 -435.575)",
    fill: "#9cd7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17562",
    "data-name": "Path 17562",
    d: "M207.511,438.374l.029-.051,67.883,37.207H275.3Z",
    transform: "translate(-207.795 -435.463)",
    fill: "#9bd7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17563",
    "data-name": "Path 17563",
    d: "M207.6,438.211l.029-.051,67.975,37.258h-.122Z",
    transform: "translate(-207.857 -435.351)",
    fill: "#9ad6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17564",
    "data-name": "Path 17564",
    d: "M207.694,438.049l.029-.051,68.068,37.308h-.122Z",
    transform: "translate(-207.919 -435.24)",
    fill: "#99d6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17565",
    "data-name": "Path 17565",
    d: "M207.785,437.887l.029-.051,68.16,37.359h-.122Z",
    transform: "translate(-207.981 -435.128)",
    fill: "#98d6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17566",
    "data-name": "Path 17566",
    d: "M207.876,437.724l.029-.051,68.253,37.41h-.122Z",
    transform: "translate(-208.043 -435.016)",
    fill: "#97d5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17567",
    "data-name": "Path 17567",
    d: "M207.968,437.562l.029-.051,68.345,37.461h-.122Z",
    transform: "translate(-208.105 -434.904)",
    fill: "#96d5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17568",
    "data-name": "Path 17568",
    d: "M208.059,437.4l.029-.051,68.437,37.511H276.4Z",
    transform: "translate(-208.167 -434.793)",
    fill: "#95d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17569",
    "data-name": "Path 17569",
    d: "M208.15,437.237l.029-.051,68.53,37.562h-.122Z",
    transform: "translate(-208.229 -434.681)",
    fill: "#94d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17570",
    "data-name": "Path 17570",
    d: "M208.242,437.075l.029-.051,68.622,37.613h-.122Z",
    transform: "translate(-208.291 -434.569)",
    fill: "#93d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17571",
    "data-name": "Path 17571",
    d: "M208.333,436.913l.029-.051,68.715,37.663h-.122Z",
    transform: "translate(-208.353 -434.458)",
    fill: "#92d3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17572",
    "data-name": "Path 17572",
    d: "M208.424,436.75l.029-.051,68.807,37.714h-.122Z",
    transform: "translate(-208.416 -434.346)",
    fill: "#91d3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17573",
    "data-name": "Path 17573",
    d: "M208.516,436.588l.029-.051,68.9,37.764h-.122Z",
    transform: "translate(-208.478 -434.234)",
    fill: "#90d2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17574",
    "data-name": "Path 17574",
    d: "M208.607,436.426l.029-.051,68.992,37.815h-.122Z",
    transform: "translate(-208.54 -434.122)",
    fill: "#8fd2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17575",
    "data-name": "Path 17575",
    d: "M208.7,436.263l.029-.051,69.084,37.865h-.122Z",
    transform: "translate(-208.602 -434.011)",
    fill: "#8ed2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17576",
    "data-name": "Path 17576",
    d: "M208.789,436.1l.029-.051L278,473.967h-.122Z",
    transform: "translate(-208.664 -433.899)",
    fill: "#8dd1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17577",
    "data-name": "Path 17577",
    d: "M208.881,435.939l.029-.051,69.269,37.967h-.122Z",
    transform: "translate(-208.726 -433.787)",
    fill: "#8cd1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17578",
    "data-name": "Path 17578",
    d: "M208.972,435.776l.029-.051,69.361,38.017h-.121Z",
    transform: "translate(-208.788 -433.676)",
    fill: "#8bd0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17579",
    "data-name": "Path 17579",
    d: "M209.064,435.614l.029-.051,69.454,38.068h-.122Z",
    transform: "translate(-208.85 -433.564)",
    fill: "#8ad0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17580",
    "data-name": "Path 17580",
    d: "M209.155,435.452l.029-.051L278.73,473.52h-.122Z",
    transform: "translate(-208.912 -433.452)",
    fill: "#89d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17581",
    "data-name": "Path 17581",
    d: "M209.246,435.289l.029-.051,69.638,38.169h-.122Z",
    transform: "translate(-208.974 -433.341)",
    fill: "#88cfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17582",
    "data-name": "Path 17582",
    d: "M209.337,435.127l.029-.051L279.1,473.3h-.122Z",
    transform: "translate(-209.036 -433.229)",
    fill: "#87cfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17583",
    "data-name": "Path 17583",
    d: "M209.429,434.965l.029-.051,69.823,38.271h-.122Z",
    transform: "translate(-209.099 -433.117)",
    fill: "#86ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17584",
    "data-name": "Path 17584",
    d: "M209.52,434.8l.029-.051,69.869,38.3-.015.026h-.06Z",
    transform: "translate(-209.161 -433.005)",
    fill: "#85ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18162",
    "data-name": "Path 18162",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.377, 1.767)",
    fill: "#84ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18163",
    "data-name": "Path 18163",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.406, 1.716)",
    fill: "#83cdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18164",
    "data-name": "Path 18164",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.435, 1.666)",
    fill: "#82cdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18165",
    "data-name": "Path 18165",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.464, 1.615)",
    fill: "#81ccff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18166",
    "data-name": "Path 18166",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.494, 1.564)",
    fill: "#80ccff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18167",
    "data-name": "Path 18167",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.523, 1.514)",
    fill: "#7eccff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18168",
    "data-name": "Path 18168",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.552, 1.463)",
    fill: "#7dcbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18169",
    "data-name": "Path 18169",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.581, 1.412)",
    fill: "#7ccbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18170",
    "data-name": "Path 18170",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.611, 1.362)",
    fill: "#7bcaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18171",
    "data-name": "Path 18171",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.64, 1.311)",
    fill: "#7acaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18172",
    "data-name": "Path 18172",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.669, 1.26)",
    fill: "#79caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18173",
    "data-name": "Path 18173",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.698, 1.21)",
    fill: "#78c9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18174",
    "data-name": "Path 18174",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.728, 1.159)",
    fill: "#77c9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18175",
    "data-name": "Path 18175",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.757, 1.109)",
    fill: "#76c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18176",
    "data-name": "Path 18176",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.786, 1.058)",
    fill: "#75c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18177",
    "data-name": "Path 18177",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.815, 1.007)",
    fill: "#74c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18178",
    "data-name": "Path 18178",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.845, 0.957)",
    fill: "#73c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18179",
    "data-name": "Path 18179",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.874, 0.906)",
    fill: "#72c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18180",
    "data-name": "Path 18180",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.903, 0.855)",
    fill: "#71c6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18181",
    "data-name": "Path 18181",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.932, 0.805)",
    fill: "#70c6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18182",
    "data-name": "Path 18182",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.961, 0.754)",
    fill: "#6fc6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18183",
    "data-name": "Path 18183",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 0.991, 0.703)",
    fill: "#6ec5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18184",
    "data-name": "Path 18184",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.02, 0.653)",
    fill: "#6dc5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18185",
    "data-name": "Path 18185",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.049, 0.602)",
    fill: "#6cc4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18186",
    "data-name": "Path 18186",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.078, 0.552)",
    fill: "#6bc4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18187",
    "data-name": "Path 18187",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.108, 0.501)",
    fill: "#6ac4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18188",
    "data-name": "Path 18188",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.137, 0.45)",
    fill: "#69c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18189",
    "data-name": "Path 18189",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.166, 0.4)",
    fill: "#68c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18190",
    "data-name": "Path 18190",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.195, 0.349)",
    fill: "#67c2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18191",
    "data-name": "Path 18191",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.225, 0.298)",
    fill: "#66c2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18192",
    "data-name": "Path 18192",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.254, 0.248)",
    fill: "#65c2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18193",
    "data-name": "Path 18193",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.283, 0.197)",
    fill: "#64c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18194",
    "data-name": "Path 18194",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.312, 0.146)",
    fill: "#63c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18195",
    "data-name": "Path 18195",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.341, 0.096)",
    fill: "#62c0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18196",
    "data-name": "Path 18196",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.371, 0.045)",
    fill: "#61c0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18197",
    "data-name": "Path 18197",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.4, -0.006)",
    fill: "#60c0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18198",
    "data-name": "Path 18198",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.429, -0.056)",
    fill: "#5fbfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18199",
    "data-name": "Path 18199",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.458, -0.107)",
    fill: "#5ebfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18200",
    "data-name": "Path 18200",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.488, -0.157)",
    fill: "#5dbeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18201",
    "data-name": "Path 18201",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.517, -0.208)",
    fill: "#5cbeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18202",
    "data-name": "Path 18202",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.546, -0.259)",
    fill: "#5bbeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18203",
    "data-name": "Path 18203",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.575, -0.309)",
    fill: "#5abdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18204",
    "data-name": "Path 18204",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.605, -0.36)",
    fill: "#59bdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18205",
    "data-name": "Path 18205",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.634, -0.411)",
    fill: "#58bcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18206",
    "data-name": "Path 18206",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.663, -0.461)",
    fill: "#57bcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18207",
    "data-name": "Path 18207",
    d: "M0,0H.059L.934,79.672H.876Z",
    transform: "matrix(0.49, -0.872, 0.872, 0.49, 1.692, -0.512)",
    fill: "#56bcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17585",
    "data-name": "Path 17585",
    d: "M213.812,427.221l.016-.028h.054l69.828,38.273-.029.051Z",
    transform: "translate(-212.079 -427.805)",
    fill: "#5bf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17586",
    "data-name": "Path 17586",
    d: "M214.153,427.193l69.735,38.222-.029.051-69.827-38.273Z",
    transform: "translate(-212.228 -427.804)",
    fill: "#54bbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17587",
    "data-name": "Path 17587",
    d: "M214.533,427.193l69.643,38.172-.029.051-69.735-38.222Z",
    transform: "translate(-212.486 -427.804)",
    fill: "#53baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17588",
    "data-name": "Path 17588",
    d: "M214.913,427.193l69.55,38.121-.029.051-69.643-38.172Z",
    transform: "translate(-212.745 -427.804)",
    fill: "#52baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17589",
    "data-name": "Path 17589",
    d: "M215.293,427.193l69.458,38.07-.029.051-69.55-38.121Z",
    transform: "translate(-213.003 -427.804)",
    fill: "#51baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17590",
    "data-name": "Path 17590",
    d: "M215.673,427.193l69.365,38.02-.029.051-69.458-38.07Z",
    transform: "translate(-213.261 -427.804)",
    fill: "#50b9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17591",
    "data-name": "Path 17591",
    d: "M216.053,427.193l69.273,37.969-.029.051-69.365-38.02Z",
    transform: "translate(-213.519 -427.804)",
    fill: "#4fb9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17592",
    "data-name": "Path 17592",
    d: "M216.433,427.193l69.181,37.919-.029.051-69.273-37.969Z",
    transform: "translate(-213.778 -427.804)",
    fill: "#4eb8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17593",
    "data-name": "Path 17593",
    d: "M216.813,427.193,285.9,465.061l-.029.051-69.181-37.919Z",
    transform: "translate(-214.036 -427.804)",
    fill: "#4db8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17594",
    "data-name": "Path 17594",
    d: "M217.193,427.193l69,37.817-.029.051-69.088-37.868Z",
    transform: "translate(-214.294 -427.804)",
    fill: "#4cb8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17595",
    "data-name": "Path 17595",
    d: "M217.573,427.193l68.9,37.767-.029.051-69-37.817Z",
    transform: "translate(-214.553 -427.804)",
    fill: "#4bb7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17596",
    "data-name": "Path 17596",
    d: "M217.953,427.193l68.811,37.716-.029.051-68.9-37.767Z",
    transform: "translate(-214.811 -427.804)",
    fill: "#4ab7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17597",
    "data-name": "Path 17597",
    d: "M218.333,427.193l68.719,37.666-.029.051-68.811-37.716Z",
    transform: "translate(-215.069 -427.804)",
    fill: "#49b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17598",
    "data-name": "Path 17598",
    d: "M218.712,427.193l68.626,37.615-.029.051-68.719-37.666Z",
    transform: "translate(-215.328 -427.804)",
    fill: "#48b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17599",
    "data-name": "Path 17599",
    d: "M219.092,427.193l68.534,37.564-.029.051-68.626-37.615Z",
    transform: "translate(-215.586 -427.804)",
    fill: "#47b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17600",
    "data-name": "Path 17600",
    d: "M219.472,427.193l68.442,37.514-.029.051-68.534-37.564Z",
    transform: "translate(-215.844 -427.804)",
    fill: "#46b5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17601",
    "data-name": "Path 17601",
    d: "M219.852,427.193,288.2,464.656l-.029.051-68.442-37.514Z",
    transform: "translate(-216.103 -427.804)",
    fill: "#45b5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17602",
    "data-name": "Path 17602",
    d: "M220.232,427.193l68.257,37.412-.029.051-68.349-37.463Z",
    transform: "translate(-216.361 -427.804)",
    fill: "#44b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17603",
    "data-name": "Path 17603",
    d: "M220.612,427.193l68.164,37.361-.029.051L220.49,427.193Z",
    transform: "translate(-216.619 -427.804)",
    fill: "#43b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17604",
    "data-name": "Path 17604",
    d: "M220.992,427.193,289.064,464.5l-.029.051-68.164-37.361Z",
    transform: "translate(-216.878 -427.804)",
    fill: "#42b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17605",
    "data-name": "Path 17605",
    d: "M221.372,427.193l67.98,37.26-.029.051L221.25,427.193Z",
    transform: "translate(-217.136 -427.804)",
    fill: "#41b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17606",
    "data-name": "Path 17606",
    d: "M221.752,427.193l67.887,37.21-.029.051-67.98-37.26Z",
    transform: "translate(-217.394 -427.804)",
    fill: "#40b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17607",
    "data-name": "Path 17607",
    d: "M222.132,427.193l67.795,37.159-.029.051-67.887-37.21Z",
    transform: "translate(-217.653 -427.804)",
    fill: "#3fb2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17608",
    "data-name": "Path 17608",
    d: "M222.512,427.193l67.7,37.108-.029.051L222.39,427.193Z",
    transform: "translate(-217.911 -427.804)",
    fill: "#3eb2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17609",
    "data-name": "Path 17609",
    d: "M222.892,427.193,290.5,464.25l-.029.051-67.7-37.108Z",
    transform: "translate(-218.169 -427.804)",
    fill: "#3db1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17610",
    "data-name": "Path 17610",
    d: "M223.272,427.193,290.789,464.2l-.029.051-67.61-37.058Z",
    transform: "translate(-218.428 -427.804)",
    fill: "#3cb1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17611",
    "data-name": "Path 17611",
    d: "M223.652,427.193l67.425,36.957-.029.051L223.53,427.193Z",
    transform: "translate(-218.686 -427.804)",
    fill: "#3bb1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17612",
    "data-name": "Path 17612",
    d: "M224.032,427.193,291.365,464.1l-.029.051L223.91,427.193Z",
    transform: "translate(-218.944 -427.804)",
    fill: "#3ab0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17613",
    "data-name": "Path 17613",
    d: "M224.412,427.193l67.24,36.855-.029.051L224.29,427.193Z",
    transform: "translate(-219.202 -427.804)",
    fill: "#39b0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17614",
    "data-name": "Path 17614",
    d: "M224.792,427.193l67.132,36.8v.036l-.013.023L224.67,427.193Z",
    transform: "translate(-219.461 -427.804)",
    fill: "#38afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17615",
    "data-name": "Path 17615",
    d: "M225.171,427.193l67.011,36.729v.067l-67.132-36.8Z",
    transform: "translate(-219.719 -427.804)",
    fill: "#37afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17616",
    "data-name": "Path 17616",
    d: "M225.551,427.193l66.889,36.662v.067L225.43,427.193Z",
    transform: "translate(-219.977 -427.804)",
    fill: "#36afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17617",
    "data-name": "Path 17617",
    d: "M225.931,427.193l66.767,36.6v.066L225.81,427.193Z",
    transform: "translate(-220.236 -427.804)",
    fill: "#35aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17618",
    "data-name": "Path 17618",
    d: "M226.311,427.193l66.646,36.529v.067l-66.767-36.6Z",
    transform: "translate(-220.494 -427.804)",
    fill: "#34aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17619",
    "data-name": "Path 17619",
    d: "M226.691,427.193l66.524,36.462v.067L226.57,427.193Z",
    transform: "translate(-220.752 -427.804)",
    fill: "#33adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17620",
    "data-name": "Path 17620",
    d: "M227.071,427.193l66.4,36.4v.067l-66.524-36.462Z",
    transform: "translate(-221.011 -427.804)",
    fill: "#32adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17621",
    "data-name": "Path 17621",
    d: "M227.451,427.193l66.281,36.329v.066l-66.4-36.4Z",
    transform: "translate(-221.269 -427.804)",
    fill: "#31adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17622",
    "data-name": "Path 17622",
    d: "M227.831,427.193l66.159,36.263v.067l-66.281-36.329Z",
    transform: "translate(-221.527 -427.804)",
    fill: "#30acff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17623",
    "data-name": "Path 17623",
    d: "M228.211,427.193l66.038,36.2v.067l-66.159-36.263Z",
    transform: "translate(-221.786 -427.804)",
    fill: "#2facff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17624",
    "data-name": "Path 17624",
    d: "M228.591,427.193l65.916,36.129v.066l-66.038-36.2Z",
    transform: "translate(-222.044 -427.804)",
    fill: "#2eabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17625",
    "data-name": "Path 17625",
    d: "M228.971,427.193l65.794,36.063v.067l-65.916-36.129Z",
    transform: "translate(-222.302 -427.804)",
    fill: "#2dabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17626",
    "data-name": "Path 17626",
    d: "M229.351,427.193l65.673,36v.067l-65.794-36.063Z",
    transform: "translate(-222.561 -427.804)",
    fill: "#2cabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17627",
    "data-name": "Path 17627",
    d: "M229.731,427.193l65.551,35.929v.067l-65.673-36Z",
    transform: "translate(-222.819 -427.804)",
    fill: "#2baaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17628",
    "data-name": "Path 17628",
    d: "M230.111,427.193l65.429,35.863v.066l-65.551-35.929Z",
    transform: "translate(-223.077 -427.804)",
    fill: "#2aaaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17629",
    "data-name": "Path 17629",
    d: "M230.491,427.193l65.308,35.8v.067l-65.43-35.863Z",
    transform: "translate(-223.336 -427.804)",
    fill: "#29a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17630",
    "data-name": "Path 17630",
    d: "M230.871,427.193l65.186,35.729v.067l-65.308-35.8Z",
    transform: "translate(-223.594 -427.804)",
    fill: "#28a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17631",
    "data-name": "Path 17631",
    d: "M231.251,427.193l65.065,35.663v.066l-65.186-35.729Z",
    transform: "translate(-223.852 -427.804)",
    fill: "#27a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17632",
    "data-name": "Path 17632",
    d: "M231.63,427.193l64.943,35.6v.067l-65.065-35.663Z",
    transform: "translate(-224.111 -427.804)",
    fill: "#26a8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17633",
    "data-name": "Path 17633",
    d: "M232.01,427.193l64.821,35.529v.067l-64.943-35.6Z",
    transform: "translate(-224.369 -427.804)",
    fill: "#25a8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17634",
    "data-name": "Path 17634",
    d: "M232.39,427.193l64.7,35.462v.067l-64.821-35.529Z",
    transform: "translate(-224.627 -427.804)",
    fill: "#24a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17635",
    "data-name": "Path 17635",
    d: "M232.77,427.193l64.578,35.4v.066l-64.7-35.462Z",
    transform: "translate(-224.885 -427.804)",
    fill: "#23a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17636",
    "data-name": "Path 17636",
    d: "M233.15,427.193l64.457,35.329v.067l-64.578-35.4Z",
    transform: "translate(-225.144 -427.804)",
    fill: "#22a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17637",
    "data-name": "Path 17637",
    d: "M233.53,427.193l64.335,35.263v.067l-64.457-35.329Z",
    transform: "translate(-225.402 -427.804)",
    fill: "#21a6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17638",
    "data-name": "Path 17638",
    d: "M233.91,427.193l64.213,35.2v.066l-64.335-35.263Z",
    transform: "translate(-225.661 -427.804)",
    fill: "#20a6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17639",
    "data-name": "Path 17639",
    d: "M234.29,427.193l64.092,35.129v.067l-64.213-35.2Z",
    transform: "translate(-225.919 -427.804)",
    fill: "#1fa5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17640",
    "data-name": "Path 17640",
    d: "M234.67,427.193l63.97,35.063v.067l-64.092-35.129Z",
    transform: "translate(-226.177 -427.804)",
    fill: "#1ea5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17641",
    "data-name": "Path 17641",
    d: "M235.05,427.193l63.848,35v.067l-63.97-35.063Z",
    transform: "translate(-226.435 -427.804)",
    fill: "#1da5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17642",
    "data-name": "Path 17642",
    d: "M235.43,427.193l63.727,34.929v.066l-63.848-35Z",
    transform: "translate(-226.694 -427.804)",
    fill: "#1ca4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17643",
    "data-name": "Path 17643",
    d: "M235.81,427.193l63.605,34.863v.067l-63.727-34.929Z",
    transform: "translate(-226.952 -427.804)",
    fill: "#1ba4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17644",
    "data-name": "Path 17644",
    d: "M236.19,427.193l63.483,34.8v.067l-63.605-34.863Z",
    transform: "translate(-227.21 -427.804)",
    fill: "#1aa3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17645",
    "data-name": "Path 17645",
    d: "M236.57,427.193l63.362,34.729v.066l-63.483-34.8Z",
    transform: "translate(-227.469 -427.804)",
    fill: "#19a3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17646",
    "data-name": "Path 17646",
    d: "M236.95,427.193l63.24,34.663v.067l-63.362-34.729Z",
    transform: "translate(-227.727 -427.804)",
    fill: "#18a3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17647",
    "data-name": "Path 17647",
    d: "M237.33,427.193l63.119,34.6v.067l-63.24-34.663Z",
    transform: "translate(-227.985 -427.804)",
    fill: "#17a2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17648",
    "data-name": "Path 17648",
    d: "M237.71,427.193l63,34.529v.067l-63.119-34.6Z",
    transform: "translate(-228.244 -427.804)",
    fill: "#16a2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17649",
    "data-name": "Path 17649",
    d: "M238.089,427.193l62.876,34.463v.066l-63-34.529Z",
    transform: "translate(-228.502 -427.804)",
    fill: "#15a1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17650",
    "data-name": "Path 17650",
    d: "M238.469,427.193l62.754,34.4v.067l-62.876-34.463Z",
    transform: "translate(-228.76 -427.804)",
    fill: "#14a1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17651",
    "data-name": "Path 17651",
    d: "M238.849,427.193l62.632,34.329v.067l-62.754-34.4Z",
    transform: "translate(-229.019 -427.804)",
    fill: "#13a1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17652",
    "data-name": "Path 17652",
    d: "M239.229,427.193l62.511,34.263v.067l-62.632-34.329Z",
    transform: "translate(-229.277 -427.804)",
    fill: "#12a0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17653",
    "data-name": "Path 17653",
    d: "M239.609,427.193,302,461.389v.066l-62.511-34.263Z",
    transform: "translate(-229.535 -427.804)",
    fill: "#11a0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17654",
    "data-name": "Path 17654",
    d: "M239.989,427.193l62.267,34.129v.067l-62.389-34.2Z",
    transform: "translate(-229.794 -427.804)",
    fill: "#109fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17655",
    "data-name": "Path 17655",
    d: "M240.369,427.193l62.146,34.063v.067l-62.267-34.129Z",
    transform: "translate(-230.052 -427.804)",
    fill: "#0f9fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17656",
    "data-name": "Path 17656",
    d: "M240.749,427.193l62.024,34v.066l-62.146-34.063Z",
    transform: "translate(-230.31 -427.804)",
    fill: "#0e9fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17657",
    "data-name": "Path 17657",
    d: "M241.129,427.193l61.9,33.929v.067l-62.024-34Z",
    transform: "translate(-230.569 -427.804)",
    fill: "#0d9eff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17658",
    "data-name": "Path 17658",
    d: "M241.509,427.193l61.781,33.863v.067l-61.9-33.929Z",
    transform: "translate(-230.827 -427.804)",
    fill: "#0c9eff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17659",
    "data-name": "Path 17659",
    d: "M241.889,427.193l61.659,33.8v.067l-61.781-33.863Z",
    transform: "translate(-231.085 -427.804)",
    fill: "#0b9dff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17660",
    "data-name": "Path 17660",
    d: "M242.269,427.193l61.538,33.729v.066l-61.659-33.8Z",
    transform: "translate(-231.344 -427.804)",
    fill: "#0a9dff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17661",
    "data-name": "Path 17661",
    d: "M242.649,427.193l61.416,33.663v.067l-61.537-33.729Z",
    transform: "translate(-231.602 -427.804)",
    fill: "#099dff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17662",
    "data-name": "Path 17662",
    d: "M243.029,427.193l61.294,33.6v.067l-61.416-33.663Z",
    transform: "translate(-231.86 -427.804)",
    fill: "#089cff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17663",
    "data-name": "Path 17663",
    d: "M243.409,427.193l61.173,33.53v.066l-61.295-33.6Z",
    transform: "translate(-232.118 -427.804)",
    fill: "#079cff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17664",
    "data-name": "Path 17664",
    d: "M243.789,427.193l61.051,33.463v.067l-61.173-33.53Z",
    transform: "translate(-232.377 -427.804)",
    fill: "#069bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17665",
    "data-name": "Path 17665",
    d: "M244.169,427.193l60.93,33.4v.067l-61.051-33.463Z",
    transform: "translate(-232.635 -427.804)",
    fill: "#059bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17666",
    "data-name": "Path 17666",
    d: "M244.548,427.193l60.808,33.329v.067l-60.93-33.4Z",
    transform: "translate(-232.893 -427.804)",
    fill: "#049bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17667",
    "data-name": "Path 17667",
    d: "M244.928,427.193l60.686,33.263v.066l-60.808-33.329Z",
    transform: "translate(-233.152 -427.804)",
    fill: "#039aff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17668",
    "data-name": "Path 17668",
    d: "M245.308,427.193l60.565,33.2v.067l-60.686-33.263Z",
    transform: "translate(-233.41 -427.804)",
    fill: "#029aff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17669",
    "data-name": "Path 17669",
    d: "M245.688,427.193l60.443,33.129v.067l-60.565-33.2Z",
    transform: "translate(-233.668 -427.804)",
    fill: "#0199ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17670",
    "data-name": "Path 17670",
    d: "M246.068,427.193l60.321,33.063v.066l-60.443-33.129Z",
    transform: "translate(-233.927 -427.804)",
    fill: "#09f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17671",
    "data-name": "Path 17671",
    d: "M306.648,460.255l-60.321-33.063h60.321Z",
    transform: "translate(-234.185 -427.804)",
    fill: "#09f",
    fillRule: "evenodd"
  }))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17673",
    "data-name": "Path 17673",
    d: "M286.4,28.823l-47.767-26.7c-1.738-.977-4.1-1.638-5.961-.568-1.387.786-2.779,1.651-4.209,2.448l1.995,2.75L254.223,22.5l24.006,10.95c-1.9,7.353,6.236,10.5,8.351,14.1h0l-2.515,60.344,2.316,53.347.386-.219a8.682,8.682,0,0,0,.967,3.351l4.376-2.528c1.5-.852,2.438-2.662,2.446-5.234l.2-113.69c.014-5.093-3.663-11.463-8.352-14.095",
    transform: "translate(-155.333 -0.694)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17674",
    "data-name": "Path 17674",
    d: "M286.6,164.122l-.148-.316a10.16,10.16,0,0,1-.956-2.961l-.4.228-2.338-53.863,2.511-60.278a16.092,16.092,0,0,0-3.062-3.156c-2.912-2.546-6.524-5.706-5.337-10.843L253.076,22.08l-.021-.014L229.246,6.288l-2.232-3.076.306-.171c.773-.43,1.547-.888,2.295-1.331.627-.371,1.276-.755,1.912-1.115,2.349-1.353,5.175-.054,6.281.568l47.767,26.7c4.708,2.643,8.527,9.088,8.512,14.366l-.2,113.69c-.008,2.6-.933,4.557-2.605,5.5Zm-.517-4.331.013.527a7.908,7.908,0,0,0,.793,2.912l4.067-2.349c1.47-.832,2.282-2.6,2.289-4.967l.2-113.689c.014-5.079-3.66-11.28-8.191-13.824L237.489,1.7c-1.01-.567-3.579-1.758-5.638-.57-.633.359-1.279.741-1.9,1.111-.653.387-1.327.785-2,1.168L229.7,5.835l23.693,15.7,24.222,11.048-.064.25c-1.271,4.921,2.1,7.873,5.083,10.478A15.859,15.859,0,0,1,285.87,46.7l.046.078L283.4,107.21l2.293,52.8Z",
    transform: "translate(-154.345 0)",
    fill: "#09f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17675",
    "data-name": "Path 17675",
    d: "M218.692,16.022c.015-5.177,3.778-7.272,8.405-4.668l47.768,26.7c4.623,2.6,8.366,8.918,8.351,14.1l-.2,113.69c-.015,5.177-3.783,7.269-8.407,4.668l-47.767-26.7c-4.628-2.6-8.366-8.919-8.352-14.1Z",
    transform: "translate(-148.551 -7.042)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17676",
    "data-name": "Path 17676",
    d: "M277.687,171.242a8.108,8.108,0,0,1-3.916-1.164L226,143.381c-4.71-2.649-8.528-9.094-8.513-14.367l.2-113.69c.007-2.613.938-4.571,2.62-5.514s3.917-.744,6.265.577l47.767,26.7c4.709,2.65,8.527,9.1,8.512,14.367l-.2,113.689c-.008,2.611-.939,4.569-2.621,5.512a4.745,4.745,0,0,1-2.35.589M218.332,15.326l-.2,113.69c-.015,5.073,3.66,11.275,8.191,13.824l47.766,26.7c2.142,1.2,4.14,1.409,5.627.575s2.293-2.594,2.3-4.973l.2-113.689c.015-5.073-3.66-11.275-8.191-13.825l-47.767-26.7c-2.143-1.206-4.141-1.41-5.627-.577s-2.293,2.595-2.3,4.975Z",
    transform: "translate(-147.871 -6.345)",
    fill: "#09f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17677",
    "data-name": "Path 17677",
    d: "M232.275,45.349c.013-4.426,3.23-6.217,7.187-3.991L280.3,64.183c3.952,2.224,7.153,7.625,7.14,12.051l-.17,47.237c-.013,4.426-3.234,6.215-7.187,3.991l-40.839-22.825c-3.957-2.226-7.153-7.625-7.141-12.051Z",
    transform: "translate(-157.806 -27.799)",
    fill: "#09f",
    fillRule: "evenodd",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11698",
    "data-name": "Group 11698",
    transform: "translate(73.901 79.587)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11697",
    "data-name": "Group 11697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11696",
    "data-name": "Group 11696",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17678",
    "data-name": "Path 17678",
    d: "M231.039,260.189c.013-4.5,3.287-6.327,7.313-4.061l41.557,23.226c4.022,2.263,7.278,7.759,7.265,12.263L287,302.835c-.013,4.5-3.291,6.324-7.313,4.061L238.13,283.67c-4.027-2.265-7.279-7.759-7.265-12.263Z",
    transform: "translate(-230.865 -255.154)",
    fill: "#09f",
    fillRule: "evenodd"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17679",
    "data-name": "Path 17679",
    d: "M147.814,95.345c.012-4.331,3.16-6.083,7.031-3.9L194.8,113.772c3.867,2.176,7,7.46,6.985,11.791l-.166,30.694c-.012,4.33-3.164,6.081-7.032,3.9l-40.818-22.611a11.33,11.33,0,0,1-6.125-10.112Z",
    transform: "translate(-92.051 -65.608)",
    fill: "#201f5d",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17680",
    "data-name": "Path 17680",
    d: "M213.4,174.84l.015,14.41,12.758,1.017Z",
    transform: "translate(-136.756 -123.638)",
    fill: "#00dcff",
    fillRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11703",
    "data-name": "Group 11703",
    transform: "translate(0 145.973)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11702",
    "data-name": "Group 11702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11701",
    "data-name": "Group 11701",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11700",
    "data-name": "Group 11700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11699",
    "data-name": "Group 11699",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17681",
    "data-name": "Path 17681",
    d: "M0,485.609l8.753-4.45,6.761,12.628-.428.218H0Z",
    transform: "translate(0 -477.051)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18208",
    "data-name": "Path 18208",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(8.751 4.11) rotate(-27.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18209",
    "data-name": "Path 18209",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(8.837 4.066) rotate(-27.573)",
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18210",
    "data-name": "Path 18210",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(8.924 4.022) rotate(-27.573)",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18211",
    "data-name": "Path 18211",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.01 3.978) rotate(-27.573)",
    fill: "#fcfeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18212",
    "data-name": "Path 18212",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.097 3.934) rotate(-27.573)",
    fill: "#fbfdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18213",
    "data-name": "Path 18213",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.183 3.89) rotate(-27.573)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18214",
    "data-name": "Path 18214",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.27 3.846) rotate(-27.573)",
    fill: "#f9fdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18215",
    "data-name": "Path 18215",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.356 3.802) rotate(-27.573)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18216",
    "data-name": "Path 18216",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.443 3.758) rotate(-27.573)",
    fill: "#f7fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18217",
    "data-name": "Path 18217",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.529 3.714) rotate(-27.573)",
    fill: "#f6fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18218",
    "data-name": "Path 18218",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.616 3.67) rotate(-27.573)",
    fill: "#f5fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18219",
    "data-name": "Path 18219",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.702 3.626) rotate(-27.573)",
    fill: "#f4fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18220",
    "data-name": "Path 18220",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.789 3.582) rotate(-27.573)",
    fill: "#f3faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18221",
    "data-name": "Path 18221",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.875 3.538) rotate(-27.573)",
    fill: "#f2faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18222",
    "data-name": "Path 18222",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(9.962 3.494) rotate(-27.573)",
    fill: "#f1f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18223",
    "data-name": "Path 18223",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.048 3.45) rotate(-27.573)",
    fill: "#f0f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18224",
    "data-name": "Path 18224",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.135 3.406) rotate(-27.573)",
    fill: "#eff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18225",
    "data-name": "Path 18225",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.221 3.362) rotate(-27.573)",
    fill: "#eef8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18226",
    "data-name": "Path 18226",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.308 3.318) rotate(-27.573)",
    fill: "#edf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18227",
    "data-name": "Path 18227",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.394 3.274) rotate(-27.573)",
    fill: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18228",
    "data-name": "Path 18228",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.48 3.23) rotate(-27.573)",
    fill: "#ebf7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18229",
    "data-name": "Path 18229",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.567 3.186) rotate(-27.573)",
    fill: "#eaf7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18230",
    "data-name": "Path 18230",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.654 3.142) rotate(-27.573)",
    fill: "#e9f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18231",
    "data-name": "Path 18231",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.74 3.098) rotate(-27.573)",
    fill: "#e8f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18232",
    "data-name": "Path 18232",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.826 3.054) rotate(-27.573)",
    fill: "#e7f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18233",
    "data-name": "Path 18233",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(10.913 3.011) rotate(-27.573)",
    fill: "#e6f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18234",
    "data-name": "Path 18234",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11 2.967) rotate(-27.573)",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18235",
    "data-name": "Path 18235",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.086 2.923) rotate(-27.573)",
    fill: "#e4f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18236",
    "data-name": "Path 18236",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.172 2.879) rotate(-27.573)",
    fill: "#e3f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18237",
    "data-name": "Path 18237",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.259 2.835) rotate(-27.573)",
    fill: "#e2f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18238",
    "data-name": "Path 18238",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.346 2.791) rotate(-27.573)",
    fill: "#e1f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18239",
    "data-name": "Path 18239",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.432 2.747) rotate(-27.573)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18240",
    "data-name": "Path 18240",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.518 2.703) rotate(-27.573)",
    fill: "#dff2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18241",
    "data-name": "Path 18241",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.605 2.659) rotate(-27.573)",
    fill: "#def2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18242",
    "data-name": "Path 18242",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.692 2.615) rotate(-27.573)",
    fill: "#ddf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18243",
    "data-name": "Path 18243",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.778 2.571) rotate(-27.573)",
    fill: "#dcf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18244",
    "data-name": "Path 18244",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.865 2.527) rotate(-27.573)",
    fill: "#dbf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18245",
    "data-name": "Path 18245",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(11.951 2.483) rotate(-27.573)",
    fill: "#daf0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18246",
    "data-name": "Path 18246",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.037 2.439) rotate(-27.573)",
    fill: "#d9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18247",
    "data-name": "Path 18247",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.124 2.395) rotate(-27.573)",
    fill: "#d8efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18248",
    "data-name": "Path 18248",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.211 2.351) rotate(-27.573)",
    fill: "#d7efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18249",
    "data-name": "Path 18249",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.297 2.307) rotate(-27.573)",
    fill: "#d6efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18250",
    "data-name": "Path 18250",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.383 2.263) rotate(-27.573)",
    fill: "#d5eeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18251",
    "data-name": "Path 18251",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.47 2.219) rotate(-27.573)",
    fill: "#d4eeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18252",
    "data-name": "Path 18252",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.557 2.175) rotate(-27.573)",
    fill: "#d3edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18253",
    "data-name": "Path 18253",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.643 2.131) rotate(-27.573)",
    fill: "#d2edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18254",
    "data-name": "Path 18254",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.729 2.087) rotate(-27.573)",
    fill: "#d1edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18255",
    "data-name": "Path 18255",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.816 2.043) rotate(-27.573)",
    fill: "#d0ecff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18256",
    "data-name": "Path 18256",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.903 1.999) rotate(-27.573)",
    fill: "#cfecff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18257",
    "data-name": "Path 18257",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(12.989 1.955) rotate(-27.573)",
    fill: "#ceebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18258",
    "data-name": "Path 18258",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.075 1.911) rotate(-27.573)",
    fill: "#cdebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18259",
    "data-name": "Path 18259",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.162 1.867) rotate(-27.573)",
    fill: "#ccebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18260",
    "data-name": "Path 18260",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.249 1.823) rotate(-27.573)",
    fill: "#cbeaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18261",
    "data-name": "Path 18261",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.335 1.779) rotate(-27.573)",
    fill: "#caeaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18262",
    "data-name": "Path 18262",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.421 1.735) rotate(-27.573)",
    fill: "#c9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18263",
    "data-name": "Path 18263",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.508 1.691) rotate(-27.573)",
    fill: "#c8e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18264",
    "data-name": "Path 18264",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.594 1.647) rotate(-27.573)",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18265",
    "data-name": "Path 18265",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.681 1.603) rotate(-27.573)",
    fill: "#c6e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18266",
    "data-name": "Path 18266",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.767 1.559) rotate(-27.573)",
    fill: "#c5e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18267",
    "data-name": "Path 18267",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.854 1.515) rotate(-27.573)",
    fill: "#c4e7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18268",
    "data-name": "Path 18268",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(13.94 1.471) rotate(-27.573)",
    fill: "#c3e7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18269",
    "data-name": "Path 18269",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.027 1.427) rotate(-27.573)",
    fill: "#c2e7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18270",
    "data-name": "Path 18270",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.114 1.383) rotate(-27.573)",
    fill: "#c1e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18271",
    "data-name": "Path 18271",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.2 1.339) rotate(-27.573)",
    fill: "#c0e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18272",
    "data-name": "Path 18272",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.286 1.295) rotate(-27.573)",
    fill: "#bfe5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18273",
    "data-name": "Path 18273",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.373 1.251) rotate(-27.573)",
    fill: "#bee5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18274",
    "data-name": "Path 18274",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.46 1.207) rotate(-27.573)",
    fill: "#bde4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18275",
    "data-name": "Path 18275",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.546 1.164) rotate(-27.573)",
    fill: "#bce4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18276",
    "data-name": "Path 18276",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.632 1.12) rotate(-27.573)",
    fill: "#bbe4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18277",
    "data-name": "Path 18277",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.719 1.076) rotate(-27.573)",
    fill: "#bae3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18278",
    "data-name": "Path 18278",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.806 1.032) rotate(-27.573)",
    fill: "#b9e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18279",
    "data-name": "Path 18279",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.892 0.988) rotate(-27.573)",
    fill: "#b8e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18280",
    "data-name": "Path 18280",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(14.978 0.944) rotate(-27.573)",
    fill: "#b7e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18281",
    "data-name": "Path 18281",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.065 0.9) rotate(-27.573)",
    fill: "#b6e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18282",
    "data-name": "Path 18282",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.152 0.856) rotate(-27.573)",
    fill: "#b5e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18283",
    "data-name": "Path 18283",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.238 0.812) rotate(-27.573)",
    fill: "#b4e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18284",
    "data-name": "Path 18284",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.324 0.768) rotate(-27.573)",
    fill: "#b3e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18285",
    "data-name": "Path 18285",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.411 0.724) rotate(-27.573)",
    fill: "#b2e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18286",
    "data-name": "Path 18286",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.497 0.68) rotate(-27.573)",
    fill: "#b1e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18287",
    "data-name": "Path 18287",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.584 0.636) rotate(-27.573)",
    fill: "#b0dfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18288",
    "data-name": "Path 18288",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.67 0.592) rotate(-27.573)",
    fill: "#afdfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18289",
    "data-name": "Path 18289",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.757 0.548) rotate(-27.573)",
    fill: "#aedeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18290",
    "data-name": "Path 18290",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.843 0.504) rotate(-27.573)",
    fill: "#addeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18291",
    "data-name": "Path 18291",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(15.93 0.46) rotate(-27.573)",
    fill: "#acdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18292",
    "data-name": "Path 18292",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.017 0.416) rotate(-27.573)",
    fill: "#abddff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18293",
    "data-name": "Path 18293",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.103 0.372) rotate(-27.573)",
    fill: "#adf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18294",
    "data-name": "Path 18294",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.189 0.328) rotate(-27.573)",
    fill: "#a9dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18295",
    "data-name": "Path 18295",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.276 0.284) rotate(-27.573)",
    fill: "#a8dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18296",
    "data-name": "Path 18296",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.363 0.24) rotate(-27.573)",
    fill: "#a7dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18297",
    "data-name": "Path 18297",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.449 0.196) rotate(-27.573)",
    fill: "#a6dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18298",
    "data-name": "Path 18298",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.535 0.152) rotate(-27.573)",
    fill: "#a5dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18299",
    "data-name": "Path 18299",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.622 0.108) rotate(-27.573)",
    fill: "#a4daff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18300",
    "data-name": "Path 18300",
    d: "M0,0H.1L.251,14.325h-.1Z",
    transform: "translate(16.709 0.064) rotate(-27.573)",
    fill: "#a3daff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17682",
    "data-name": "Path 17682",
    d: "M52.474,468.006l.037-.019h.063l6.748,12.6-.087.044Z",
    transform: "translate(-35.677 -467.987)",
    fill: "#a2daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17683",
    "data-name": "Path 17683",
    d: "M52.9,467.987l6.724,12.559-.086.044-6.748-12.6Z",
    transform: "translate(-35.889 -467.987)",
    fill: "#a1d9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17684",
    "data-name": "Path 17684",
    d: "M53.241,467.987l6.7,12.515-.086.044L53.13,467.987Z",
    transform: "translate(-36.123 -467.987)",
    fill: "#a0d9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17685",
    "data-name": "Path 17685",
    d: "M53.584,467.987l6.677,12.471-.087.044-6.7-12.515Z",
    transform: "translate(-36.357 -467.987)",
    fill: "#9fd8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17686",
    "data-name": "Path 17686",
    d: "M53.928,467.987l6.654,12.427-.086.044-6.677-12.471Z",
    transform: "translate(-36.59 -467.987)",
    fill: "#9ed8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17687",
    "data-name": "Path 17687",
    d: "M54.272,467.987,60.9,480.37l-.087.044-6.654-12.427Z",
    transform: "translate(-36.824 -467.987)",
    fill: "#9dd8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17688",
    "data-name": "Path 17688",
    d: "M54.616,467.987l6.607,12.339-.086.044-6.63-12.383Z",
    transform: "translate(-37.058 -467.987)",
    fill: "#9cd7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17689",
    "data-name": "Path 17689",
    d: "M54.959,467.987l6.583,12.295-.086.044-6.607-12.339Z",
    transform: "translate(-37.292 -467.987)",
    fill: "#9bd7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17690",
    "data-name": "Path 17690",
    d: "M55.3,467.987l6.56,12.251-.086.044-6.583-12.295Z",
    transform: "translate(-37.525 -467.987)",
    fill: "#9ad6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17691",
    "data-name": "Path 17691",
    d: "M55.647,467.987l6.536,12.207-.086.044-6.56-12.251Z",
    transform: "translate(-37.759 -467.987)",
    fill: "#99d6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17692",
    "data-name": "Path 17692",
    d: "M55.991,467.987,62.5,480.15l-.086.044-6.536-12.207Z",
    transform: "translate(-37.993 -467.987)",
    fill: "#98d6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17693",
    "data-name": "Path 17693",
    d: "M56.335,467.987l6.489,12.119-.086.044-6.513-12.163Z",
    transform: "translate(-38.227 -467.987)",
    fill: "#97d5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17694",
    "data-name": "Path 17694",
    d: "M56.678,467.987l6.465,12.075-.087.044-6.489-12.119Z",
    transform: "translate(-38.46 -467.987)",
    fill: "#96d5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17695",
    "data-name": "Path 17695",
    d: "M57.022,467.987l6.442,12.031-.086.044-6.465-12.075Z",
    transform: "translate(-38.694 -467.987)",
    fill: "#95d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17696",
    "data-name": "Path 17696",
    d: "M57.366,467.987l6.418,11.987-.087.044-6.442-12.031Z",
    transform: "translate(-38.928 -467.987)",
    fill: "#94d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17697",
    "data-name": "Path 17697",
    d: "M57.71,467.987,64.1,479.93l-.086.044L57.6,467.987Z",
    transform: "translate(-39.162 -467.987)",
    fill: "#93d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17698",
    "data-name": "Path 17698",
    d: "M58.053,467.987l6.371,11.9-.086.044-6.395-11.943Z",
    transform: "translate(-39.395 -467.987)",
    fill: "#92d3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17699",
    "data-name": "Path 17699",
    d: "M58.4,467.987l6.348,11.855-.086.044-6.371-11.9Z",
    transform: "translate(-39.629 -467.987)",
    fill: "#91d3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17700",
    "data-name": "Path 17700",
    d: "M58.741,467.987,65.065,479.8l-.086.044-6.348-11.855Z",
    transform: "translate(-39.863 -467.987)",
    fill: "#90d2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17701",
    "data-name": "Path 17701",
    d: "M59.085,467.987l6.3,11.767-.086.044-6.324-11.811Z",
    transform: "translate(-40.096 -467.987)",
    fill: "#8fd2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17702",
    "data-name": "Path 17702",
    d: "M59.429,467.987l6.277,11.723-.086.044-6.3-11.767Z",
    transform: "translate(-40.33 -467.987)",
    fill: "#8ed2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17703",
    "data-name": "Path 17703",
    d: "M59.772,467.987l6.254,11.679-.087.044-6.277-11.723Z",
    transform: "translate(-40.564 -467.987)",
    fill: "#8dd1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17704",
    "data-name": "Path 17704",
    d: "M60.116,467.987l6.23,11.635-.086.044-6.254-11.679Z",
    transform: "translate(-40.798 -467.987)",
    fill: "#8cd1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17705",
    "data-name": "Path 17705",
    d: "M60.46,467.987l6.207,11.591-.087.044-6.23-11.635Z",
    transform: "translate(-41.031 -467.987)",
    fill: "#8bd0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17706",
    "data-name": "Path 17706",
    d: "M60.8,467.987l6.183,11.547-.086.044-6.207-11.591Z",
    transform: "translate(-41.265 -467.987)",
    fill: "#8ad0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17707",
    "data-name": "Path 17707",
    d: "M61.147,467.987l6.159,11.5-.086.044-6.183-11.547Z",
    transform: "translate(-41.499 -467.987)",
    fill: "#89d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17708",
    "data-name": "Path 17708",
    d: "M61.491,467.987l6.136,11.459-.086.044-6.159-11.5Z",
    transform: "translate(-41.733 -467.987)",
    fill: "#88cfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17709",
    "data-name": "Path 17709",
    d: "M61.835,467.987,67.947,479.4l-.086.044-6.136-11.459Z",
    transform: "translate(-41.966 -467.987)",
    fill: "#87cfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17710",
    "data-name": "Path 17710",
    d: "M62.179,467.987l6.089,11.371-.087.044-6.112-11.415Z",
    transform: "translate(-42.2 -467.987)",
    fill: "#86ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17711",
    "data-name": "Path 17711",
    d: "M62.523,467.987l6.065,11.327-.086.044-6.089-11.371Z",
    transform: "translate(-42.434 -467.987)",
    fill: "#85ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17712",
    "data-name": "Path 17712",
    d: "M62.866,467.987l6.042,11.283-.087.044-6.065-11.327Z",
    transform: "translate(-42.668 -467.987)",
    fill: "#84ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17713",
    "data-name": "Path 17713",
    d: "M63.21,467.987l6.018,11.239-.086.044L63.1,467.987Z",
    transform: "translate(-42.901 -467.987)",
    fill: "#83cdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17714",
    "data-name": "Path 17714",
    d: "M63.554,467.987l5.994,11.2-.086.044-6.018-11.239Z",
    transform: "translate(-43.135 -467.987)",
    fill: "#82cdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17715",
    "data-name": "Path 17715",
    d: "M63.9,467.987l5.971,11.151-.086.044-5.995-11.2Z",
    transform: "translate(-43.369 -467.987)",
    fill: "#81ccff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17716",
    "data-name": "Path 17716",
    d: "M64.241,467.987l5.947,11.107-.086.044-5.971-11.151Z",
    transform: "translate(-43.602 -467.987)",
    fill: "#80ccff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17717",
    "data-name": "Path 17717",
    d: "M64.585,467.987l5.924,11.063-.086.044-5.948-11.107Z",
    transform: "translate(-43.836 -467.987)",
    fill: "#7eccff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17718",
    "data-name": "Path 17718",
    d: "M64.929,467.987l5.9,11.019-.086.044-5.924-11.063Z",
    transform: "translate(-44.07 -467.987)",
    fill: "#7dcbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17719",
    "data-name": "Path 17719",
    d: "M65.273,467.987l5.877,10.976-.087.044-5.9-11.019Z",
    transform: "translate(-44.304 -467.987)",
    fill: "#7ccbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17720",
    "data-name": "Path 17720",
    d: "M65.617,467.987l5.853,10.932-.086.044-5.877-10.976Z",
    transform: "translate(-44.537 -467.987)",
    fill: "#7bcaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17721",
    "data-name": "Path 17721",
    d: "M65.96,467.987l5.83,10.888-.087.044L65.85,467.987Z",
    transform: "translate(-44.771 -467.987)",
    fill: "#7acaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17722",
    "data-name": "Path 17722",
    d: "M66.3,467.987l5.806,10.844-.086.044-5.83-10.888Z",
    transform: "translate(-45.005 -467.987)",
    fill: "#79caff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17723",
    "data-name": "Path 17723",
    d: "M66.648,467.987l5.782,10.8-.086.044-5.806-10.844Z",
    transform: "translate(-45.239 -467.987)",
    fill: "#78c9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17724",
    "data-name": "Path 17724",
    d: "M66.992,467.987l5.759,10.756-.086.044-5.783-10.8Z",
    transform: "translate(-45.472 -467.987)",
    fill: "#77c9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17725",
    "data-name": "Path 17725",
    d: "M67.336,467.987,73.071,478.7l-.086.044-5.759-10.756Z",
    transform: "translate(-45.706 -467.987)",
    fill: "#76c8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17726",
    "data-name": "Path 17726",
    d: "M67.679,467.987l5.712,10.668-.086.044-5.736-10.712Z",
    transform: "translate(-45.94 -467.987)",
    fill: "#75c8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17727",
    "data-name": "Path 17727",
    d: "M68.023,467.987l5.688,10.624-.086.044-5.712-10.668Z",
    transform: "translate(-46.174 -467.987)",
    fill: "#74c8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17728",
    "data-name": "Path 17728",
    d: "M68.367,467.987l5.665,10.58-.087.044-5.688-10.624Z",
    transform: "translate(-46.407 -467.987)",
    fill: "#73c7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17729",
    "data-name": "Path 17729",
    d: "M68.711,467.987l5.641,10.536-.086.044L68.6,467.987Z",
    transform: "translate(-46.641 -467.987)",
    fill: "#72c7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17730",
    "data-name": "Path 17730",
    d: "M69.054,467.987l5.618,10.492-.087.044-5.641-10.536Z",
    transform: "translate(-46.875 -467.987)",
    fill: "#71c6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17731",
    "data-name": "Path 17731",
    d: "M69.4,467.987l5.594,10.448-.086.044-5.618-10.492Z",
    transform: "translate(-47.108 -467.987)",
    fill: "#70c6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17732",
    "data-name": "Path 17732",
    d: "M69.742,467.987l5.57,10.4-.086.044-5.594-10.448Z",
    transform: "translate(-47.342 -467.987)",
    fill: "#6fc6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17733",
    "data-name": "Path 17733",
    d: "M70.086,467.987l5.547,10.36-.086.044-5.571-10.4Z",
    transform: "translate(-47.576 -467.987)",
    fill: "#6ec5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17734",
    "data-name": "Path 17734",
    d: "M70.43,467.987,75.953,478.3l-.086.044-5.547-10.36Z",
    transform: "translate(-47.81 -467.987)",
    fill: "#6dc5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17735",
    "data-name": "Path 17735",
    d: "M70.773,467.987l5.5,10.272-.086.044-5.524-10.316Z",
    transform: "translate(-48.043 -467.987)",
    fill: "#6cc4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17736",
    "data-name": "Path 17736",
    d: "M71.117,467.987l5.476,10.228-.086.044-5.5-10.272Z",
    transform: "translate(-48.277 -467.987)",
    fill: "#6bc4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17737",
    "data-name": "Path 17737",
    d: "M71.461,467.987l5.453,10.184-.087.044-5.476-10.228Z",
    transform: "translate(-48.511 -467.987)",
    fill: "#6ac4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17738",
    "data-name": "Path 17738",
    d: "M71.8,467.987l5.429,10.14-.086.044-5.453-10.184Z",
    transform: "translate(-48.745 -467.987)",
    fill: "#69c3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17739",
    "data-name": "Path 17739",
    d: "M72.148,467.987l5.406,10.1-.087.044-5.429-10.14Z",
    transform: "translate(-48.978 -467.987)",
    fill: "#68c3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17740",
    "data-name": "Path 17740",
    d: "M72.492,467.987l5.382,10.052-.086.044-5.406-10.1Z",
    transform: "translate(-49.212 -467.987)",
    fill: "#67c2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17741",
    "data-name": "Path 17741",
    d: "M72.836,467.987,78.194,478l-.086.044-5.382-10.052Z",
    transform: "translate(-49.446 -467.987)",
    fill: "#66c2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17742",
    "data-name": "Path 17742",
    d: "M73.18,467.987l5.335,9.964-.086.044L73.07,467.987Z",
    transform: "translate(-49.68 -467.987)",
    fill: "#65c2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17743",
    "data-name": "Path 17743",
    d: "M73.524,467.987l5.312,9.92-.086.044-5.335-9.964Z",
    transform: "translate(-49.913 -467.987)",
    fill: "#64c1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17744",
    "data-name": "Path 17744",
    d: "M73.867,467.987l5.288,9.876-.086.044-5.312-9.92Z",
    transform: "translate(-50.147 -467.987)",
    fill: "#63c1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17745",
    "data-name": "Path 17745",
    d: "M74.211,467.987l5.264,9.832-.086.044L74.1,467.987Z",
    transform: "translate(-50.381 -467.987)",
    fill: "#62c0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17746",
    "data-name": "Path 17746",
    d: "M74.555,467.987l5.241,9.788-.087.044-5.264-9.832Z",
    transform: "translate(-50.615 -467.987)",
    fill: "#61c0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17747",
    "data-name": "Path 17747",
    d: "M74.9,467.987l5.217,9.744-.086.044-5.241-9.788Z",
    transform: "translate(-50.848 -467.987)",
    fill: "#60c0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17748",
    "data-name": "Path 17748",
    d: "M75.242,467.987l5.194,9.7-.087.044-5.217-9.744Z",
    transform: "translate(-51.082 -467.987)",
    fill: "#5fbfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17749",
    "data-name": "Path 17749",
    d: "M75.586,467.987l5.17,9.656-.086.044-5.194-9.7Z",
    transform: "translate(-51.316 -467.987)",
    fill: "#5ebfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17750",
    "data-name": "Path 17750",
    d: "M75.93,467.987l5.147,9.612-.086.044-5.17-9.656Z",
    transform: "translate(-51.549 -467.987)",
    fill: "#5dbeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17751",
    "data-name": "Path 17751",
    d: "M76.274,467.987l5.123,9.568-.086.044-5.147-9.612Z",
    transform: "translate(-51.783 -467.987)",
    fill: "#5cbeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17752",
    "data-name": "Path 17752",
    d: "M76.618,467.987l5.1,9.524-.086.044-5.123-9.568Z",
    transform: "translate(-52.017 -467.987)",
    fill: "#5bbeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17753",
    "data-name": "Path 17753",
    d: "M76.961,467.987l5.076,9.48-.086.044-5.1-9.524Z",
    transform: "translate(-52.251 -467.987)",
    fill: "#5abdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17754",
    "data-name": "Path 17754",
    d: "M77.305,467.987l5.053,9.436-.086.044-5.076-9.48Z",
    transform: "translate(-52.484 -467.987)",
    fill: "#59bdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17755",
    "data-name": "Path 17755",
    d: "M77.649,467.987l5.029,9.392-.087.044-5.053-9.436Z",
    transform: "translate(-52.718 -467.987)",
    fill: "#58bcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17756",
    "data-name": "Path 17756",
    d: "M77.993,467.987,83,477.336l-.086.044-5.029-9.392Z",
    transform: "translate(-52.952 -467.987)",
    fill: "#57bcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17757",
    "data-name": "Path 17757",
    d: "M78.336,467.987l4.982,9.3-.087.044-5.006-9.348Z",
    transform: "translate(-53.186 -467.987)",
    fill: "#56bcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17758",
    "data-name": "Path 17758",
    d: "M78.68,467.987l4.958,9.26-.086.044-4.982-9.3Z",
    transform: "translate(-53.419 -467.987)",
    fill: "#5bf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17759",
    "data-name": "Path 17759",
    d: "M79.024,467.987l4.935,9.217-.086.044-4.958-9.26Z",
    transform: "translate(-53.653 -467.987)",
    fill: "#54bbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17760",
    "data-name": "Path 17760",
    d: "M79.368,467.987l4.911,9.173-.086.044-4.935-9.217Z",
    transform: "translate(-53.887 -467.987)",
    fill: "#53baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17761",
    "data-name": "Path 17761",
    d: "M79.712,467.987l4.888,9.129-.086.044L79.6,467.987Z",
    transform: "translate(-54.121 -467.987)",
    fill: "#52baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17762",
    "data-name": "Path 17762",
    d: "M80.055,467.987l4.864,9.085-.087.044-4.888-9.129Z",
    transform: "translate(-54.354 -467.987)",
    fill: "#51baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17763",
    "data-name": "Path 17763",
    d: "M80.4,467.987l4.841,9.041-.086.044-4.864-9.085Z",
    transform: "translate(-54.588 -467.987)",
    fill: "#50b9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17764",
    "data-name": "Path 17764",
    d: "M80.743,467.987l4.817,9-.087.044-4.841-9.041Z",
    transform: "translate(-54.822 -467.987)",
    fill: "#4fb9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17765",
    "data-name": "Path 17765",
    d: "M81.087,467.987l4.794,8.953-.086.044-4.817-9Z",
    transform: "translate(-55.056 -467.987)",
    fill: "#4eb8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17766",
    "data-name": "Path 17766",
    d: "M81.431,467.987,86.2,476.9l-.086.044-4.794-8.953Z",
    transform: "translate(-55.289 -467.987)",
    fill: "#4db8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17767",
    "data-name": "Path 17767",
    d: "M81.774,467.987l4.747,8.865-.086.044-4.77-8.909Z",
    transform: "translate(-55.523 -467.987)",
    fill: "#4cb8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17768",
    "data-name": "Path 17768",
    d: "M82.118,467.987l4.723,8.821-.086.044-4.747-8.865Z",
    transform: "translate(-55.757 -467.987)",
    fill: "#4bb7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17769",
    "data-name": "Path 17769",
    d: "M82.462,467.987l4.7,8.777-.086.044-4.723-8.821Z",
    transform: "translate(-55.99 -467.987)",
    fill: "#4ab7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17770",
    "data-name": "Path 17770",
    d: "M82.806,467.987l4.676,8.733-.086.044-4.7-8.777Z",
    transform: "translate(-56.224 -467.987)",
    fill: "#49b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17771",
    "data-name": "Path 17771",
    d: "M83.149,467.987l4.652,8.689-.087.044-4.676-8.733Z",
    transform: "translate(-56.458 -467.987)",
    fill: "#48b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17772",
    "data-name": "Path 17772",
    d: "M83.493,467.987l4.629,8.645-.086.044-4.652-8.689Z",
    transform: "translate(-56.692 -467.987)",
    fill: "#47b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17773",
    "data-name": "Path 17773",
    d: "M83.837,467.987l4.605,8.6-.087.044-4.629-8.645Z",
    transform: "translate(-56.925 -467.987)",
    fill: "#46b5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17774",
    "data-name": "Path 17774",
    d: "M84.181,467.987l4.582,8.557-.086.044-4.605-8.6Z",
    transform: "translate(-57.159 -467.987)",
    fill: "#45b5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17775",
    "data-name": "Path 17775",
    d: "M84.525,467.987l4.558,8.513-.086.044-4.582-8.557Z",
    transform: "translate(-57.393 -467.987)",
    fill: "#44b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17776",
    "data-name": "Path 17776",
    d: "M84.868,467.987l4.535,8.469-.086.044-4.558-8.513Z",
    transform: "translate(-57.627 -467.987)",
    fill: "#43b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17777",
    "data-name": "Path 17777",
    d: "M85.212,467.987l4.511,8.425-.086.044L85.1,467.987Z",
    transform: "translate(-57.86 -467.987)",
    fill: "#42b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17778",
    "data-name": "Path 17778",
    d: "M85.556,467.987l4.455,8.32v.077l-.054.027-4.511-8.425Z",
    transform: "translate(-58.094 -467.987)",
    fill: "#41b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17779",
    "data-name": "Path 17779",
    d: "M85.9,467.987l4.345,8.115v.206l-4.455-8.32Z",
    transform: "translate(-58.328 -467.987)",
    fill: "#40b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17780",
    "data-name": "Path 17780",
    d: "M86.243,467.987l4.235,7.909v.206l-4.345-8.115Z",
    transform: "translate(-58.562 -467.987)",
    fill: "#3fb2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17781",
    "data-name": "Path 17781",
    d: "M86.587,467.987l4.125,7.7v.206l-4.235-7.909Z",
    transform: "translate(-58.795 -467.987)",
    fill: "#3eb2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17782",
    "data-name": "Path 17782",
    d: "M86.931,467.987l4.015,7.5v.205l-4.125-7.7Z",
    transform: "translate(-59.029 -467.987)",
    fill: "#3db1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17783",
    "data-name": "Path 17783",
    d: "M87.275,467.987l3.9,7.293v.206l-4.015-7.5Z",
    transform: "translate(-59.263 -467.987)",
    fill: "#3cb1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17784",
    "data-name": "Path 17784",
    d: "M87.619,467.987l3.795,7.087v.206l-3.9-7.293Z",
    transform: "translate(-59.496 -467.987)",
    fill: "#3bb1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17785",
    "data-name": "Path 17785",
    d: "M87.962,467.987l3.684,6.882v.206l-3.795-7.087Z",
    transform: "translate(-59.73 -467.987)",
    fill: "#3ab0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17786",
    "data-name": "Path 17786",
    d: "M88.306,467.987l3.575,6.676v.206L88.2,467.987Z",
    transform: "translate(-59.964 -467.987)",
    fill: "#39b0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17787",
    "data-name": "Path 17787",
    d: "M88.65,467.987l3.465,6.47v.206l-3.575-6.676Z",
    transform: "translate(-60.198 -467.987)",
    fill: "#38afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17788",
    "data-name": "Path 17788",
    d: "M88.994,467.987l3.354,6.265v.206l-3.465-6.47Z",
    transform: "translate(-60.431 -467.987)",
    fill: "#37afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17789",
    "data-name": "Path 17789",
    d: "M89.337,467.987l3.244,6.059v.206l-3.354-6.265Z",
    transform: "translate(-60.665 -467.987)",
    fill: "#36afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17790",
    "data-name": "Path 17790",
    d: "M89.681,467.987l3.134,5.854v.206l-3.245-6.059Z",
    transform: "translate(-60.899 -467.987)",
    fill: "#35aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17791",
    "data-name": "Path 17791",
    d: "M90.025,467.987l3.024,5.648v.206l-3.134-5.854Z",
    transform: "translate(-61.133 -467.987)",
    fill: "#34aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17792",
    "data-name": "Path 17792",
    d: "M90.369,467.987l2.914,5.443v.206l-3.024-5.648Z",
    transform: "translate(-61.366 -467.987)",
    fill: "#33adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17793",
    "data-name": "Path 17793",
    d: "M90.713,467.987l2.8,5.237v.206L90.6,467.987Z",
    transform: "translate(-61.6 -467.987)",
    fill: "#32adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17794",
    "data-name": "Path 17794",
    d: "M91.056,467.987l2.694,5.032v.205l-2.8-5.237Z",
    transform: "translate(-61.834 -467.987)",
    fill: "#31adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17795",
    "data-name": "Path 17795",
    d: "M91.4,467.987l2.584,4.826v.206l-2.694-5.032Z",
    transform: "translate(-62.068 -467.987)",
    fill: "#30acff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17796",
    "data-name": "Path 17796",
    d: "M91.744,467.987l2.474,4.621v.206l-2.584-4.826Z",
    transform: "translate(-62.301 -467.987)",
    fill: "#2facff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17797",
    "data-name": "Path 17797",
    d: "M92.088,467.987l2.364,4.415v.206l-2.474-4.621Z",
    transform: "translate(-62.535 -467.987)",
    fill: "#2eabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17798",
    "data-name": "Path 17798",
    d: "M92.431,467.987l2.254,4.21v.206l-2.364-4.415Z",
    transform: "translate(-62.769 -467.987)",
    fill: "#2dabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17799",
    "data-name": "Path 17799",
    d: "M92.775,467.987l2.144,4v.206l-2.254-4.21Z",
    transform: "translate(-63.002 -467.987)",
    fill: "#2cabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17800",
    "data-name": "Path 17800",
    d: "M93.119,467.987l2.034,3.8v.206l-2.144-4Z",
    transform: "translate(-63.236 -467.987)",
    fill: "#2baaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17801",
    "data-name": "Path 17801",
    d: "M93.463,467.987l1.924,3.593v.206l-2.034-3.8Z",
    transform: "translate(-63.47 -467.987)",
    fill: "#2aaaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17802",
    "data-name": "Path 17802",
    d: "M93.807,467.987l1.814,3.387v.206L93.7,467.987Z",
    transform: "translate(-63.704 -467.987)",
    fill: "#29a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17803",
    "data-name": "Path 17803",
    d: "M94.15,467.987l1.7,3.182v.206l-1.814-3.387Z",
    transform: "translate(-63.937 -467.987)",
    fill: "#28a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17804",
    "data-name": "Path 17804",
    d: "M94.494,467.987l1.594,2.976v.206l-1.7-3.182Z",
    transform: "translate(-64.171 -467.987)",
    fill: "#27a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17805",
    "data-name": "Path 17805",
    d: "M94.838,467.987l1.484,2.771v.205l-1.594-2.976Z",
    transform: "translate(-64.405 -467.987)",
    fill: "#26a8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17806",
    "data-name": "Path 17806",
    d: "M95.182,467.987l1.374,2.565v.206l-1.484-2.771Z",
    transform: "translate(-64.639 -467.987)",
    fill: "#25a8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17807",
    "data-name": "Path 17807",
    d: "M95.525,467.987l1.263,2.36v.206l-1.374-2.565Z",
    transform: "translate(-64.872 -467.987)",
    fill: "#24a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17808",
    "data-name": "Path 17808",
    d: "M95.869,467.987l1.154,2.154v.206l-1.264-2.36Z",
    transform: "translate(-65.106 -467.987)",
    fill: "#23a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17809",
    "data-name": "Path 17809",
    d: "M96.213,467.987l1.044,1.949v.206L96.1,467.987Z",
    transform: "translate(-65.34 -467.987)",
    fill: "#22a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17810",
    "data-name": "Path 17810",
    d: "M96.557,467.987l.933,1.743v.206l-1.044-1.949Z",
    transform: "translate(-65.574 -467.987)",
    fill: "#21a6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17811",
    "data-name": "Path 17811",
    d: "M96.9,467.987l.823,1.538v.206l-.933-1.743Z",
    transform: "translate(-65.807 -467.987)",
    fill: "#20a6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17812",
    "data-name": "Path 17812",
    d: "M97.244,467.987l.713,1.332v.206l-.823-1.538Z",
    transform: "translate(-66.041 -467.987)",
    fill: "#1fa5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17813",
    "data-name": "Path 17813",
    d: "M97.588,467.987l.6,1.127v.206l-.714-1.332Z",
    transform: "translate(-66.275 -467.987)",
    fill: "#1ea5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17814",
    "data-name": "Path 17814",
    d: "M97.932,467.987l.493.921v.206l-.6-1.127Z",
    transform: "translate(-66.508 -467.987)",
    fill: "#1da5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17815",
    "data-name": "Path 17815",
    d: "M98.276,467.987l.383.716v.206l-.493-.921Z",
    transform: "translate(-66.742 -467.987)",
    fill: "#1ca4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17816",
    "data-name": "Path 17816",
    d: "M98.62,467.987l.273.51v.205l-.383-.716Z",
    transform: "translate(-66.976 -467.987)",
    fill: "#1ba4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17817",
    "data-name": "Path 17817",
    d: "M98.963,467.987l.163.3v.206l-.273-.51Z",
    transform: "translate(-67.21 -467.987)",
    fill: "#1aa3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17818",
    "data-name": "Path 17818",
    d: "M99.307,467.987l.053.1v.206l-.163-.3Z",
    transform: "translate(-67.443 -467.987)",
    fill: "#19a3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17819",
    "data-name": "Path 17819",
    d: "M99.594,468.086l-.053-.1h.053Z",
    transform: "translate(-67.677 -467.987)",
    fill: "#18a3ff",
    fillRule: "evenodd"
  }))))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17821",
    "data-name": "Path 17821",
    d: "M51.355,109.975c.013-4.532,3.3-6.366,7.347-4.086l41.755,23.37c4.041,2.277,7.313,7.807,7.3,12.339l-.174,48.366c-.013,4.532-3.307,6.363-7.348,4.086L58.48,170.679c-4.046-2.279-7.313-7.807-7.3-12.339Z",
    transform: "translate(-34.797 -72.186)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17822",
    "data-name": "Path 17822",
    d: "M102.837,194.649a7.116,7.116,0,0,1-3.443-1.024l-41.753-23.37c-4.128-2.326-7.474-7.982-7.461-12.61l.175-48.366c.007-2.3.828-4.03,2.313-4.862s3.451-.656,5.514.507l41.754,23.37c4.127,2.326,7.474,7.983,7.46,12.611l-.174,48.366c-.007,2.3-.828,4.028-2.314,4.86a4.19,4.19,0,0,1-2.071.519m-48.1-90.127a3.539,3.539,0,0,0-1.751.435c-1.279.716-1.987,2.252-1.992,4.323h0l-.175,48.366c-.013,4.429,3.19,9.843,7.14,12.068l41.753,23.37c1.858,1.046,3.589,1.226,4.876.5s1.987-2.251,1.993-4.322l.174-48.366c.012-4.429-3.19-9.843-7.14-12.068l-41.754-23.37a6.483,6.483,0,0,0-3.124-.941",
    transform: "translate(-34.117 -71.49)",
    fill: "#09f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17823",
    "data-name": "Path 17823",
    d: "M44.261,111.743c.013-4.532,3.3-6.366,7.347-4.086l41.755,23.37c4.041,2.277,7.313,7.807,7.3,12.339l-.174,48.366c-.013,4.532-3.307,6.363-7.348,4.086L51.386,172.447c-4.046-2.279-7.313-7.807-7.3-12.339Z",
    transform: "translate(-29.974 -73.402)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17824",
    "data-name": "Path 17824",
    d: "M95.744,196.417a7.12,7.12,0,0,1-3.444-1.024l-41.753-23.37c-4.128-2.326-7.474-7.983-7.461-12.611l.175-48.366c.007-2.3.828-4.03,2.313-4.862s3.451-.655,5.514.507l41.754,23.37c4.127,2.326,7.474,7.983,7.46,12.611l-.174,48.366c-.007,2.3-.828,4.027-2.314,4.86a4.192,4.192,0,0,1-2.071.519m-48.1-90.127a3.539,3.539,0,0,0-1.751.435c-1.279.716-1.987,2.252-1.992,4.323h0l-.175,48.366c-.013,4.429,3.19,9.843,7.14,12.068l41.753,23.37c1.858,1.046,3.589,1.226,4.876.5s1.987-2.251,1.993-4.321l.174-48.366c.013-4.429-3.19-9.843-7.14-12.068l-41.754-23.37a6.483,6.483,0,0,0-3.124-.941",
    transform: "translate(-29.294 -72.707)",
    fill: "#09f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11706",
    "data-name": "Group 11706",
    transform: "translate(17.705 49.642)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11705",
    "data-name": "Group 11705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11704",
    "data-name": "Group 11704",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17825",
    "data-name": "Path 17825",
    d: "M55.422,162.422c.008-2.926,2.132-4.11,4.744-2.638L98.93,181.235a10.1,10.1,0,0,1,4.714,7.967l-.112,31.23c-.008,2.926-2.135,4.109-4.745,2.638L60.023,201.62a10.1,10.1,0,0,1-4.714-7.968Z",
    transform: "translate(-55.309 -159.151)",
    fill: "#09f",
    fillRule: "evenodd"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17826",
    "data-name": "Path 17826",
    d: "M139.262,218.315a4.931,4.931,0,0,1,3.311,4.221c.172,1.93-1.033,3.17-2.69,2.77a4.93,4.93,0,0,1-3.311-4.221c-.172-1.93,1.033-3.17,2.69-2.77",
    transform: "translate(-92.844 -150.167)",
    fill: "#09f",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17827",
    "data-name": "Path 17827",
    d: "M76.46,233.444,88.524,214l6.092,21.593,6.191-7.353,7.713,23.151Z",
    transform: "translate(-51.984 -147.248)",
    fill: "#0fa",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17828",
    "data-name": "Path 17828",
    d: "M60.769,123.893c2.236.577,4.236,3.159,4.467,5.767s-1.393,4.254-3.629,3.677-4.235-3.159-4.467-5.767,1.393-4.254,3.629-3.677",
    transform: "translate(-38.834 -85.169)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17829",
    "data-name": "Path 17829",
    d: "M61.8,133.078a3.805,3.805,0,0,1-.949-.125c-2.352-.607-4.462-3.317-4.7-6.042a3.936,3.936,0,0,1,1.2-3.482,3.119,3.119,0,0,1,2.826-.523c2.352.607,4.462,3.317,4.7,6.041a3.936,3.936,0,0,1-1.2,3.482,2.912,2.912,0,0,1-1.877.649m-2.58-9.675a2.246,2.246,0,0,0-1.458.5,3.338,3.338,0,0,0-.977,2.951c.221,2.483,2.118,4.947,4.23,5.492a2.449,2.449,0,0,0,2.25-.4A3.339,3.339,0,0,0,64.238,129c-.221-2.483-2.118-4.947-4.23-5.492a3.181,3.181,0,0,0-.793-.106",
    transform: "translate(-38.155 -84.483)",
    fill: "#09f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17830",
    "data-name": "Path 17830",
    d: "M86.307,139.629c0-.552.4-.769.9-.483l14.938,8.268a1.944,1.944,0,0,1,.889,1.518v1.092c0,.552-.4.769-.9.483L87.2,142.239a1.943,1.943,0,0,1-.89-1.518Z",
    transform: "translate(-58.68 -95.657)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17831",
    "data-name": "Path 17831",
    d: "M101.865,150.257a1.156,1.156,0,0,1-.575-.169l-14.932-8.265a2.258,2.258,0,0,1-1.052-1.79v-1.093a.9.9,0,0,1,.422-.824.965.965,0,0,1,.957.074l14.932,8.265a2.255,2.255,0,0,1,1.051,1.79v1.091a.9.9,0,0,1-.422.825.784.784,0,0,1-.382.1M85.948,138.943v1.092a1.627,1.627,0,0,0,.733,1.25l14.932,8.265c.162.094.27.1.319.07s.1-.142.1-.283v-1.092a1.65,1.65,0,0,0-.733-1.25L86.364,138.73c-.162-.094-.27-.1-.319-.071s-.1.142-.1.284",
    transform: "translate(-58 -94.97)",
    fill: "#09f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17832",
    "data-name": "Path 17832",
    d: "M86.307,153.061c0-.326.238-.454.529-.285l8.821,4.882a1.148,1.148,0,0,1,.525.9v.645c0,.326-.238.454-.529.285L86.832,154.6a1.147,1.147,0,0,1-.525-.9Z",
    transform: "translate(-58.68 -105.071)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17833",
    "data-name": "Path 17833",
    d: "M95.217,159.184a.813.813,0,0,1-.406-.118l-8.816-4.879a1.45,1.45,0,0,1-.687-1.168v-.646a.654.654,0,0,1,.316-.6.7.7,0,0,1,.7.045l8.815,4.879a1.453,1.453,0,0,1,.688,1.168v.644a.655.655,0,0,1-.316.6.6.6,0,0,1-.291.073m-9.268-6.809v.644a.842.842,0,0,0,.368.628l8.815,4.879a.411.411,0,0,0,.048.024.307.307,0,0,0,0-.039v-.644a.845.845,0,0,0-.369-.628L86,152.359a.358.358,0,0,0-.048-.024.322.322,0,0,0,0,.039",
    transform: "translate(-58 -104.384)",
    fill: "#09f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17834",
    "data-name": "Path 17834",
    d: "M55.644,344.137c2.029,2.3,2.06,2.477,6.024,4.749l.754-1.449a19.194,19.194,0,0,0-3.456-5.082,19.929,19.929,0,0,0,4.063-3.729c2.585-3.368,1.15-5.707-1.084-5.234-1.948.414-4.987,5.335-6.64,8.11-.689,1.156-.855,1.282.339,2.634",
    transform: "translate(-37.236 -229.36)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17835",
    "data-name": "Path 17835",
    d: "M61.124,348.635l-.294-.168c-3.77-2.161-4.034-2.462-5.756-4.42l-.348-.395c-1.2-1.354-1.166-1.672-.459-2.851l.086-.144c2.16-3.626,4.891-7.842,6.849-8.258a2.267,2.267,0,0,1,2.472.866c.772,1.17.375,2.986-1.063,4.859a20.407,20.407,0,0,1-3.855,3.6l.263.314a17.7,17.7,0,0,1,3.016,4.57l.069.139Zm.713-15.68a2.394,2.394,0,0,0-.5.055c-1.933.41-5.319,6.094-6.432,7.961l-.087.146c-.579.967-.6,1,.391,2.129l.349.4c1.653,1.879,1.9,2.165,5.3,4.12l.528-1.014a17.028,17.028,0,0,0-2.866-4.309l-.7-.835.284-.192a19.63,19.63,0,0,0,3.989-3.659c1.5-1.949,1.517-3.421,1.037-4.148a1.488,1.488,0,0,0-1.3-.648",
    transform: "translate(-36.561 -228.672)",
    fill: "#09f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17836",
    "data-name": "Path 17836",
    d: "M87.506,465.6c.255-.1.824-1.2,1.8-1.095,1.168.129,2.424-.653,3.453-.769.183-.021.41-.09.531-.018a.731.731,0,0,1,.258,1.217A7.363,7.363,0,0,1,92.3,466.2a8.745,8.745,0,0,1-1.444,1.029c-.442.239-.756.244-1.159.436l.012.368a1.986,1.986,0,0,1-.889.577,2.414,2.414,0,0,1-1.867-.679,4.093,4.093,0,0,1-.184-2.1Z",
    transform: "translate(-58.943 -319.053)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17837",
    "data-name": "Path 17837",
    d: "M87.9,468.253a2.931,2.931,0,0,1-1.834-.78l-.08-.07-.02-.1c-.026-.125-.058-.249-.091-.375a3.5,3.5,0,0,1-.091-1.851l.04-.172.873-.277c.04-.033.123-.126.185-.194a2.119,2.119,0,0,1,1.778-.924,4.873,4.873,0,0,0,1.987-.4,6.836,6.836,0,0,1,1.393-.374c.04,0,.083-.012.126-.019a.873.873,0,0,1,.609.045,1.175,1.175,0,0,1,.613.736,1.159,1.159,0,0,1-.259.923,7.73,7.73,0,0,1-1.3,1.327l-.143.116a8.093,8.093,0,0,1-1.35.945,3.418,3.418,0,0,1-.712.278c-.093.028-.184.055-.276.088l.01.284-.091.094a2.286,2.286,0,0,1-1.061.67,1.654,1.654,0,0,1-.308.028m-1.329-1.18a2.03,2.03,0,0,0,1.514.54,1.58,1.58,0,0,0,.625-.395l-.014-.436.186-.089a3.578,3.578,0,0,1,.556-.2,2.792,2.792,0,0,0,.588-.226,7.577,7.577,0,0,0,1.25-.879l.145-.117a7.081,7.081,0,0,0,1.18-1.2.619.619,0,0,0,.16-.441c-.022-.1-.123-.21-.3-.32-.037,0-.132.015-.187.024s-.11.019-.162.024a6.4,6.4,0,0,0-1.255.343,5.3,5.3,0,0,1-2.271.426c-.527-.056-.93.388-1.223.715a1.214,1.214,0,0,1-.419.361l-.018.007-.553.176a3,3,0,0,0,.122,1.388c.027.1.052.2.076.3",
    transform: "translate(-58.263 -318.365)",
    fill: "#09f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17838",
    "data-name": "Path 17838",
    d: "M79.112,383.719c.223,2.444,1.479,10.247,1.129,12.39-.525,3.222-.128,8.7-.122,12.124-.089,1.437-1.982,2.2-2.571,1.289-.473-3.056-1.524-7.337-1.8-9.035a12.025,12.025,0,0,1,.289-5.461,63.67,63.67,0,0,0-1.953-7.327c-.287-.88-1.916-3.726-.23-6.553Z",
    transform: "translate(-49.702 -262.259)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17839",
    "data-name": "Path 17839",
    d: "M77.665,409.322a1.231,1.231,0,0,1-1.07-.541l-.036-.055-.01-.064c-.276-1.784-.742-3.949-1.153-5.858-.285-1.323-.531-2.465-.645-3.175a12.552,12.552,0,0,1,.277-5.542,65.287,65.287,0,0,0-1.93-7.2c-.038-.117-.1-.27-.177-.455-.5-1.228-1.555-3.784-.025-6.35l.151-.254,5.685,2.784.016.173c.062.676.2,1.773.369,3.044.429,3.306,1.017,7.834.758,9.423a54.087,54.087,0,0,0-.186,8.815c.034,1.183.066,2.3.068,3.259a2.206,2.206,0,0,1-1.658,1.941,1.8,1.8,0,0,1-.434.055m-.494-.826a.759.759,0,0,0,.77.166,1.558,1.558,0,0,0,1.177-1.355c0-.931-.035-2.044-.069-3.223a54.363,54.363,0,0,1,.194-8.93c.245-1.5-.336-5.978-.761-9.247-.152-1.174-.286-2.2-.355-2.893l-4.821-2.361c-1.158,2.22-.24,4.453.209,5.548.083.2.151.37.193.5a63.944,63.944,0,0,1,1.965,7.377l.012.08-.03.076a11.687,11.687,0,0,0-.272,5.3c.112.694.356,1.829.639,3.143.407,1.892.868,4.034,1.148,5.821",
    transform: "translate(-49.019 -261.353)",
    fill: "#09f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11709",
    "data-name": "Group 11709",
    transform: "translate(25.428 121.877)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11708",
    "data-name": "Group 11708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11707",
    "data-name": "Group 11707",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17840",
    "data-name": "Path 17840",
    d: "M84.482,399.331c.061.705.1,1.359.12,1.923-.66,3.231-2.411,7.767-3.43,11.015-.334-1.754-.778-3.308-.988-4.454l0-.022,0-.014v-.007l0-.021,0-.021-.007-.041,0-.021,0-.021,0-.02,0-.02,0-.02h0l0-.02,0-.02,0-.02v0l0-.017,0-.019,0-.019v0l0-.015,0-.019,0-.019v-.006l0-.013,0-.018,0-.018v-.008l0-.01,0-.018,0-.018,0-.01v-.008l0-.018,0-.017,0-.012v-.006l0-.017,0-.017,0-.013v0l0-.017,0-.017,0-.014v0l0-.016,0-.016,0-.016-.012-.08,0-.022-.01-.067,0-.013-.011-.08,0-.019-.009-.068,0-.017c0-.027-.007-.054-.01-.081l0-.02c0-.021-.005-.042-.007-.062l0-.025c0-.023-.006-.047-.008-.07l0-.027c0-.021,0-.043-.007-.065l0-.027c0-.021,0-.041-.006-.062l0-.022c0-.027-.005-.054-.008-.082l0-.019-.005-.062,0-.028c0-.025,0-.051-.006-.076l0-.031,0-.049,0-.036,0-.075v-.017l0-.068,0-.03,0-.061V405.6c0-.026,0-.053,0-.079l0-.031,0-.05V405.4l0-.066v-.169l0-.07v-.118c0-.028,0-.055,0-.083v-.362c0-.031,0-.062,0-.092v-.032l0-.047v-.027l0-.1v-.011l0-.058v-.009c0-.06.006-.119.009-.179v-.012c0-.081.011-.162.017-.242v-.008q.007-.088.015-.174v-.011q.02-.21.047-.411h0a6.528,6.528,0,0,1,.356-1.493c-.116-.777-.475-2.254-.91-3.832q.073-.366.135-.743a11.084,11.084,0,0,0,0-2.445,2.217,2.217,0,0,1,.621-1.78c.463-.47.247-1.252.812-2.088l2.642,1.566c.129,1.007.288,2.2.439,3.429l-1.682,5.605c.891-.758,1.65-1.639,2.074-2.006",
    transform: "translate(-79.437 -390.736)",
    fill: "#09f",
    fillRule: "evenodd"
  }))))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17841",
    "data-name": "Path 17841",
    d: "M65.674,477.075c.274-.006,1.2-.853,2.072-.425,1.051.513,2.506.2,3.513.436.179.042.417.053.5.161a.731.731,0,0,1-.187,1.229,7.53,7.53,0,0,1-1.609.77,8.887,8.887,0,0,1-1.718.481c-.5.076-.8-.025-1.242.02l-.118.35a2.02,2.02,0,0,1-1.037.244,2.367,2.367,0,0,1-1.514-1.264,4.108,4.108,0,0,1,.567-2.031Z",
    transform: "translate(-43.743 -327.892)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17842",
    "data-name": "Path 17842",
    d: "M65.256,479.97a1.008,1.008,0,0,1-.162-.012,2.65,2.65,0,0,1-1.746-1.425l-.051-.092.017-.1c.02-.125.033-.253.047-.382a3.516,3.516,0,0,1,.568-1.77l.1-.149.917.033c.049-.018.159-.077.242-.121a2.157,2.157,0,0,1,2-.27,4.86,4.86,0,0,0,2,.3,6.873,6.873,0,0,1,1.44.116c.039.009.082.017.125.024a.869.869,0,0,1,.556.247,1.152,1.152,0,0,1,.316.9,1.18,1.18,0,0,1-.569.78,7.919,7.919,0,0,1-1.687.81l-.178.062a8.221,8.221,0,0,1-1.6.434,3.488,3.488,0,0,1-.767.022c-.1-.005-.189-.009-.289-.01l-.092.27-.118.058a2.606,2.606,0,0,1-1.07.285m-1.293-1.643a2,2,0,0,0,1.232,1.015,1.624,1.624,0,0,0,.726-.161l.14-.415.206-.021a3.564,3.564,0,0,1,.593,0,2.829,2.829,0,0,0,.632-.016,7.681,7.681,0,0,0,1.481-.4l.18-.063a7.234,7.234,0,0,0,1.532-.731c.186-.128.288-.25.305-.36a.581.581,0,0,0-.168-.4,1.4,1.4,0,0,0-.184-.04c-.055-.01-.11-.02-.16-.031a6.424,6.424,0,0,0-1.3-.1,5.32,5.32,0,0,1-2.282-.362,1.589,1.589,0,0,0-1.4.26,1.249,1.249,0,0,1-.521.2h-.019l-.581-.021A3.021,3.021,0,0,0,64,478.019c-.011.1-.022.207-.036.308",
    transform: "translate(-43.036 -327.2)",
    fill: "#09f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17843",
    "data-name": "Path 17843",
    d: "M73.728,400.986c-1.52,3.357-4.2,10.356-5.416,13.772-.462.953-2.2,1.558-2.891.327.456-2.764,1.267-8.818,2.61-12.021a24.4,24.4,0,0,1,1.782-3.468c.356-1.35.8-5,1.146-6.969-.309-1.633-1.658-4.362.934-6.734,1.046.726,4.28,1.18,5.747.372.237,6.448-1.385,9.137-3.913,14.722",
    transform: "translate(-44.479 -265.526)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17844",
    "data-name": "Path 17844",
    d: "M65.893,415.2a1.608,1.608,0,0,1-1.461-.854l-.052-.094.017-.105c.065-.392.137-.851.216-1.357.5-3.166,1.247-7.95,2.414-10.732a25.973,25.973,0,0,1,1.783-3.486c.217-.857.469-2.563.712-4.214.143-.973.279-1.893.4-2.615-.049-.243-.121-.517-.2-.806-.426-1.612-1.069-4.048,1.238-6.159l.191-.175.214.148c.96.666,4.051,1.1,5.4.354l.459-.253.019.513c.214,5.834-1.058,8.594-3.165,13.167-.247.536-.506,1.1-.775,1.692l-.293-.126.293.126c-1.509,3.333-4.155,10.245-5.407,13.748l-.013.031a2.315,2.315,0,0,1-1.944,1.2h-.056m-.846-1.065a.985.985,0,0,0,.884.441,1.7,1.7,0,0,0,1.376-.825c1.258-3.518,3.907-10.435,5.42-13.778.27-.6.529-1.158.777-1.7,2.013-4.367,3.249-7.05,3.123-12.426a8.293,8.293,0,0,1-5.4-.452c-1.825,1.813-1.3,3.787-.882,5.382.085.321.165.625.218.9l.01.054-.01.055c-.126.723-.264,1.661-.411,2.655-.252,1.706-.512,3.47-.741,4.339l-.016.061-.039.05a24.383,24.383,0,0,0-1.74,3.4c-1.139,2.714-1.882,7.454-2.374,10.59-.072.462-.139.883-.2,1.251",
    transform: "translate(-43.772 -264.639)",
    fill: "#09f"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17845",
    "data-name": "Path 17845",
    d: "M72.3,342.034c.218,1.915-.373,3.8.229,5.548.027.181.044.89.076,1.083.4,2.265,5.306,4.558,9.4,2.384.023-.281,0-.575.019-1.095a6.072,6.072,0,0,1,.138-1.3c-.005-1.233-.4-1.863-.21-3.235.384-2.791,1.968-5.473,1.092-7.669a2.352,2.352,0,0,0-.891-.992c-.968-.759-5.973-3.246-7.49-3.422-4.406-.557-2.6,6.623-2.362,8.7",
    transform: "translate(-48.774 -229.34)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17846",
    "data-name": "Path 17846",
    d: "M77.781,351.541a8.49,8.49,0,0,1-3.563-.779,4.269,4.269,0,0,1-2.6-2.733c-.019-.113-.03-.318-.046-.618-.009-.17-.019-.36-.028-.447a8.715,8.715,0,0,1-.235-3.322,13.259,13.259,0,0,0,0-2.26c-.03-.266-.088-.624-.155-1.038-.352-2.184-.94-5.84.575-7.356a2.618,2.618,0,0,1,2.3-.65c1.581.183,6.635,2.692,7.65,3.488l.087.068a2.437,2.437,0,0,1,.9,1.055c.611,1.531.119,3.224-.4,5.017a19.9,19.9,0,0,0-.671,2.807,5.5,5.5,0,0,0,.074,1.842,7.921,7.921,0,0,1,.139,1.35,2.381,2.381,0,0,1-.069.477,2.288,2.288,0,0,0-.072.781l0,.03v.03c-.011.256-.01.456-.009.627s0,.332-.01.479l-.014.169-.152.081a7.855,7.855,0,0,1-3.7.907m-5.837-10.23a13.693,13.693,0,0,1,0,2.365,8.059,8.059,0,0,0,.213,3.119l.013.054c.015.1.025.3.037.53.011.206.024.463.038.548A3.732,3.732,0,0,0,74.5,350.2a7.634,7.634,0,0,0,6.523-.033c0-.08,0-.165,0-.259,0-.172,0-.373.008-.627a2.848,2.848,0,0,1,.083-.968,2.139,2.139,0,0,0,.056-.349,7.4,7.4,0,0,0-.131-1.253,6.088,6.088,0,0,1-.077-2.025,20.412,20.412,0,0,1,.689-2.894c.491-1.689.955-3.284.421-4.621a1.86,1.86,0,0,0-.7-.793l-.089-.069c-.9-.7-5.88-3.188-7.328-3.355a1.987,1.987,0,0,0-1.763.466c-1.292,1.293-.712,4.891-.4,6.824.068.422.126.787.158,1.066",
    transform: "translate(-48.096 -228.651)",
    fill: "#09f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11712",
    "data-name": "Group 11712",
    transform: "translate(30.753 107.246)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11711",
    "data-name": "Group 11711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11710",
    "data-name": "Group 11710",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17847",
    "data-name": "Path 17847",
    d: "M98.61,352.659c.568-2.661,1.644-5.172.982-7.324a2.922,2.922,0,0,0-.891-1.287c-.968-.984-1.07,1.676-2.587,1.448-.292,3.537.986,6.741,2.5,7.163",
    transform: "translate(-96.072 -343.828)",
    fill: "#09f",
    fillRule: "evenodd"
  }))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17848",
    "data-name": "Path 17848",
    d: "M81.668,316.951a10.293,10.293,0,0,0,.111,2.352c-1.435-.046-3.428-.412-3.646-1.454.01-.125.019-.252.026-.376a.5.5,0,0,0-.059-.045,7.789,7.789,0,0,1-1.912-1.192,3.1,3.1,0,0,1-.653-3.605,3.555,3.555,0,0,1,5.971-.5c.329.381.088.774.276,1.142.036.072.172.1.328.23a5.4,5.4,0,0,1,.829,2.466c-.007.317-.752.763-1.083.937a.9.9,0,0,1-.189.048",
    transform: "translate(-51.131 -213.815)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17849",
    "data-name": "Path 17849",
    d: "M81.489,318.939l-.4-.013c-.849-.027-3.642-.23-3.949-1.7l-.009-.043,0-.044c.005-.064.01-.128.015-.192-.144-.085-.3-.163-.466-.242a4.4,4.4,0,0,1-1.416-.948,3.388,3.388,0,0,1-.7-3.951,3.71,3.71,0,0,1,2.888-2.038,4.188,4.188,0,0,1,3.613,1.475,1.2,1.2,0,0,1,.268.856.976.976,0,0,0,.032.305l.024.013a1.667,1.667,0,0,1,.24.158,5.42,5.42,0,0,1,.946,2.713c-.009.455-.685.906-1.25,1.2l-.036.017a10.062,10.062,0,0,0,.12,2.053Zm-3.709-1.8c.188.671,1.585,1.051,2.948,1.147a11.036,11.036,0,0,1-.056-2.044L80.69,316l.241-.045a1.109,1.109,0,0,0,.12-.026,2.434,2.434,0,0,0,.894-.675,5.532,5.532,0,0,0-.726-2.212,1.116,1.116,0,0,0-.142-.089.578.578,0,0,1-.258-.232,1.3,1.3,0,0,1-.117-.621.612.612,0,0,0-.117-.459,3.542,3.542,0,0,0-3.05-1.258,3.04,3.04,0,0,0-2.392,1.7,2.828,2.828,0,0,0,.608,3.259,3.9,3.9,0,0,0,1.221.8,6.04,6.04,0,0,1,.628.337.838.838,0,0,1,.1.073l.113.1-.008.148c-.006.111-.013.225-.022.337",
    transform: "translate(-50.455 -213.127)",
    fill: "#09f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17850",
    "data-name": "Path 17850",
    d: "M87.021,328.329a10.293,10.293,0,0,0,.111,2.352c-1.435-.046-3.428-.412-3.646-1.454.01-.125.019-.252.026-.376-.02-.017-.041-.029-.059-.045-1.09-1,.368-2.137,2.211-1.154a1.439,1.439,0,0,0,1.356.677",
    transform: "translate(-56.485 -225.192)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17851",
    "data-name": "Path 17851",
    d: "M86.836,330.323l-.4-.013c-.849-.027-3.642-.23-3.949-1.7l-.009-.043,0-.044c.006-.072.012-.144.016-.217a1.061,1.061,0,0,1-.23-1.459c.433-.582,1.584-.831,2.865-.148l.073.039.044.069a1.12,1.12,0,0,0,1.068.531l.363-.019-.027.353a10.063,10.063,0,0,0,.107,2.274Zm-3.709-1.8c.188.671,1.585,1.051,2.949,1.147a11.325,11.325,0,0,1-.074-1.72,1.735,1.735,0,0,1-1.242-.74c-.976-.493-1.749-.3-1.971,0-.194.26.043.542.2.686a.432.432,0,0,1,.054.041l.113.1-.008.148c-.006.111-.013.225-.022.337",
    transform: "translate(-55.802 -224.51)",
    fill: "#09f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17852",
    "data-name": "Path 17852",
    d: "M82.7,333.412c-.424.128-.821.554-.743.827.423,1.685,3.588,2.061,5.557,1.656.024-.005-.737-.986-1.114-1.106-1.239.119-3.318-.382-3.7-1.377",
    transform: "translate(-55.713 -229.415)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17853",
    "data-name": "Path 17853",
    d: "M85.25,335.51c-1.887,0-3.924-.588-4.29-2.045-.133-.468.406-1.032.96-1.2l.288-.087.106.275c.294.765,2.128,1.294,3.368,1.176l.067-.006.063.02c.355.113,1.351,1.121,1.335,1.418l-.013.239-.241.05a8.256,8.256,0,0,1-1.644.158m-3.374-2.536a.663.663,0,0,0-.295.344c.332,1.321,2.818,1.738,4.672,1.507a3.358,3.358,0,0,0-.592-.566c-1.257.093-3.122-.342-3.785-1.285",
    transform: "translate(-55.031 -228.567)",
    fill: "#09f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17854",
    "data-name": "Path 17854",
    d: "M77.658,315.293c-.525-.546-1.413-.808-1.983-1.444a2.611,2.611,0,0,1-.8-2.578c-.662-2.031,1.6-3.642,3.505-4.008a1.452,1.452,0,0,1,1.586,2.13,1.915,1.915,0,0,1,.458,1.485,1.328,1.328,0,0,0,.1,1.087c.15.343.524,1.172-.153.647-.438-.339-.744.41-.6.928a2.315,2.315,0,0,1,.1,1c-.127,1.087-1.916,1.056-2.208.752",
    transform: "translate(-50.826 -211.4)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17855",
    "data-name": "Path 17855",
    d: "M77.711,315.1a1.4,1.4,0,0,1-.966-.282,3.972,3.972,0,0,0-.843-.6,4.612,4.612,0,0,1-1.146-.854,2.876,2.876,0,0,1-.9-2.79,2.6,2.6,0,0,1,.307-2.107,5.457,5.457,0,0,1,3.473-2.2,1.776,1.776,0,0,1,1.824.693,1.73,1.73,0,0,1,.2,1.706,2.236,2.236,0,0,1,.4,1.578,1.058,1.058,0,0,0,.076.909c.209.478.414.945.106,1.174-.278.207-.611-.051-.753-.161l-.005,0a.783.783,0,0,0-.083.6,2.624,2.624,0,0,1,.1,1.12,1.314,1.314,0,0,1-1,1.094,2.672,2.672,0,0,1-.795.118m-.5-.713a1.728,1.728,0,0,0,1.2-.035.653.653,0,0,0,.461-.534,2.024,2.024,0,0,0-.085-.882,1.258,1.258,0,0,1,.367-1.313.58.58,0,0,1,.457-.08l-.051-.118a1.641,1.641,0,0,1-.128-1.291,1.607,1.607,0,0,0-.383-1.221l-.157-.171.121-.2a1.1,1.1,0,0,0-.074-1.224,1.13,1.13,0,0,0-1.176-.439,4.781,4.781,0,0,0-3.046,1.906,1.975,1.975,0,0,0-.216,1.7l.033.1-.038.1a2.339,2.339,0,0,0,.743,2.265,4.138,4.138,0,0,0,1,.731,4.533,4.533,0,0,1,.974.7",
    transform: "translate(-50.148 -210.713)",
    fill: "#09f"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17856",
    "data-name": "Path 17856",
    d: "M141.781,315.733c.422-.382.741-.842,1.221-1.341a39.793,39.793,0,0,1,3.438-2.657c.362-.288.674.316.373.609s-1.1,1.017-1.1,1.019l-.036.023a1.906,1.906,0,0,1,.453,1.181c.01.489-.932,1.3-1.511,1.868-.512.5-1.352.212-1.689.6-.74-.173-.934-.676-1.147-1.3",
    transform: "translate(-96.396 -214.448)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17857",
    "data-name": "Path 17857",
    d: "M142.261,316.695l-.191-.045a1.877,1.877,0,0,1-1.376-1.505l-.065-.19.151-.137a7.257,7.257,0,0,0,.641-.692c.173-.2.351-.412.564-.633a16.779,16.779,0,0,1,2.217-1.763c.455-.324.885-.63,1.251-.922a.588.588,0,0,1,.823.047.748.748,0,0,1-.021,1.025c-.091.088-.623.584-.932.865a2.3,2.3,0,0,1,.341,1.131c.01.51-.543,1.078-1.325,1.825-.1.094-.193.184-.279.269a1.84,1.84,0,0,1-1.158.44.958.958,0,0,0-.515.14Zm-.9-1.562c.16.445.312.727.7.867a1.741,1.741,0,0,1,.757-.209,1.275,1.275,0,0,0,.781-.26c.088-.087.185-.179.286-.274.4-.38,1.138-1.087,1.133-1.368a1.6,1.6,0,0,0-.37-.977l-.26-.279.329-.2c.02-.016.791-.717,1.079-1a.1.1,0,0,0,.027-.078.17.17,0,0,0-.006-.041c-.381.3-.8.6-1.244.914a16.332,16.332,0,0,0-2.128,1.686c-.2.207-.372.41-.539.605-.182.213-.355.417-.548.608",
    transform: "translate(-95.613 -213.761)",
    fill: "#09f"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17858",
    "data-name": "Path 17858",
    d: "M97.643,330.14c.248-.113,6.064-.89,7.108-.946a24.477,24.477,0,0,1,4.7-3.958,4.286,4.286,0,0,0,.814-.366c.178-.159.434-.394.533-.474a3.124,3.124,0,0,1,1.342,1.323c-.174.22-.346.453-.515.7-.126.181-.163.651-.287.84A37.554,37.554,0,0,1,107.773,331a4.2,4.2,0,0,1-1.444,1.178c-.436.191-1,.43-1.512.633a31.239,31.239,0,0,1-5.6,1.771,2.359,2.359,0,0,1-1.571-4.442",
    transform: "translate(-65.408 -223.211)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17859",
    "data-name": "Path 17859",
    d: "M97.907,334.177a2.52,2.52,0,0,1-2.572-1.724,2.82,2.82,0,0,1,1.5-3.364c.347-.158,5.921-.867,7.1-.965.514-.528,3.162-3.2,4.712-3.936.1-.048.22-.092.339-.136a1.779,1.779,0,0,0,.4-.179l.157-.141c.153-.138.315-.284.39-.344l.133-.108.165.05a3.4,3.4,0,0,1,1.523,1.463l.109.182-.132.167c-.161.2-.326.426-.5.681a1.654,1.654,0,0,0-.1.321,1.68,1.68,0,0,1-.183.512,17.91,17.91,0,0,1-2.405,2.6c-.447.428-.868.831-1.195,1.182l-.112.12a4.138,4.138,0,0,1-1.438,1.132c-.389.171-.97.42-1.524.638l-.111.044a30.991,30.991,0,0,1-5.56,1.746,4.447,4.447,0,0,1-.687.056m-.813-4.517a2.191,2.191,0,0,0-1.147,2.61,2.061,2.061,0,0,0,2.545,1.236,30.423,30.423,0,0,0,5.422-1.708l.111-.044c.544-.214,1.117-.459,1.5-.628a3.534,3.534,0,0,0,1.226-.981l.113-.122c.339-.363.767-.773,1.22-1.207a17.545,17.545,0,0,0,2.315-2.5,1.647,1.647,0,0,0,.1-.322,1.608,1.608,0,0,1,.193-.526c.136-.2.266-.373.392-.538a3.238,3.238,0,0,0-.9-.938l-.216.194-.158.142a1.919,1.919,0,0,1-.6.3c-.1.037-.2.074-.287.115a24.3,24.3,0,0,0-4.608,3.888l-.088.093-.13.007c-1.07.057-6.573.8-7,.923",
    transform: "translate(-64.737 -222.443)",
    fill: "#09f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17860",
    "data-name": "Path 17860",
    d: "M517.249,297.013l-31.528-17.147a11.509,11.509,0,0,1-6.079-10.089V250.394a5.949,5.949,0,0,1,8.8-5.215l31.153,16.943a10.837,10.837,0,0,1,6.194,9.75v20.257a5.74,5.74,0,0,1-8.537,4.884",
    transform: "translate(-326.106 -168.176)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17861",
    "data-name": "Path 17861",
    d: "M519.367,297.353a6.171,6.171,0,0,1-2.954-.757l-31.528-17.147a11.83,11.83,0,0,1-6.243-10.362V249.7a6.219,6.219,0,0,1,3.3-5.506,6,6,0,0,1,5.985.024l31.144,16.937a11.091,11.091,0,0,1,6.358,10.023v20.257a5.822,5.822,0,0,1-2.992,5.092,6.165,6.165,0,0,1-3.067.821m-34.422-53.317a5.725,5.725,0,0,0-5.663,5.668v19.383A11.209,11.209,0,0,0,485.2,278.9l31.528,17.147a5.492,5.492,0,0,0,5.385-.057,5.209,5.209,0,0,0,2.676-4.554V271.182a10.484,10.484,0,0,0-6.02-9.473L487.6,244.761a5.209,5.209,0,0,0-2.657-.725",
    transform: "translate(-325.426 -167.486)",
    fill: "#09f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17862",
    "data-name": "Path 17862",
    d: "M510.424,299.4l-31.349-17.05a11.444,11.444,0,0,1-6.044-10.032V253.047a6.094,6.094,0,0,1,9.064-5.185l30.976,16.847a11.059,11.059,0,0,1,5.841,9.695v20.143a5.707,5.707,0,0,1-8.489,4.856",
    transform: "translate(-321.611 -170.025)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17863",
    "data-name": "Path 17863",
    d: "M512.526,299.738a6.145,6.145,0,0,1-2.939-.753l-31.349-17.05a11.764,11.764,0,0,1-6.208-10.3V252.359a6.165,6.165,0,0,1,3.167-5.39,6.5,6.5,0,0,1,6.374-.067l30.976,16.847a11.379,11.379,0,0,1,6.005,9.967v20.142a5.791,5.791,0,0,1-2.976,5.065,6.131,6.131,0,0,1-3.05.817m-2.627-1.3a5.459,5.459,0,0,0,5.353-.057,5.177,5.177,0,0,0,2.659-4.527V273.715a10.758,10.758,0,0,0-5.677-9.423l-30.977-16.847a5.85,5.85,0,0,0-5.737.061,5.548,5.548,0,0,0-2.851,4.852v19.273a11.142,11.142,0,0,0,5.88,9.76Z",
    transform: "translate(-320.93 -169.337)",
    fill: "#09f"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17864",
    "data-name": "Path 17864",
    d: "M502.515,279.175a8.579,8.579,0,0,1-7.492-4.313l-13.871-24.827.562-.3,13.87,24.827a7.982,7.982,0,0,0,9.142,3.679l18.526-7.228.238.579-18.554,7.238a8.687,8.687,0,0,1-2.423.344",
    transform: "translate(-327.132 -171.84)",
    fill: "#09f"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18301",
    "data-name": "Path 18301",
    d: "M0,0,.639.005.846,25.18l-.639-.005Z",
    transform: "matrix(0.943, -0.333, 0.333, 0.943, 179.934, 105.811)",
    fill: "#09f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18302",
    "data-name": "Path 18302",
    d: "M0,0,16.186.132l.005.626L.005.626Z",
    transform: "translate(152.788 107.937) rotate(-19.802)",
    fill: "#09f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11717",
    "data-name": "Group 11717",
    transform: "translate(76.226 190.381)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11716",
    "data-name": "Group 11716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11715",
    "data-name": "Group 11715",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11714",
    "data-name": "Group 11714",
    transform: "translate(1.188 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11713",
    "data-name": "Group 11713",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17865",
    "data-name": "Path 17865",
    d: "M238.127,615.5l9.685-4.924,5.114,9.551h-14.8Z",
    transform: "translate(-239.316 -610.509)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17866",
    "data-name": "Path 17866",
    d: "M268.383,610.478l.089-.045,5.138,9.6H273.5Z",
    transform: "translate(-259.886 -610.409)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17867",
    "data-name": "Path 17867",
    d: "M268.661,610.381l.046-.023h.055l5.151,9.619H273.8Z",
    transform: "translate(-260.075 -610.358)",
    fill: "#feffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17868",
    "data-name": "Path 17868",
    d: "M269.09,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-260.29 -610.358)",
    fill: "#fdfeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17869",
    "data-name": "Path 17869",
    d: "M269.444,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-260.53 -610.358)",
    fill: "#fcfeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17870",
    "data-name": "Path 17870",
    d: "M269.8,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-260.771 -610.358)",
    fill: "#fbfdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17871",
    "data-name": "Path 17871",
    d: "M270.152,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-261.012 -610.358)",
    fill: "#fafdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17872",
    "data-name": "Path 17872",
    d: "M270.506,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-261.253 -610.358)",
    fill: "#f9fdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17873",
    "data-name": "Path 17873",
    d: "M270.86,610.358l5.15,9.619H275.9l-5.15-9.619Z",
    transform: "translate(-261.493 -610.358)",
    fill: "#f8fcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17874",
    "data-name": "Path 17874",
    d: "M271.214,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-261.734 -610.358)",
    fill: "#f7fcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17875",
    "data-name": "Path 17875",
    d: "M271.568,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-261.975 -610.358)",
    fill: "#f6fbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17876",
    "data-name": "Path 17876",
    d: "M271.922,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-262.215 -610.358)",
    fill: "#f5fbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17877",
    "data-name": "Path 17877",
    d: "M272.276,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-262.456 -610.358)",
    fill: "#f4fbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17878",
    "data-name": "Path 17878",
    d: "M272.63,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-262.697 -610.358)",
    fill: "#f3faff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17879",
    "data-name": "Path 17879",
    d: "M272.984,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-262.937 -610.358)",
    fill: "#f2faff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17880",
    "data-name": "Path 17880",
    d: "M273.338,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-263.178 -610.358)",
    fill: "#f1f9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17881",
    "data-name": "Path 17881",
    d: "M273.692,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-263.419 -610.358)",
    fill: "#f0f9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17882",
    "data-name": "Path 17882",
    d: "M274.046,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-263.659 -610.358)",
    fill: "#eff9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17883",
    "data-name": "Path 17883",
    d: "M274.4,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-263.9 -610.358)",
    fill: "#eef8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17884",
    "data-name": "Path 17884",
    d: "M274.754,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-264.141 -610.358)",
    fill: "#edf8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17885",
    "data-name": "Path 17885",
    d: "M275.108,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-264.381 -610.358)",
    fill: "#ecf7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17886",
    "data-name": "Path 17886",
    d: "M275.462,610.358l5.15,9.619H280.5l-5.15-9.619Z",
    transform: "translate(-264.622 -610.358)",
    fill: "#ebf7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17887",
    "data-name": "Path 17887",
    d: "M275.816,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-264.863 -610.358)",
    fill: "#eaf7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17888",
    "data-name": "Path 17888",
    d: "M276.17,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-265.104 -610.358)",
    fill: "#e9f6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17889",
    "data-name": "Path 17889",
    d: "M276.524,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-265.344 -610.358)",
    fill: "#e8f6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17890",
    "data-name": "Path 17890",
    d: "M276.878,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-265.585 -610.358)",
    fill: "#e7f5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17891",
    "data-name": "Path 17891",
    d: "M277.232,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-265.826 -610.358)",
    fill: "#e6f5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17892",
    "data-name": "Path 17892",
    d: "M277.586,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-266.066 -610.358)",
    fill: "#e5f5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17893",
    "data-name": "Path 17893",
    d: "M277.94,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-266.307 -610.358)",
    fill: "#e4f4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17894",
    "data-name": "Path 17894",
    d: "M278.294,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-266.548 -610.358)",
    fill: "#e3f4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17895",
    "data-name": "Path 17895",
    d: "M278.648,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-266.788 -610.358)",
    fill: "#e2f3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17896",
    "data-name": "Path 17896",
    d: "M279,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-267.029 -610.358)",
    fill: "#e1f3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17897",
    "data-name": "Path 17897",
    d: "M279.356,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-267.27 -610.358)",
    fill: "#e0f3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17898",
    "data-name": "Path 17898",
    d: "M279.71,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-267.51 -610.358)",
    fill: "#dff2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17899",
    "data-name": "Path 17899",
    d: "M280.064,610.358l5.15,9.619H285.1l-5.15-9.619Z",
    transform: "translate(-267.751 -610.358)",
    fill: "#def2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17900",
    "data-name": "Path 17900",
    d: "M280.418,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-267.992 -610.358)",
    fill: "#ddf1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17901",
    "data-name": "Path 17901",
    d: "M280.772,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-268.232 -610.358)",
    fill: "#dcf1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17902",
    "data-name": "Path 17902",
    d: "M281.126,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-268.473 -610.358)",
    fill: "#dbf1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17903",
    "data-name": "Path 17903",
    d: "M281.48,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-268.714 -610.358)",
    fill: "#daf0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17904",
    "data-name": "Path 17904",
    d: "M281.834,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-268.955 -610.358)",
    fill: "#d9f0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17905",
    "data-name": "Path 17905",
    d: "M282.188,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-269.195 -610.358)",
    fill: "#d8efff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17906",
    "data-name": "Path 17906",
    d: "M282.542,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-269.436 -610.358)",
    fill: "#d7efff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17907",
    "data-name": "Path 17907",
    d: "M282.9,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-269.677 -610.358)",
    fill: "#d6efff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17908",
    "data-name": "Path 17908",
    d: "M283.25,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-269.917 -610.358)",
    fill: "#d5eeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17909",
    "data-name": "Path 17909",
    d: "M283.6,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-270.158 -610.358)",
    fill: "#d4eeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17910",
    "data-name": "Path 17910",
    d: "M283.958,610.358l5.151,9.619H289l-5.151-9.619Z",
    transform: "translate(-270.399 -610.358)",
    fill: "#d3edff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17911",
    "data-name": "Path 17911",
    d: "M284.312,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-270.639 -610.358)",
    fill: "#d2edff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17912",
    "data-name": "Path 17912",
    d: "M284.666,610.358l5.15,9.619H289.7l-5.15-9.619Z",
    transform: "translate(-270.88 -610.358)",
    fill: "#d1edff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17913",
    "data-name": "Path 17913",
    d: "M285.02,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-271.121 -610.358)",
    fill: "#d0ecff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17914",
    "data-name": "Path 17914",
    d: "M285.374,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-271.361 -610.358)",
    fill: "#cfecff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17915",
    "data-name": "Path 17915",
    d: "M285.728,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-271.602 -610.358)",
    fill: "#ceebff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17916",
    "data-name": "Path 17916",
    d: "M286.082,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-271.843 -610.358)",
    fill: "#cdebff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17917",
    "data-name": "Path 17917",
    d: "M286.436,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-272.084 -610.358)",
    fill: "#ccebff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17918",
    "data-name": "Path 17918",
    d: "M286.79,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-272.324 -610.358)",
    fill: "#cbeaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17919",
    "data-name": "Path 17919",
    d: "M287.144,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-272.565 -610.358)",
    fill: "#caeaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17920",
    "data-name": "Path 17920",
    d: "M287.5,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-272.806 -610.358)",
    fill: "#c9e9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17921",
    "data-name": "Path 17921",
    d: "M287.852,610.358,293,619.977h-.114l-5.15-9.619Z",
    transform: "translate(-273.046 -610.358)",
    fill: "#c8e9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17922",
    "data-name": "Path 17922",
    d: "M288.206,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-273.287 -610.358)",
    fill: "#c7e9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17923",
    "data-name": "Path 17923",
    d: "M288.56,610.358l5.151,9.619H293.6l-5.151-9.619Z",
    transform: "translate(-273.528 -610.358)",
    fill: "#c6e8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17924",
    "data-name": "Path 17924",
    d: "M288.914,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-273.768 -610.358)",
    fill: "#c5e8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17925",
    "data-name": "Path 17925",
    d: "M289.268,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-274.009 -610.358)",
    fill: "#c4e7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17926",
    "data-name": "Path 17926",
    d: "M289.622,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-274.25 -610.358)",
    fill: "#c3e7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17927",
    "data-name": "Path 17927",
    d: "M289.976,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-274.49 -610.358)",
    fill: "#c2e7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17928",
    "data-name": "Path 17928",
    d: "M290.331,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-274.731 -610.358)",
    fill: "#c1e6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17929",
    "data-name": "Path 17929",
    d: "M290.685,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-274.972 -610.358)",
    fill: "#c0e6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17930",
    "data-name": "Path 17930",
    d: "M291.039,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-275.213 -610.358)",
    fill: "#bfe5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17931",
    "data-name": "Path 17931",
    d: "M291.393,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-275.453 -610.358)",
    fill: "#bee5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17932",
    "data-name": "Path 17932",
    d: "M291.747,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-275.694 -610.358)",
    fill: "#bde4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17933",
    "data-name": "Path 17933",
    d: "M292.1,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-275.935 -610.358)",
    fill: "#bce4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17934",
    "data-name": "Path 17934",
    d: "M292.454,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-276.175 -610.358)",
    fill: "#bbe4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17935",
    "data-name": "Path 17935",
    d: "M292.809,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-276.416 -610.358)",
    fill: "#bae3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17936",
    "data-name": "Path 17936",
    d: "M293.163,610.358l5.151,9.619H298.2l-5.15-9.619Z",
    transform: "translate(-276.657 -610.358)",
    fill: "#b9e3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17937",
    "data-name": "Path 17937",
    d: "M293.517,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-276.897 -610.358)",
    fill: "#b8e2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17938",
    "data-name": "Path 17938",
    d: "M293.871,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-277.138 -610.358)",
    fill: "#b7e2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17939",
    "data-name": "Path 17939",
    d: "M294.225,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-277.379 -610.358)",
    fill: "#b6e2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17940",
    "data-name": "Path 17940",
    d: "M294.579,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-277.619 -610.358)",
    fill: "#b5e1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17941",
    "data-name": "Path 17941",
    d: "M294.933,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-277.86 -610.358)",
    fill: "#b4e1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17942",
    "data-name": "Path 17942",
    d: "M295.287,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-278.101 -610.358)",
    fill: "#b3e0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17943",
    "data-name": "Path 17943",
    d: "M295.641,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-278.341 -610.358)",
    fill: "#b2e0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17944",
    "data-name": "Path 17944",
    d: "M295.995,610.358l5.151,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-278.582 -610.358)",
    fill: "#b1e0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17945",
    "data-name": "Path 17945",
    d: "M296.349,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-278.823 -610.358)",
    fill: "#b0dfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17946",
    "data-name": "Path 17946",
    d: "M296.7,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-279.064 -610.358)",
    fill: "#afdfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17947",
    "data-name": "Path 17947",
    d: "M297.057,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-279.304 -610.358)",
    fill: "#aedeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17948",
    "data-name": "Path 17948",
    d: "M297.411,610.358l5.151,9.619h-.113l-5.151-9.619Z",
    transform: "translate(-279.545 -610.358)",
    fill: "#addeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17949",
    "data-name": "Path 17949",
    d: "M297.765,610.358l5.151,9.619H302.8l-5.15-9.619Z",
    transform: "translate(-279.786 -610.358)",
    fill: "#acdeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17950",
    "data-name": "Path 17950",
    d: "M298.119,610.358l5.15,9.619h-.113l-5.15-9.619Z",
    transform: "translate(-280.026 -610.358)",
    fill: "#abddff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17951",
    "data-name": "Path 17951",
    d: "M298.473,610.358l5.151,9.619h-.114l-5.15-9.619Z",
    transform: "translate(-280.267 -610.358)",
    fill: "#adf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17952",
    "data-name": "Path 17952",
    d: "M298.827,610.358l5.13,9.581-.074.038h-.019l-5.15-9.619Z",
    transform: "translate(-280.508 -610.358)",
    fill: "#a9dcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17953",
    "data-name": "Path 17953",
    d: "M299.181,610.358l5.106,9.536-.089.045-5.13-9.581Z",
    transform: "translate(-280.748 -610.358)",
    fill: "#a8dcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17954",
    "data-name": "Path 17954",
    d: "M299.535,610.358l5.082,9.491-.089.045-5.106-9.536Z",
    transform: "translate(-280.989 -610.358)",
    fill: "#a7dcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17955",
    "data-name": "Path 17955",
    d: "M299.889,610.358l5.057,9.445-.089.046-5.082-9.491Z",
    transform: "translate(-281.23 -610.358)",
    fill: "#a6dbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17956",
    "data-name": "Path 17956",
    d: "M300.243,610.358l5.033,9.4-.089.045-5.057-9.445Z",
    transform: "translate(-281.47 -610.358)",
    fill: "#a5dbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17957",
    "data-name": "Path 17957",
    d: "M300.6,610.358l5.009,9.355-.089.045-5.033-9.4Z",
    transform: "translate(-281.711 -610.358)",
    fill: "#a4daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17958",
    "data-name": "Path 17958",
    d: "M300.951,610.358l4.985,9.31-.089.045-5.009-9.355Z",
    transform: "translate(-281.952 -610.358)",
    fill: "#a3daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17959",
    "data-name": "Path 17959",
    d: "M301.3,610.358l4.96,9.264-.089.045-4.985-9.31Z",
    transform: "translate(-282.193 -610.358)",
    fill: "#a2daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17960",
    "data-name": "Path 17960",
    d: "M301.659,610.358l4.936,9.219-.089.045-4.96-9.264Z",
    transform: "translate(-282.433 -610.358)",
    fill: "#a1d9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17961",
    "data-name": "Path 17961",
    d: "M302.013,610.358l4.912,9.173-.089.046-4.936-9.219Z",
    transform: "translate(-282.674 -610.358)",
    fill: "#a0d9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17962",
    "data-name": "Path 17962",
    d: "M302.367,610.358l4.888,9.128-.089.045-4.912-9.173Z",
    transform: "translate(-282.915 -610.358)",
    fill: "#9fd8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17963",
    "data-name": "Path 17963",
    d: "M302.721,610.358l4.863,9.083-.089.045-4.888-9.128Z",
    transform: "translate(-283.155 -610.358)",
    fill: "#9ed8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17964",
    "data-name": "Path 17964",
    d: "M303.075,610.358l4.839,9.038-.089.045-4.863-9.083Z",
    transform: "translate(-283.396 -610.358)",
    fill: "#9dd8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17965",
    "data-name": "Path 17965",
    d: "M303.429,610.358l4.815,8.993-.089.045-4.839-9.038Z",
    transform: "translate(-283.637 -610.358)",
    fill: "#9cd7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17966",
    "data-name": "Path 17966",
    d: "M303.783,610.358l4.791,8.947-.089.046-4.815-8.993Z",
    transform: "translate(-283.877 -610.358)",
    fill: "#9bd7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17967",
    "data-name": "Path 17967",
    d: "M304.137,610.358l4.766,8.9-.089.045-4.791-8.947Z",
    transform: "translate(-284.118 -610.358)",
    fill: "#9ad6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17968",
    "data-name": "Path 17968",
    d: "M304.491,610.358l4.742,8.857-.089.045-4.766-8.9Z",
    transform: "translate(-284.359 -610.358)",
    fill: "#99d6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17969",
    "data-name": "Path 17969",
    d: "M304.845,610.358l4.718,8.811-.089.045-4.742-8.857Z",
    transform: "translate(-284.599 -610.358)",
    fill: "#98d6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17970",
    "data-name": "Path 17970",
    d: "M305.2,610.358l4.694,8.766-.089.045-4.718-8.811Z",
    transform: "translate(-284.84 -610.358)",
    fill: "#97d5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17971",
    "data-name": "Path 17971",
    d: "M305.553,610.358l4.669,8.721-.089.045-4.694-8.766Z",
    transform: "translate(-285.081 -610.358)",
    fill: "#96d5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17972",
    "data-name": "Path 17972",
    d: "M305.907,610.358l4.645,8.675-.089.046-4.669-8.721Z",
    transform: "translate(-285.321 -610.358)",
    fill: "#95d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17973",
    "data-name": "Path 17973",
    d: "M306.261,610.358l4.621,8.63-.089.045-4.645-8.675Z",
    transform: "translate(-285.562 -610.358)",
    fill: "#94d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17974",
    "data-name": "Path 17974",
    d: "M306.615,610.358l4.6,8.585-.089.045-4.621-8.63Z",
    transform: "translate(-285.803 -610.358)",
    fill: "#93d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17975",
    "data-name": "Path 17975",
    d: "M306.969,610.358l4.572,8.54-.089.045-4.6-8.585Z",
    transform: "translate(-286.044 -610.358)",
    fill: "#92d3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17976",
    "data-name": "Path 17976",
    d: "M307.323,610.358l4.548,8.494-.089.045-4.572-8.54Z",
    transform: "translate(-286.284 -610.358)",
    fill: "#91d3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17977",
    "data-name": "Path 17977",
    d: "M307.677,610.358l4.524,8.449-.089.046-4.548-8.494Z",
    transform: "translate(-286.525 -610.358)",
    fill: "#90d2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17978",
    "data-name": "Path 17978",
    d: "M308.031,610.358l4.5,8.4-.089.045-4.524-8.449Z",
    transform: "translate(-286.766 -610.358)",
    fill: "#8fd2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17979",
    "data-name": "Path 17979",
    d: "M308.385,610.358l4.475,8.358-.089.045-4.5-8.4Z",
    transform: "translate(-287.006 -610.358)",
    fill: "#8ed2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17980",
    "data-name": "Path 17980",
    d: "M308.739,610.358l4.451,8.313-.089.045-4.475-8.358Z",
    transform: "translate(-287.247 -610.358)",
    fill: "#8dd1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17981",
    "data-name": "Path 17981",
    d: "M309.093,610.358l4.427,8.268-.089.045-4.451-8.313Z",
    transform: "translate(-287.488 -610.358)",
    fill: "#8cd1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17982",
    "data-name": "Path 17982",
    d: "M309.447,610.358l4.4,8.223-.089.045-4.427-8.268Z",
    transform: "translate(-287.728 -610.358)",
    fill: "#8bd0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17983",
    "data-name": "Path 17983",
    d: "M309.8,610.358l4.378,8.177-.089.046-4.4-8.223Z",
    transform: "translate(-287.969 -610.358)",
    fill: "#8ad0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17984",
    "data-name": "Path 17984",
    d: "M310.155,610.358l4.354,8.132-.089.045-4.378-8.177Z",
    transform: "translate(-288.21 -610.358)",
    fill: "#89d0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17985",
    "data-name": "Path 17985",
    d: "M310.509,610.358l4.33,8.087-.089.045-4.354-8.132Z",
    transform: "translate(-288.45 -610.358)",
    fill: "#88cfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17986",
    "data-name": "Path 17986",
    d: "M310.863,610.358l4.306,8.042-.089.045-4.33-8.087Z",
    transform: "translate(-288.691 -610.358)",
    fill: "#87cfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17987",
    "data-name": "Path 17987",
    d: "M311.217,610.358l4.281,8-.089.045-4.306-8.042Z",
    transform: "translate(-288.932 -610.358)",
    fill: "#86ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17988",
    "data-name": "Path 17988",
    d: "M311.571,610.358l4.257,7.951-.089.046-4.281-8Z",
    transform: "translate(-289.173 -610.358)",
    fill: "#85ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17989",
    "data-name": "Path 17989",
    d: "M311.925,610.358l4.233,7.906-.089.045-4.257-7.951Z",
    transform: "translate(-289.413 -610.358)",
    fill: "#84ceff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17990",
    "data-name": "Path 17990",
    d: "M312.279,610.358l4.209,7.86-.089.045-4.233-7.906Z",
    transform: "translate(-289.654 -610.358)",
    fill: "#83cdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17991",
    "data-name": "Path 17991",
    d: "M312.633,610.358l4.184,7.815-.089.045-4.209-7.86Z",
    transform: "translate(-289.895 -610.358)",
    fill: "#82cdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17992",
    "data-name": "Path 17992",
    d: "M312.987,610.358l4.16,7.77-.089.045-4.184-7.815Z",
    transform: "translate(-290.135 -610.358)",
    fill: "#81ccff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17993",
    "data-name": "Path 17993",
    d: "M313.341,610.358l4.136,7.725-.089.045-4.16-7.77Z",
    transform: "translate(-290.376 -610.358)",
    fill: "#80ccff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17994",
    "data-name": "Path 17994",
    d: "M313.7,610.358l4.112,7.679-.089.046-4.136-7.725Z",
    transform: "translate(-290.617 -610.358)",
    fill: "#7eccff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17995",
    "data-name": "Path 17995",
    d: "M314.049,610.358l4.087,7.634-.089.045-4.112-7.679Z",
    transform: "translate(-290.857 -610.358)",
    fill: "#7dcbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17996",
    "data-name": "Path 17996",
    d: "M314.4,610.358l4.063,7.589-.089.045-4.087-7.634Z",
    transform: "translate(-291.098 -610.358)",
    fill: "#7ccbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17997",
    "data-name": "Path 17997",
    d: "M314.757,610.358,318.8,617.9l-.089.045-4.063-7.589Z",
    transform: "translate(-291.339 -610.358)",
    fill: "#7bcaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17998",
    "data-name": "Path 17998",
    d: "M315.111,610.358l4.015,7.5-.089.045L315,610.358Z",
    transform: "translate(-291.579 -610.358)",
    fill: "#7acaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17999",
    "data-name": "Path 17999",
    d: "M315.465,610.358l3.99,7.453-.089.046-4.015-7.5Z",
    transform: "translate(-291.82 -610.358)",
    fill: "#79caff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18000",
    "data-name": "Path 18000",
    d: "M315.819,610.358l3.966,7.407-.089.045-3.99-7.453Z",
    transform: "translate(-292.061 -610.358)",
    fill: "#78c9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18001",
    "data-name": "Path 18001",
    d: "M316.173,610.358l3.942,7.362-.089.045-3.966-7.407Z",
    transform: "translate(-292.302 -610.358)",
    fill: "#77c9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18002",
    "data-name": "Path 18002",
    d: "M316.527,610.358l3.918,7.317-.089.045-3.942-7.362Z",
    transform: "translate(-292.542 -610.358)",
    fill: "#76c8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18003",
    "data-name": "Path 18003",
    d: "M316.881,610.358l3.893,7.272-.089.045-3.918-7.317Z",
    transform: "translate(-292.783 -610.358)",
    fill: "#75c8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18004",
    "data-name": "Path 18004",
    d: "M317.235,610.358l3.869,7.227-.089.045-3.893-7.272Z",
    transform: "translate(-293.024 -610.358)",
    fill: "#74c8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18005",
    "data-name": "Path 18005",
    d: "M317.589,610.358l3.845,7.181-.089.046-3.869-7.227Z",
    transform: "translate(-293.264 -610.358)",
    fill: "#73c7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18006",
    "data-name": "Path 18006",
    d: "M317.943,610.358l3.821,7.136-.089.045-3.845-7.181Z",
    transform: "translate(-293.505 -610.358)",
    fill: "#72c7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18007",
    "data-name": "Path 18007",
    d: "M318.3,610.358l3.8,7.091-.089.045-3.821-7.136Z",
    transform: "translate(-293.746 -610.358)",
    fill: "#71c6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18008",
    "data-name": "Path 18008",
    d: "M318.651,610.358l3.772,7.045-.089.045-3.8-7.091Z",
    transform: "translate(-293.986 -610.358)",
    fill: "#70c6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18009",
    "data-name": "Path 18009",
    d: "M319.005,610.358l3.748,7-.089.045-3.772-7.045Z",
    transform: "translate(-294.227 -610.358)",
    fill: "#6fc6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18010",
    "data-name": "Path 18010",
    d: "M319.359,610.358l3.724,6.955-.089.046-3.748-7Z",
    transform: "translate(-294.468 -610.358)",
    fill: "#6ec5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18011",
    "data-name": "Path 18011",
    d: "M319.713,610.358l3.7,6.909-.089.045-3.724-6.955Z",
    transform: "translate(-294.708 -610.358)",
    fill: "#6dc5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18012",
    "data-name": "Path 18012",
    d: "M320.067,610.358l3.675,6.864-.089.045-3.7-6.909Z",
    transform: "translate(-294.949 -610.358)",
    fill: "#6cc4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18013",
    "data-name": "Path 18013",
    d: "M320.421,610.358l3.651,6.819-.089.045-3.675-6.864Z",
    transform: "translate(-295.19 -610.358)",
    fill: "#6bc4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18014",
    "data-name": "Path 18014",
    d: "M320.775,610.358l3.627,6.774-.089.045-3.651-6.819Z",
    transform: "translate(-295.43 -610.358)",
    fill: "#6ac4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18015",
    "data-name": "Path 18015",
    d: "M321.129,610.358l3.6,6.728-.089.045-3.627-6.774Z",
    transform: "translate(-295.671 -610.358)",
    fill: "#69c3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18016",
    "data-name": "Path 18016",
    d: "M321.483,610.358l3.578,6.683-.089.046-3.6-6.728Z",
    transform: "translate(-295.912 -610.358)",
    fill: "#68c3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18017",
    "data-name": "Path 18017",
    d: "M321.837,610.358,325.392,617l-.089.045-3.578-6.683Z",
    transform: "translate(-296.152 -610.358)",
    fill: "#67c2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18018",
    "data-name": "Path 18018",
    d: "M322.191,610.358l3.53,6.592-.089.045-3.554-6.638Z",
    transform: "translate(-296.393 -610.358)",
    fill: "#66c2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18019",
    "data-name": "Path 18019",
    d: "M322.546,610.358l3.505,6.547-.089.045-3.53-6.592Z",
    transform: "translate(-296.634 -610.358)",
    fill: "#65c2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18020",
    "data-name": "Path 18020",
    d: "M322.9,610.358l3.481,6.5-.089.045-3.505-6.547Z",
    transform: "translate(-296.875 -610.358)",
    fill: "#64c1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18021",
    "data-name": "Path 18021",
    d: "M323.254,610.358l3.457,6.456-.089.046-3.481-6.5Z",
    transform: "translate(-297.115 -610.358)",
    fill: "#63c1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18022",
    "data-name": "Path 18022",
    d: "M323.608,610.358l3.433,6.411-.089.045-3.457-6.456Z",
    transform: "translate(-297.356 -610.358)",
    fill: "#62c0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18023",
    "data-name": "Path 18023",
    d: "M323.962,610.358l3.408,6.366-.089.045-3.433-6.411Z",
    transform: "translate(-297.597 -610.358)",
    fill: "#61c0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18024",
    "data-name": "Path 18024",
    d: "M324.316,610.358l3.384,6.321-.089.045-3.409-6.366Z",
    transform: "translate(-297.837 -610.358)",
    fill: "#60c0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18025",
    "data-name": "Path 18025",
    d: "M324.669,610.358l3.36,6.276-.089.045-3.384-6.321Z",
    transform: "translate(-298.078 -610.358)",
    fill: "#5fbfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18026",
    "data-name": "Path 18026",
    d: "M325.023,610.358l3.336,6.23-.089.045-3.36-6.276Z",
    transform: "translate(-298.319 -610.358)",
    fill: "#5ebfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18027",
    "data-name": "Path 18027",
    d: "M325.378,610.358l3.311,6.185-.089.046-3.336-6.23Z",
    transform: "translate(-298.559 -610.358)",
    fill: "#5dbeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18028",
    "data-name": "Path 18028",
    d: "M325.732,610.358l3.287,6.139-.089.045-3.311-6.185Z",
    transform: "translate(-298.8 -610.358)",
    fill: "#5cbeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18029",
    "data-name": "Path 18029",
    d: "M326.086,610.358l3.263,6.094-.089.045-3.287-6.139Z",
    transform: "translate(-299.041 -610.358)",
    fill: "#5bbeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18030",
    "data-name": "Path 18030",
    d: "M326.44,610.358l3.239,6.049-.089.045-3.263-6.094Z",
    transform: "translate(-299.282 -610.358)",
    fill: "#5abdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18031",
    "data-name": "Path 18031",
    d: "M326.794,610.358l3.215,6-.089.045-3.239-6.049Z",
    transform: "translate(-299.522 -610.358)",
    fill: "#59bdff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18032",
    "data-name": "Path 18032",
    d: "M327.148,610.358l3.19,5.958-.089.046-3.215-6Z",
    transform: "translate(-299.763 -610.358)",
    fill: "#58bcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18033",
    "data-name": "Path 18033",
    d: "M327.5,610.358l3.166,5.913-.089.045-3.19-5.958Z",
    transform: "translate(-300.004 -610.358)",
    fill: "#57bcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18034",
    "data-name": "Path 18034",
    d: "M327.856,610.358,331,616.226l-.089.045-3.166-5.913Z",
    transform: "translate(-300.244 -610.358)",
    fill: "#56bcff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18035",
    "data-name": "Path 18035",
    d: "M328.21,610.358l3.117,5.823-.089.045-3.142-5.868Z",
    transform: "translate(-300.485 -610.358)",
    fill: "#5bf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18036",
    "data-name": "Path 18036",
    d: "M328.564,610.358l3.093,5.777-.089.045-3.117-5.823Z",
    transform: "translate(-300.726 -610.358)",
    fill: "#54bbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18037",
    "data-name": "Path 18037",
    d: "M328.918,610.358l3.069,5.732-.089.045-3.094-5.777Z",
    transform: "translate(-300.966 -610.358)",
    fill: "#53baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18038",
    "data-name": "Path 18038",
    d: "M329.272,610.358l3.045,5.687-.089.046-3.069-5.732Z",
    transform: "translate(-301.207 -610.358)",
    fill: "#52baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18039",
    "data-name": "Path 18039",
    d: "M329.626,610.358,332.646,616l-.089.045-3.045-5.687Z",
    transform: "translate(-301.448 -610.358)",
    fill: "#51baff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18040",
    "data-name": "Path 18040",
    d: "M329.98,610.358l3,5.6-.089.045-3.021-5.641Z",
    transform: "translate(-301.688 -610.358)",
    fill: "#50b9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18041",
    "data-name": "Path 18041",
    d: "M330.334,610.358l2.972,5.551-.089.045-3-5.6Z",
    transform: "translate(-301.929 -610.358)",
    fill: "#4fb9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18042",
    "data-name": "Path 18042",
    d: "M330.688,610.358l2.948,5.506-.089.045-2.972-5.551Z",
    transform: "translate(-302.17 -610.358)",
    fill: "#4eb8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18043",
    "data-name": "Path 18043",
    d: "M331.042,610.358l2.924,5.46-.089.046-2.948-5.506Z",
    transform: "translate(-302.41 -610.358)",
    fill: "#4db8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18044",
    "data-name": "Path 18044",
    d: "M331.4,610.358l2.9,5.415-.089.045-2.924-5.46Z",
    transform: "translate(-302.651 -610.358)",
    fill: "#4cb8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18045",
    "data-name": "Path 18045",
    d: "M331.75,610.358l2.875,5.37-.089.045-2.9-5.415Z",
    transform: "translate(-302.892 -610.358)",
    fill: "#4bb7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18046",
    "data-name": "Path 18046",
    d: "M332.1,610.358l2.851,5.324-.089.045-2.875-5.37Z",
    transform: "translate(-303.133 -610.358)",
    fill: "#4ab7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18047",
    "data-name": "Path 18047",
    d: "M332.458,610.358l2.827,5.279-.089.045-2.851-5.324Z",
    transform: "translate(-303.373 -610.358)",
    fill: "#49b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18048",
    "data-name": "Path 18048",
    d: "M332.812,610.358l2.8,5.234-.089.045-2.827-5.279Z",
    transform: "translate(-303.614 -610.358)",
    fill: "#48b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18049",
    "data-name": "Path 18049",
    d: "M333.166,610.358l2.778,5.188-.089.045-2.8-5.234Z",
    transform: "translate(-303.855 -610.358)",
    fill: "#47b6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18050",
    "data-name": "Path 18050",
    d: "M333.52,610.358l2.754,5.143-.089.045-2.778-5.188Z",
    transform: "translate(-304.095 -610.358)",
    fill: "#46b5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18051",
    "data-name": "Path 18051",
    d: "M333.874,610.358l2.73,5.1-.089.045-2.754-5.143Z",
    transform: "translate(-304.336 -610.358)",
    fill: "#45b5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18052",
    "data-name": "Path 18052",
    d: "M334.228,610.358l2.706,5.053-.089.045-2.73-5.1Z",
    transform: "translate(-304.577 -610.358)",
    fill: "#44b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18053",
    "data-name": "Path 18053",
    d: "M334.582,610.358l2.681,5.008-.089.045-2.706-5.053Z",
    transform: "translate(-304.817 -610.358)",
    fill: "#43b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18054",
    "data-name": "Path 18054",
    d: "M334.936,610.358l2.657,4.962-.089.045-2.681-5.008Z",
    transform: "translate(-305.058 -610.358)",
    fill: "#42b4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18055",
    "data-name": "Path 18055",
    d: "M335.29,610.358l2.633,4.917-.089.046-2.657-4.962Z",
    transform: "translate(-305.299 -610.358)",
    fill: "#41b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18056",
    "data-name": "Path 18056",
    d: "M335.644,610.358l2.609,4.872-.089.045-2.633-4.917Z",
    transform: "translate(-305.539 -610.358)",
    fill: "#40b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18057",
    "data-name": "Path 18057",
    d: "M336,610.358l2.584,4.826-.089.045-2.609-4.872Z",
    transform: "translate(-305.78 -610.358)",
    fill: "#3fb2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18058",
    "data-name": "Path 18058",
    d: "M336.352,610.358l2.56,4.781-.089.045-2.584-4.826Z",
    transform: "translate(-306.021 -610.358)",
    fill: "#3eb2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18059",
    "data-name": "Path 18059",
    d: "M336.706,610.358l2.536,4.736-.089.045-2.56-4.781Z",
    transform: "translate(-306.261 -610.358)",
    fill: "#3db1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18060",
    "data-name": "Path 18060",
    d: "M337.06,610.358l2.512,4.69-.089.046-2.536-4.736Z",
    transform: "translate(-306.502 -610.358)",
    fill: "#3cb1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18061",
    "data-name": "Path 18061",
    d: "M337.414,610.358,339.9,615l-.089.045-2.512-4.69Z",
    transform: "translate(-306.743 -610.358)",
    fill: "#3bb1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18062",
    "data-name": "Path 18062",
    d: "M337.768,610.358l2.463,4.6-.089.045-2.487-4.645Z",
    transform: "translate(-306.984 -610.358)",
    fill: "#3ab0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18063",
    "data-name": "Path 18063",
    d: "M338.122,610.358l2.439,4.555-.089.045-2.463-4.6Z",
    transform: "translate(-307.224 -610.358)",
    fill: "#39b0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18064",
    "data-name": "Path 18064",
    d: "M338.476,610.358l2.415,4.509-.089.045-2.439-4.555Z",
    transform: "translate(-307.465 -610.358)",
    fill: "#38afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18065",
    "data-name": "Path 18065",
    d: "M338.83,610.358l2.39,4.464-.089.045-2.415-4.509Z",
    transform: "translate(-307.706 -610.358)",
    fill: "#37afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18066",
    "data-name": "Path 18066",
    d: "M339.184,610.358l2.366,4.419-.089.046-2.39-4.464Z",
    transform: "translate(-307.946 -610.358)",
    fill: "#36afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18067",
    "data-name": "Path 18067",
    d: "M339.538,610.358l2.342,4.373-.089.045-2.366-4.419Z",
    transform: "translate(-308.187 -610.358)",
    fill: "#35aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18068",
    "data-name": "Path 18068",
    d: "M339.892,610.358l2.318,4.328-.089.045-2.342-4.373Z",
    transform: "translate(-308.428 -610.358)",
    fill: "#34aeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18069",
    "data-name": "Path 18069",
    d: "M340.246,610.358l2.293,4.283-.089.045-2.318-4.328Z",
    transform: "translate(-308.668 -610.358)",
    fill: "#33adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18070",
    "data-name": "Path 18070",
    d: "M340.6,610.358l2.269,4.238-.089.045-2.293-4.283Z",
    transform: "translate(-308.909 -610.358)",
    fill: "#32adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18071",
    "data-name": "Path 18071",
    d: "M340.954,610.358l2.245,4.192-.089.046-2.269-4.238Z",
    transform: "translate(-309.15 -610.358)",
    fill: "#31adff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18072",
    "data-name": "Path 18072",
    d: "M341.308,610.358l2.221,4.147-.089.045-2.245-4.192Z",
    transform: "translate(-309.39 -610.358)",
    fill: "#30acff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18073",
    "data-name": "Path 18073",
    d: "M341.662,610.358l2.2,4.1-.089.045-2.221-4.147Z",
    transform: "translate(-309.631 -610.358)",
    fill: "#2facff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18074",
    "data-name": "Path 18074",
    d: "M342.016,610.358l2.172,4.057-.089.045-2.2-4.1Z",
    transform: "translate(-309.872 -610.358)",
    fill: "#2eabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18075",
    "data-name": "Path 18075",
    d: "M342.37,610.358l2.148,4.011-.089.045-2.172-4.057Z",
    transform: "translate(-310.113 -610.358)",
    fill: "#2dabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18076",
    "data-name": "Path 18076",
    d: "M342.724,610.358l2.124,3.966-.089.045-2.148-4.011Z",
    transform: "translate(-310.353 -610.358)",
    fill: "#2cabff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18077",
    "data-name": "Path 18077",
    d: "M343.078,610.358l2.1,3.92-.089.046-2.124-3.966Z",
    transform: "translate(-310.594 -610.358)",
    fill: "#2baaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18078",
    "data-name": "Path 18078",
    d: "M343.432,610.358l2.075,3.875-.089.045-2.1-3.92Z",
    transform: "translate(-310.835 -610.358)",
    fill: "#2aaaff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18079",
    "data-name": "Path 18079",
    d: "M343.786,610.358l2.051,3.83-.089.045-2.075-3.875Z",
    transform: "translate(-311.075 -610.358)",
    fill: "#29a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18080",
    "data-name": "Path 18080",
    d: "M344.14,610.358l2.027,3.785-.089.045-2.051-3.83Z",
    transform: "translate(-311.316 -610.358)",
    fill: "#28a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18081",
    "data-name": "Path 18081",
    d: "M344.494,610.358l2,3.74-.089.045-2.027-3.785Z",
    transform: "translate(-311.557 -610.358)",
    fill: "#27a9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18082",
    "data-name": "Path 18082",
    d: "M344.848,610.358l1.978,3.694-.089.046-2-3.74Z",
    transform: "translate(-311.797 -610.358)",
    fill: "#26a8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18083",
    "data-name": "Path 18083",
    d: "M345.2,610.358l1.954,3.649-.089.045-1.978-3.694Z",
    transform: "translate(-312.038 -610.358)",
    fill: "#25a8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18084",
    "data-name": "Path 18084",
    d: "M345.556,610.358l1.93,3.6-.089.045-1.954-3.649Z",
    transform: "translate(-312.279 -610.358)",
    fill: "#24a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18085",
    "data-name": "Path 18085",
    d: "M345.91,610.358l1.905,3.558-.089.045-1.93-3.6Z",
    transform: "translate(-312.519 -610.358)",
    fill: "#23a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18086",
    "data-name": "Path 18086",
    d: "M346.264,610.358l1.881,3.513-.089.045-1.905-3.558Z",
    transform: "translate(-312.76 -610.358)",
    fill: "#22a7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18087",
    "data-name": "Path 18087",
    d: "M346.618,610.358l1.857,3.468-.089.045-1.881-3.513Z",
    transform: "translate(-313.001 -610.358)",
    fill: "#21a6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18088",
    "data-name": "Path 18088",
    d: "M346.972,610.358l1.833,3.422-.089.045-1.857-3.468Z",
    transform: "translate(-313.242 -610.358)",
    fill: "#20a6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18089",
    "data-name": "Path 18089",
    d: "M347.326,610.358l1.808,3.377-.089.045-1.833-3.422Z",
    transform: "translate(-313.482 -610.358)",
    fill: "#1fa5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18090",
    "data-name": "Path 18090",
    d: "M347.68,610.358l1.784,3.332-.089.045-1.808-3.377Z",
    transform: "translate(-313.723 -610.358)",
    fill: "#1ea5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18091",
    "data-name": "Path 18091",
    d: "M348.034,610.358l1.76,3.287-.089.045-1.784-3.332Z",
    transform: "translate(-313.964 -610.358)",
    fill: "#1da5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18092",
    "data-name": "Path 18092",
    d: "M348.388,610.358l1.736,3.241-.089.045-1.76-3.287Z",
    transform: "translate(-314.204 -610.358)",
    fill: "#1ca4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18093",
    "data-name": "Path 18093",
    d: "M348.742,610.358l1.711,3.2-.089.045-1.736-3.241Z",
    transform: "translate(-314.445 -610.358)",
    fill: "#1ba4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18094",
    "data-name": "Path 18094",
    d: "M349.1,610.358l1.687,3.151-.089.045-1.711-3.2Z",
    transform: "translate(-314.686 -610.358)",
    fill: "#1aa3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18095",
    "data-name": "Path 18095",
    d: "M349.45,610.358l1.663,3.105-.089.045-1.687-3.151Z",
    transform: "translate(-314.926 -610.358)",
    fill: "#19a3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18096",
    "data-name": "Path 18096",
    d: "M349.8,610.358l1.639,3.06-.089.045-1.663-3.105Z",
    transform: "translate(-315.167 -610.358)",
    fill: "#18a3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18097",
    "data-name": "Path 18097",
    d: "M350.158,610.358l1.614,3.015-.089.045-1.639-3.06Z",
    transform: "translate(-315.408 -610.358)",
    fill: "#17a2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18098",
    "data-name": "Path 18098",
    d: "M350.512,610.358l1.59,2.97-.089.045-1.614-3.015Z",
    transform: "translate(-315.648 -610.358)",
    fill: "#16a2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18099",
    "data-name": "Path 18099",
    d: "M350.866,610.358l1.566,2.924-.089.046-1.59-2.97Z",
    transform: "translate(-315.889 -610.358)",
    fill: "#15a1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18100",
    "data-name": "Path 18100",
    d: "M351.22,610.358l1.542,2.879-.089.045-1.566-2.924Z",
    transform: "translate(-316.13 -610.358)",
    fill: "#14a1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18101",
    "data-name": "Path 18101",
    d: "M351.574,610.358l1.472,2.75v.106l-.044.022-1.542-2.879Z",
    transform: "translate(-316.371 -610.358)",
    fill: "#13a1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18102",
    "data-name": "Path 18102",
    d: "M351.928,610.358l1.359,2.539v.211l-1.472-2.75Z",
    transform: "translate(-316.611 -610.358)",
    fill: "#12a0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18103",
    "data-name": "Path 18103",
    d: "M352.282,610.358l1.246,2.327v.212l-1.359-2.539Z",
    transform: "translate(-316.852 -610.358)",
    fill: "#11a0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18104",
    "data-name": "Path 18104",
    d: "M352.636,610.358l1.133,2.115v.211l-1.246-2.327Z",
    transform: "translate(-317.093 -610.358)",
    fill: "#109fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18105",
    "data-name": "Path 18105",
    d: "M352.99,610.358l1.019,1.9v.212l-1.133-2.115Z",
    transform: "translate(-317.333 -610.358)",
    fill: "#0f9fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18106",
    "data-name": "Path 18106",
    d: "M353.344,610.358l.906,1.692v.211l-1.019-1.9Z",
    transform: "translate(-317.574 -610.358)",
    fill: "#0e9fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18107",
    "data-name": "Path 18107",
    d: "M353.7,610.358l.793,1.48v.212l-.906-1.692Z",
    transform: "translate(-317.815 -610.358)",
    fill: "#0d9eff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18108",
    "data-name": "Path 18108",
    d: "M354.052,610.358l.679,1.269v.211l-.793-1.48Z",
    transform: "translate(-318.055 -610.358)",
    fill: "#0c9eff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18109",
    "data-name": "Path 18109",
    d: "M354.406,610.358l.566,1.057v.212l-.679-1.269Z",
    transform: "translate(-318.296 -610.358)",
    fill: "#0b9dff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18110",
    "data-name": "Path 18110",
    d: "M354.76,610.358l.453.846v.211l-.566-1.057Z",
    transform: "translate(-318.537 -610.358)",
    fill: "#0a9dff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18111",
    "data-name": "Path 18111",
    d: "M355.115,610.358l.339.634v.212l-.453-.846Z",
    transform: "translate(-318.777 -610.358)",
    fill: "#099dff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18112",
    "data-name": "Path 18112",
    d: "M355.468,610.358l.226.422v.211l-.339-.634Z",
    transform: "translate(-319.018 -610.358)",
    fill: "#089cff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18113",
    "data-name": "Path 18113",
    d: "M355.823,610.358l.113.211v.212l-.226-.422Z",
    transform: "translate(-319.259 -610.358)",
    fill: "#079cff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18114",
    "data-name": "Path 18114",
    d: "M356.176,610.568l-.113-.211h.113Z",
    transform: "translate(-319.5 -610.358)",
    fill: "#069bff",
    fillRule: "evenodd"
  }))))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18116",
    "data-name": "Path 18116",
    d: "M304.756,411.213q-.189-.285-.391-.566c-.523-.727-1.094-1.329-1.578-2.11a1.425,1.425,0,0,1-.2-1.344,1.858,1.858,0,0,1,.637-1.293,2.171,2.171,0,0,1,1.194-.7c.895-.079.319,1.581.32,1.745.4.481.782.725.865,1.315a6.555,6.555,0,0,0,.211,1.431,5.618,5.618,0,0,0,.568.749Z",
    transform: "translate(-205.675 -278.811)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18117",
    "data-name": "Path 18117",
    d: "M303.963,410.926l-.154-.232q-.186-.28-.384-.556c-.2-.279-.415-.547-.621-.806a13.4,13.4,0,0,1-.968-1.321,1.563,1.563,0,0,1-.272-1.372l.027-.177a2.134,2.134,0,0,1,.7-1.436,2.5,2.5,0,0,1,1.424-.822.722.722,0,0,1,.633.224c.342.382.215,1.076.069,1.7l-.011.047c.06.068.119.13.176.191a2.025,2.025,0,0,1,.663,1.17c.038.27.057.491.072.681a2.276,2.276,0,0,0,.11.656,5.511,5.511,0,0,0,.525.686l.264.306Zm-.165-6.1-.032,0a1.887,1.887,0,0,0-.981.59,1.584,1.584,0,0,0-.561,1.133l-.028.183a1,1,0,0,0,.187.956,12.792,12.792,0,0,0,.925,1.26c.212.265.431.539.641.832q.123.171.241.344l1.008-.478a4.169,4.169,0,0,1-.344-.486l-.017-.034a2.649,2.649,0,0,1-.165-.863c-.015-.18-.032-.39-.068-.646a1.458,1.458,0,0,0-.5-.834c-.093-.1-.193-.206-.294-.326l-.072-.086v-.111a1.291,1.291,0,0,1,.049-.275c.189-.8.144-1.067.073-1.146a.09.09,0,0,0-.061-.015",
    transform: "translate(-204.997 -278.123)",
    fill: "#09f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18118",
    "data-name": "Path 18118",
    d: "M311.272,425.2c-.848-1.467-1.927-1.9-2.653-3.51a5.2,5.2,0,0,0-.18-.579q-.178-.268-.368-.532a2.459,2.459,0,0,0,1.571-.965,4.367,4.367,0,0,0,.374.517c.132.162.494.2.681.368,1.3,1.159,3.157,2.857,3.441,3.726.275.814.7,9.2-1.249,9.743-1.471.41-2.39-.143-2.724-.922-.649-1.511,1.247-6.961,1.107-7.846",
    transform: "translate(-209.456 -288.726)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18119",
    "data-name": "Path 18119",
    d: "M310.695,430.338a2.127,2.127,0,0,1-2.065-1.256c-.415-.966.023-3.017.639-5.6a15.047,15.047,0,0,0,.451-2.27,7.755,7.755,0,0,0-1.162-1.448,6.93,6.93,0,0,1-1.471-2.032,1.755,1.755,0,0,1-.088-.3,1.622,1.622,0,0,0-.069-.242c-.115-.172-.235-.346-.359-.519l-.322-.448.56-.042a2.43,2.43,0,0,0,1.258-.7l-.376-1.8.992,1.695a3.964,3.964,0,0,0,.347.478,1.071,1.071,0,0,0,.2.093,1.409,1.409,0,0,1,.442.239c1.664,1.488,3.243,2.985,3.53,3.861.243.719.618,7.123-.581,9.329a1.515,1.515,0,0,1-.885.808,3.88,3.88,0,0,1-1.042.154m-3.34-13.647.112.167a1.4,1.4,0,0,1,.153.436,1.693,1.693,0,0,0,.051.187,6.319,6.319,0,0,0,1.355,1.86,8.225,8.225,0,0,1,1.284,1.623l.029.049.009.056a9.96,9.96,0,0,1-.456,2.556c-.439,1.84-1.04,4.36-.672,5.217.335.78,1.21,1.059,2.341.743a.932.932,0,0,0,.5-.5c1.072-1.973.758-8.193.537-8.845-.276-.842-2.432-2.77-3.354-3.593a.989.989,0,0,0-.247-.12,1.07,1.07,0,0,1-.468-.284c-.053-.065-.1-.127-.146-.185a3.372,3.372,0,0,1-1.024.635",
    transform: "translate(-208.215 -284.647)",
    fill: "#09f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11720",
    "data-name": "Group 11720",
    transform: "translate(100.255 139.744)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11719",
    "data-name": "Group 11719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11718",
    "data-name": "Group 11718",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18120",
    "data-name": "Path 18120",
    d: "M318.525,449.09c0,.474-.044,1.057-.094,1.538-.184,1.8-.677,3.373-1.381,3.569-1.471.41-2.389-.143-2.724-.922a4,4,0,0,1-.068-1.844c.761-.855,2.849-2.819,4.267-2.342",
    transform: "translate(-313.871 -448.705)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18121",
    "data-name": "Path 18121",
    d: "M315.417,453.965a2.128,2.128,0,0,1-2.066-1.256,4.143,4.143,0,0,1-.091-2l.012-.095.064-.072c.279-.314,2.782-3.049,4.613-2.433l.216.073v.222c0,.523-.052,1.143-.1,1.57-.108,1.049-.48,3.523-1.612,3.838a3.883,3.883,0,0,1-1.042.154m-1.532-3.087a3.388,3.388,0,0,0,.057,1.591c.335.78,1.21,1.058,2.34.743.415-.116.944-1.287,1.151-3.3.035-.347.076-.823.088-1.262-1.147-.139-2.817,1.327-3.637,2.229",
    transform: "translate(-313.191 -448.018)",
    fill: "#09f"
  }))))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18122",
    "data-name": "Path 18122",
    d: "M297.274,603.689c-.5-1.067-.777-1.634-2.079-1.808a1.911,1.911,0,0,0-1.016.428c-1.318.222-1.343,1.459-1.065,2.6.258,1.057.535,1.161.552,1.717a2.715,2.715,0,0,1-.145.726,3.353,3.353,0,0,0,.661,2.472,3.654,3.654,0,0,0,3,1.332c.385-.038.413-.8.349-1.329-.134-1.082-.314-1.552-.375-2.16a9.586,9.586,0,0,1,.131-2.28,4.464,4.464,0,0,0-.013-1.694",
    transform: "translate(-199.19 -414.144)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18123",
    "data-name": "Path 18123",
    d: "M296.269,610.785a4,4,0,0,1-3.032-1.481,3.605,3.605,0,0,1-.7-2.725l.014-.05a2.386,2.386,0,0,0,.121-.586,1.288,1.288,0,0,0-.163-.562,5.51,5.51,0,0,1-.381-1.092,2.859,2.859,0,0,1,.16-2.287,1.639,1.639,0,0,1,1.086-.676,2.155,2.155,0,0,1,1.137-.447h.026l.026,0c1.49.2,1.823.911,2.327,1.988a4.261,4.261,0,0,1,.04,1.863l-.021.158a8.672,8.672,0,0,0-.109,2.052,7.286,7.286,0,0,0,.138.788c.073.342.163.766.237,1.366a2.188,2.188,0,0,1-.219,1.449.606.606,0,0,1-.415.227q-.132.013-.268.013M294.5,601.5a1.642,1.642,0,0,0-.811.367l-.06.043-.074.012a1.038,1.038,0,0,0-.736.419,2.353,2.353,0,0,0-.072,1.8,4.919,4.919,0,0,0,.343.983,1.869,1.869,0,0,1,.218.8,2.683,2.683,0,0,1-.142.765l-.013.05a3.053,3.053,0,0,0,.617,2.219,3.351,3.351,0,0,0,2.7,1.195,1.915,1.915,0,0,0,.063-.981c-.071-.573-.155-.967-.228-1.314a7.673,7.673,0,0,1-.148-.853,9.108,9.108,0,0,1,.111-2.193l.021-.157a4.131,4.131,0,0,0,.013-1.525h0c-.484-1.035-.687-1.468-1.8-1.625",
    transform: "translate(-198.511 -413.454)",
    fill: "#09f"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18124",
    "data-name": "Path 18124",
    d: "M294.5,603.093c-1.557.084-1.654,1.43-1.36,2.648.255,1.057.535,1.161.552,1.716a2.716,2.716,0,0,1-.145.726,3.354,3.354,0,0,0,.661,2.472,3.655,3.655,0,0,0,3,1.332.313.313,0,0,0,.241-.174,3.7,3.7,0,0,0-.32-1.489,8.639,8.639,0,0,1-.783-1.954c-.143-.609-.035-1.548-.146-2.259-.278-1.788-.506-2.828-1.7-3.017",
    transform: "translate(-199.212 -414.978)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18125",
    "data-name": "Path 18125",
    d: "M296.292,611.618a4,4,0,0,1-3.032-1.481,3.6,3.6,0,0,1-.7-2.725l.014-.051a2.352,2.352,0,0,0,.121-.586,1.275,1.275,0,0,0-.162-.559,5.44,5.44,0,0,1-.382-1.1,2.9,2.9,0,0,1,.24-2.374,1.808,1.808,0,0,1,1.415-.656l.034,0,.034.006c1.493.235,1.712,1.645,1.966,3.278a8.156,8.156,0,0,1,.063,1.126,5.624,5.624,0,0,0,.078,1.11,7.353,7.353,0,0,0,.648,1.662l.113.228c.006.012.546,1.367.31,1.776a.63.63,0,0,1-.488.332q-.132.013-.268.013m-2.491-8.9a1.166,1.166,0,0,0-.9.405,2.284,2.284,0,0,0-.129,1.857,4.8,4.8,0,0,0,.343.985,1.856,1.856,0,0,1,.217.794,2.681,2.681,0,0,1-.142.765l-.013.05a3.055,3.055,0,0,0,.617,2.219,3.359,3.359,0,0,0,2.68,1.2,4.769,4.769,0,0,0-.313-1.221l-.11-.224a7.853,7.853,0,0,1-.7-1.794,5.988,5.988,0,0,1-.094-1.242,7.777,7.777,0,0,0-.056-1.04c-.283-1.82-.492-2.589-1.4-2.75m2.688,8.253h0",
    transform: "translate(-198.534 -414.286)",
    fill: "#09f"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18126",
    "data-name": "Path 18126",
    d: "M293.211,604.841a2.853,2.853,0,0,0-.074,1.946c.255,1.057.535,1.161.552,1.716a2.711,2.711,0,0,1-.145.725,3.353,3.353,0,0,0,.661,2.472,3.654,3.654,0,0,0,3,1.331.273.273,0,0,0,.142-.056,1.5,1.5,0,0,0-.146-.672c-.426-1.062-1.476-2.578-1.588-3.58-.054-.484.029-.87.011-1.306a3.935,3.935,0,0,0-.613-2.122,1.266,1.266,0,0,0-1.8-.455",
    transform: "translate(-199.213 -416.025)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18127",
    "data-name": "Path 18127",
    d: "M296.292,612.668a4,4,0,0,1-3.031-1.481,3.6,3.6,0,0,1-.7-2.725l.014-.05a2.359,2.359,0,0,0,.121-.586,1.276,1.276,0,0,0-.162-.559,5.436,5.436,0,0,1-.382-1.1,3.186,3.186,0,0,1,.1-2.162l.028-.051.045-.038a1.275,1.275,0,0,1,1.012-.293,1.9,1.9,0,0,1,1.265.809,4.189,4.189,0,0,1,.667,2.282,5.4,5.4,0,0,1-.013.569,4.028,4.028,0,0,0,0,.716,7.508,7.508,0,0,0,.914,2.172,14.558,14.558,0,0,1,.655,1.329,1.773,1.773,0,0,1,.166.812l-.012.136-.11.084a.6.6,0,0,1-.307.12,2.6,2.6,0,0,1-.268.013m-3.5-8.314a2.726,2.726,0,0,0-.019,1.674,4.805,4.805,0,0,0,.343.985,1.858,1.858,0,0,1,.217.794,2.682,2.682,0,0,1-.142.765l-.013.05a3.055,3.055,0,0,0,.617,2.219,3.352,3.352,0,0,0,2.536,1.2,2.162,2.162,0,0,0-.1-.314,14.14,14.14,0,0,0-.627-1.269,7.8,7.8,0,0,1-.981-2.391,4.571,4.571,0,0,1,0-.82,4.977,4.977,0,0,0,.013-.507,3.613,3.613,0,0,0-.559-1.961,1.256,1.256,0,0,0-.817-.537.626.626,0,0,0-.462.109",
    transform: "translate(-198.535 -415.337)",
    fill: "#09f"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18128",
    "data-name": "Path 18128",
    d: "M306.144,498.571c-.414,2.489-4.579,3.751-3.574,8.778.387,1.936,1.486,8.155,1.224,9.952-.276,1.9-2.061,2.767-2.81,4.754-1.1,2.912-1.173,6.182-2.284,8.767a2.859,2.859,0,0,1,2.607,2.616c1.031-3.822,3.521-8.061,5.232-11.592,1-2.054,1.441-2.454,1.579-3.271a59.944,59.944,0,0,0,.709-12.279l-.2-1.03-.9-4.062Z",
    transform: "translate(-203.085 -343.058)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18129",
    "data-name": "Path 18129",
    d: "M300.227,532.987l-.231-1.5a2.536,2.536,0,0,0-2.311-2.352l-.447-.029.173-.4a21.661,21.661,0,0,0,1.157-4.352,27.249,27.249,0,0,1,1.121-4.4,8.01,8.01,0,0,1,1.473-2.3,4.853,4.853,0,0,0,1.32-2.386c.238-1.633-.72-7.341-1.222-9.849-.669-3.348.886-5.136,2.135-6.573a5.157,5.157,0,0,0,1.437-2.315l.142-.855,2.072,3.473.9,4.062.207,1.076a60.273,60.273,0,0,1-.713,12.349,4.568,4.568,0,0,1-.65,1.534c-.233.416-.551.985-.956,1.819-.429.885-.9,1.8-1.4,2.768a48.411,48.411,0,0,0-3.816,8.771Zm-2.074-4.415a3.041,3.041,0,0,1,2.159,1.759,56.888,56.888,0,0,1,3.553-7.859c.5-.964.964-1.876,1.39-2.755.412-.85.736-1.429.972-1.852a4.033,4.033,0,0,0,.581-1.337,59.622,59.622,0,0,0,.706-12.189l-.2-1.011-.885-4.005-1.189-1.974a8.014,8.014,0,0,1-1.359,1.894c-1.222,1.4-2.606,3-2,6.05.4,2.022,1.5,8.207,1.227,10.056a5.4,5.4,0,0,1-1.455,2.689,7.508,7.508,0,0,0-1.372,2.129,26.8,26.8,0,0,0-1.093,4.3,24.521,24.521,0,0,1-1.043,4.1",
    transform: "translate(-202.09 -341.062)",
    fill: "#09f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11723",
    "data-name": "Group 11723",
    transform: "translate(99.728 157.686)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11722",
    "data-name": "Group 11722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11721",
    "data-name": "Group 11721",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18130",
    "data-name": "Path 18130",
    d: "M312.465,519.646a11.991,11.991,0,0,1,.063,2.448,4.256,4.256,0,0,1-.982,2.036,16.915,16.915,0,0,1,2.843,1.173,88.617,88.617,0,0,0-2.709,8.552c1.135-2.5,2.518-5,3.593-7.216,1-2.054,1.441-2.455,1.579-3.271a59.919,59.919,0,0,0,.709-12.279l-.2-1.03-.9-4.062-.278-.461-.052.1a34.765,34.765,0,0,0-1.625,3.7c-.535,2.107-.537,3.725-1.894,3.786a8.558,8.558,0,0,1,2.233,1.959c.648,1.256.749,2.088.892,4.551a13.952,13.952,0,0,1-3.275.016",
    transform: "translate(-311.546 -505.537)",
    fill: "#09f",
    fillRule: "evenodd"
  }))))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18131",
    "data-name": "Path 18131",
    d: "M308.22,552.648a3.132,3.132,0,0,1-.74-.27c-.582.115-2.2,1.443-1.931,2.12.528.109,1.138.261,1.8.446Z",
    transform: "translate(-207.72 -380.082)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18132",
    "data-name": "Path 18132",
    d: "M306.863,554.6l-.286-.08c-.666-.187-1.263-.335-1.776-.44l-.169-.035-.063-.157a1,1,0,0,1,.126-.87,4.154,4.154,0,0,1,2.039-1.669l.114-.022.1.055a2.81,2.81,0,0,0,.664.241l.349.083Zm-1.692-1.08c.393.086.828.194,1.3.322l.651-1.712a3.22,3.22,0,0,1-.351-.14,3.9,3.9,0,0,0-1.51,1.327.887.887,0,0,0-.087.2",
    transform: "translate(-207.039 -379.358)",
    fill: "#09f"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18133",
    "data-name": "Path 18133",
    d: "M294.216,545.879a5,5,0,0,0-.478-1.1,1.608,1.608,0,0,0-1.42-.657,2.938,2.938,0,0,0-1.812,1.174,4.667,4.667,0,0,0-.666,1.324c-.339.764-3.076,1.014-3.338,3.343a1.153,1.153,0,0,0,1.223,1.405c.738-.014,1.342-.784,2.366-1.336a6.14,6.14,0,0,1,1.723-.513c.937-.165,1.741-.434,1.723-.582-.011-.088-.15-.185-.178-.45a1.359,1.359,0,0,1,.381-1.027,1.828,1.828,0,0,1,.582-.4c.217-.1.4-.267.282-.536-.09-.207-.28-.41-.388-.642",
    transform: "translate(-194.783 -374.393)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18134",
    "data-name": "Path 18134",
    d: "M287.007,550.99a1.474,1.474,0,0,1-1.124-.438,1.637,1.637,0,0,1-.381-1.314,3.812,3.812,0,0,1,2.515-2.879c.382-.194.777-.395.847-.554s.122-.29.169-.412a3.217,3.217,0,0,1,.539-.98,3.286,3.286,0,0,1,2.029-1.293,1.927,1.927,0,0,1,1.715.782,2.494,2.494,0,0,1,.374.788,3.247,3.247,0,0,0,.137.371h0a2.144,2.144,0,0,0,.174.284,2.227,2.227,0,0,1,.217.366.684.684,0,0,1-.437.937,1.521,1.521,0,0,0-.483.329,1.051,1.051,0,0,0-.3.788.439.439,0,0,0,.082.212.551.551,0,0,1,.1.231c.019.156.069.566-1.984.927a5.692,5.692,0,0,0-1.625.479,8.217,8.217,0,0,0-.981.649,2.771,2.771,0,0,1-1.534.726h-.043m4.784-7.256a1.1,1.1,0,0,0-.118.007,2.956,2.956,0,0,0-2.041,1.874c-.051.129-.106.272-.18.439-.161.362-.592.582-1.139.859-.9.457-2.02,1.026-2.175,2.394a1.047,1.047,0,0,0,.217.825.868.868,0,0,0,.681.234,2.342,2.342,0,0,0,1.16-.6,8.825,8.825,0,0,1,1.057-.7,6.205,6.205,0,0,1,1.821-.547,7.144,7.144,0,0,0,1.376-.361,1,1,0,0,1-.092-.332,1.649,1.649,0,0,1,.46-1.267,2.12,2.12,0,0,1,.681-.474c.113-.054.137-.093.139-.1a.142.142,0,0,0-.012-.037,1.8,1.8,0,0,0-.16-.263,2.648,2.648,0,0,1-.224-.371,3.735,3.735,0,0,1-.165-.441,1.91,1.91,0,0,0-.279-.606,1.31,1.31,0,0,0-1.008-.539",
    transform: "translate(-194.102 -373.704)",
    fill: "#09f"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18135",
    "data-name": "Path 18135",
    d: "M294.014,545.321a1.886,1.886,0,0,0-.276-.545,1.608,1.608,0,0,0-1.421-.657,2.938,2.938,0,0,0-1.812,1.175,4.666,4.666,0,0,0-.666,1.324c-.335.752-.813.391-1.5.87a4,4,0,0,0-1.836,2.473,1.285,1.285,0,0,0,.408,1.169.521.521,0,0,1,.088,0c1.519.066,3.788-2.682,4.671-3.375a1.275,1.275,0,0,1,.354-.215c.677-.214,1.958-1.369,1.993-2.216",
    transform: "translate(-194.783 -374.393)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18136",
    "data-name": "Path 18136",
    d: "M286.134,550.768l-.106-.083a1.58,1.58,0,0,1-.526-1.446,4.306,4.306,0,0,1,1.968-2.693,2.207,2.207,0,0,1,.859-.35c.293-.066.4-.091.536-.39.069-.156.121-.29.168-.412a3.217,3.217,0,0,1,.539-.98,3.285,3.285,0,0,1,2.029-1.293,1.927,1.927,0,0,1,1.714.782,2.193,2.193,0,0,1,.321.631l.019.055,0,.057c-.043,1.035-1.5,2.274-2.214,2.5a.97.97,0,0,0-.252.162c-.208.163-.512.462-.865.808-1.157,1.135-2.739,2.68-4.021,2.635a.2.2,0,0,0-.033,0Zm.218-.641h.02c1,0,2.5-1.473,3.5-2.453.366-.36.682-.67.917-.854a1.522,1.522,0,0,1,.455-.269,3.287,3.287,0,0,0,1.768-1.878,1.509,1.509,0,0,0-.209-.4,1.279,1.279,0,0,0-1.127-.531,2.954,2.954,0,0,0-2.041,1.874c-.051.129-.106.272-.18.438a1.182,1.182,0,0,1-.98.75,1.591,1.591,0,0,0-.631.25,3.815,3.815,0,0,0-1.7,2.253,1.089,1.089,0,0,0,.214.821",
    transform: "translate(-194.102 -373.704)",
    fill: "#09f"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18137",
    "data-name": "Path 18137",
    d: "M292.318,544.1a3.011,3.011,0,0,0-1.812,1.175,5.626,5.626,0,0,1-2.116,2.025,3.939,3.939,0,0,0-1.888,2.642,1.334,1.334,0,0,0,.319,1.09c.907.141,2.057-1.279,2.6-1.865,1.512-1.644.52-1.267,2.74-2.672,1.329-.841,2.077-2.607.161-2.4",
    transform: "translate(-194.783 -374.374)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18138",
    "data-name": "Path 18138",
    d: "M286.27,550.666a1.2,1.2,0,0,1-.182-.014l-.1-.016-.074-.074a1.622,1.622,0,0,1-.408-1.341,4.235,4.235,0,0,1,2.056-2.883,3.944,3.944,0,0,0,1.585-1.391c.129-.172.267-.356.433-.556A3.332,3.332,0,0,1,291.6,543.1c1.039-.116,1.362.319,1.461.588.274.745-.52,1.815-1.412,2.379-1.351.855-1.449,1-1.712,1.4a8.5,8.5,0,0,1-.964,1.217c-.056.06-.119.131-.187.207-.64.714-1.587,1.771-2.516,1.771m5.4-6.944a2.68,2.68,0,0,0-1.6,1.061c-.159.191-.29.366-.413.53a4.567,4.567,0,0,1-1.8,1.573,3.647,3.647,0,0,0-1.722,2.4,1.1,1.1,0,0,0,.159.753c.636-.027,1.553-1.05,2.007-1.557.07-.079.134-.151.192-.213a7.935,7.935,0,0,0,.9-1.138c.33-.5.5-.7,1.9-1.587.792-.5,1.281-1.31,1.158-1.645-.085-.23-.578-.2-.786-.178Z",
    transform: "translate(-194.102 -373.686)",
    fill: "#09f"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18139",
    "data-name": "Path 18139",
    d: "M317.872,503.042a42.782,42.782,0,0,1,1.735,4.178,38.548,38.548,0,0,1,1.06,7.331c.1,1.345.677,7.88.311,9.387a1,1,0,0,1-.4.534,2.063,2.063,0,0,1-2.057.361c-4.509-1.688-6.717-3.144-12.026-4.239a5.206,5.206,0,0,0,1.648-2.9c1.712.909,5.036.189,7.455.807-1.131-3.646-1.862-4.5-3.076-5.831-1.643-1.8-1.792-3.431-1.344-5.753.288-1.488.974-2.929,1.416-4.626Z",
    transform: "translate(-208.385 -345.618)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18140",
    "data-name": "Path 18140",
    d: "M317.322,524.5a2.471,2.471,0,0,1-.851-.143c-1.395-.522-2.557-1.017-3.681-1.494a38.7,38.7,0,0,0-8.3-2.731l-.845-.174.758-.4a5.008,5.008,0,0,0,1.482-2.643l.029-.491.443.235a8.893,8.893,0,0,0,3.713.477,19.038,19.038,0,0,1,3.121.185c-1.047-3.228-1.773-4.026-2.847-5.2-1.774-1.947-1.858-3.747-1.419-6.018a18.347,18.347,0,0,1,.749-2.528c.235-.675.478-1.373.672-2.117l.071-.273,5.734.816.072.155a43.717,43.717,0,0,1,1.748,4.21,40.462,40.462,0,0,1,1.075,7.4l.042.531c.281,3.512.564,7.7.261,8.95a1.283,1.283,0,0,1-.491.691,2.136,2.136,0,0,1-1.54.566m-12.1-4.852a39.732,39.732,0,0,1,7.827,2.643c1.117.475,2.272.967,3.654,1.483a1.76,1.76,0,0,0,1.7-.276l.046-.042a.707.707,0,0,0,.282-.358c.319-1.312-.13-6.916-.277-8.757l-.042-.535a37.373,37.373,0,0,0-1.045-7.257,42.291,42.291,0,0,0-1.65-3.99l-4.821-.686c-.185.664-.4,1.287-.612,1.891a17.9,17.9,0,0,0-.726,2.444c-.414,2.14-.339,3.724,1.269,5.488,1.292,1.418,2.019,2.327,3.142,5.947l.165.533-.553-.141a15.128,15.128,0,0,0-3.512-.282,11.284,11.284,0,0,1-3.618-.377,6.588,6.588,0,0,1-1.232,2.27",
    transform: "translate(-206.448 -344.848)",
    fill: "#09f"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18141",
    "data-name": "Path 18141",
    d: "M318.07,471.158a21.491,21.491,0,0,1-.947-3.261c-.373-2.022-.806-2.6-.551-4.266,1.542-1.082,1.48-2.23,1.212-2.817a24,24,0,0,0-1.33-2.158c-1.814-2.026-7.072-4.2-9.249-4.435-1.83-.2-2.139,1.685-1.8,3.541.518,2.824,2.823,5.037,3.744,7.713.509,1.478,1.482,1.912.439,3.715-.3,2.359,8.575,4.063,8.481,1.968",
    transform: "translate(-207.562 -312.532)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18142",
    "data-name": "Path 18142",
    d: "M315.318,471.728a11.54,11.54,0,0,1-5.608-1.512c-1.026-.672-1.175-1.325-1.12-1.754l.008-.061.031-.053a1.956,1.956,0,0,0,.022-2.4,7.17,7.17,0,0,1-.486-1.064,17.022,17.022,0,0,0-1.7-3.26,13.407,13.407,0,0,1-2.056-4.5c-.164-.892-.312-2.52.528-3.395a1.852,1.852,0,0,1,1.622-.512c2.249.244,7.6,2.467,9.454,4.54A23.255,23.255,0,0,1,317.4,460c.371.812.241,2.047-1.206,3.117a5.725,5.725,0,0,0,.229,2.509c.1.425.224.907.339,1.529a21.345,21.345,0,0,0,.934,3.213l.018.089a1.008,1.008,0,0,1-.586.943,3.962,3.962,0,0,1-1.8.329m-6.1-3.133c-.017.441.446.842.847,1.1,1.768,1.159,5.548,1.808,6.741,1.156.21-.114.255-.234.26-.331a21.494,21.494,0,0,1-.942-3.259c-.111-.6-.228-1.076-.331-1.493a6.312,6.312,0,0,1-.221-2.874l.02-.13.11-.077c1.559-1.094,1.241-2.142,1.106-2.437-.1-.223-1.095-1.874-1.279-2.08-1.712-1.912-6.89-4.1-9.043-4.33a1.223,1.223,0,0,0-1.083.318,3.485,3.485,0,0,0-.365,2.859,12.963,12.963,0,0,0,1.974,4.286,17.465,17.465,0,0,1,1.758,3.382,6.493,6.493,0,0,0,.447.975,2.511,2.511,0,0,1,0,2.932",
    transform: "translate(-206.881 -311.843)",
    fill: "#09f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11726",
    "data-name": "Group 11726",
    transform: "translate(104.826 145.572)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11725",
    "data-name": "Group 11725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11724",
    "data-name": "Group 11724",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18143",
    "data-name": "Path 18143",
    d: "M332.314,474.625a5.255,5.255,0,0,1,.013-1.709c1.542-1.082,1.48-2.23,1.212-2.817-.069-.151-.508-.9-.871-1.477-.573-.813-3.182-1.771-4.084.441-.718,1.76,1.789,4.5,3.731,5.561",
    transform: "translate(-328.142 -467.388)",
    fill: "#09f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18144",
    "data-name": "Path 18144",
    d: "M332.061,474.523l-.574-.314c-2.1-1.148-4.652-4.036-3.872-5.948a2.308,2.308,0,0,1,1.957-1.544,3.186,3.186,0,0,1,2.689,1.042c.339.541.815,1.342.9,1.526.371.813.241,2.047-1.205,3.117a4.865,4.865,0,0,0,0,1.488Zm-2.19-7.2a2.13,2.13,0,0,0-.227.012,1.692,1.692,0,0,0-1.433,1.154c-.563,1.381,1.3,3.666,3.053,4.846a6.066,6.066,0,0,1,.077-1.155l.02-.13.11-.077c1.559-1.094,1.241-2.142,1.106-2.437-.054-.117-.465-.825-.852-1.441a2.591,2.591,0,0,0-1.853-.773",
    transform: "translate(-327.472 -466.7)",
    fill: "#fff"
  }))))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18145",
    "data-name": "Path 18145",
    d: "M319.2,448.1a2.951,2.951,0,0,1-1.682-.091c-.109.491-.268,1.059-.417,1.678-.208.862-2.984.961-3.575-.256a21.256,21.256,0,0,0,.107-2.192,8.4,8.4,0,0,1-1.464-2.007c.456-1.173,4,.545,7.031,2.867",
    transform: "translate(-212.238 -306.097)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18146",
    "data-name": "Path 18146",
    d: "M314.818,449.97a2.509,2.509,0,0,1-2.309-1.087l-.026-.054,0-.06a8.267,8.267,0,0,1,.056-.876c.035-.385.091-1.013.075-1.2-.114-.154-.264-.321-.423-.5a4.7,4.7,0,0,1-1.049-1.542l-.038-.106.041-.106a.873.873,0,0,1,.618-.531c1.344-.364,4.526,1.436,6.911,3.264l.229.175-.157.239c-.217.328-1.154.244-1.713.127-.046.189-.1.388-.15.6-.063.245-.128.5-.192.768-.112.463-.663.79-1.473.874a3.867,3.867,0,0,1-.394.02m-1.7-1.3a2.223,2.223,0,0,0,2.027.659c.547-.057.881-.246.917-.4.065-.269.131-.528.195-.776.082-.321.159-.621.221-.9l.082-.367.355.145a2.7,2.7,0,0,0,.7.137c-2.426-1.749-4.84-2.894-5.688-2.666a.316.316,0,0,0-.136.069,4.648,4.648,0,0,0,.873,1.2,6.522,6.522,0,0,1,.5.6c.109.156.11.376,0,1.566-.025.275-.052.581-.056.724m5.179-1.5h0Z",
    transform: "translate(-211.515 -305.414)",
    fill: "#09f"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18147",
    "data-name": "Path 18147",
    d: "M318.613,438.3c-.261.163-1.919-.655-2.069-.648-1.444.069-3.2.183-3.481-.226a8.4,8.4,0,0,1-1.464-2.007,3.4,3.4,0,0,1,.907-3.955c2.249-1.853,5.779-.495,6.284,1.6.207.861-.111,1.079-.068,1.656a3.881,3.881,0,0,0,.3.723,10.6,10.6,0,0,1-.141,1.474c-.039.641-.1,1.27-.272,1.379",
    transform: "translate(-211.673 -296.279)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18148",
    "data-name": "Path 18148",
    d: "M317.828,437.942a5.115,5.115,0,0,1-1.541-.492c-.166-.069-.369-.152-.448-.177l-.238.012c-2.117.1-3.152.1-3.485-.375a6.041,6.041,0,0,0-.454-.54,4.693,4.693,0,0,1-1.049-1.542,3.684,3.684,0,0,1,1-4.3,4.409,4.409,0,0,1,4.184-.713,3.751,3.751,0,0,1,2.618,2.484,2.331,2.331,0,0,1,0,1.216,1.5,1.5,0,0,0-.057.489,5.162,5.162,0,0,0,.267.6c.092.165.061.367,0,.77-.037.242-.083.544-.1.871-.066,1.084-.164,1.464-.418,1.623a.5.5,0,0,1-.276.071m-1.962-1.294a2.189,2.189,0,0,1,.67.227,9.021,9.021,0,0,0,1.213.435,5.35,5.35,0,0,0,.134-1.1c.021-.355.07-.671.109-.926a3.9,3.9,0,0,0,.052-.418,3.612,3.612,0,0,1-.323-.814,2.086,2.086,0,0,1,.071-.67,1.718,1.718,0,0,0,0-.936,3.17,3.17,0,0,0-2.2-2.034,3.764,3.764,0,0,0-3.57.6,3.117,3.117,0,0,0-.811,3.615,4.216,4.216,0,0,0,.924,1.333,6.531,6.531,0,0,1,.5.6,9.1,9.1,0,0,0,2.925.1l.277-.013h.02m2.2-1.746h0",
    transform: "translate(-210.991 -295.591)",
    fill: "#09f"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18149",
    "data-name": "Path 18149",
    d: "M275.4,436.275c-.778,1.48-.221,2.708-1.109,3.714-1.334,1.513-.357,3.175,2.643,3.793a15.492,15.492,0,0,0,5.788-.565c.382-.128,2.168,1.069,5.018-.282,2.456-1.164,1.258-3.527,2.575-5.493a38.924,38.924,0,0,0,1.969-4.015c1.391-2.673,1.67-7.848-2.427-7.806-2.341-.768-6.158-.384-7.251,3.665-.685,2.534-3.137,1.867-4.084,4.785-.4,1.229-2.423.874-3.122,2.205",
    transform: "translate(-186.088 -292.641)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18150",
    "data-name": "Path 18150",
    d: "M277.443,443.508a6.541,6.541,0,0,1-1.259-.1c-1.827-.376-3.028-1.142-3.38-2.158a2.137,2.137,0,0,1,.561-2.143,2.643,2.643,0,0,0,.533-1.619,5.293,5.293,0,0,1,.535-2.035,2.981,2.981,0,0,1,1.845-1.29c.685-.246,1.112-.42,1.257-.867a4.692,4.692,0,0,1,2.332-2.742,3.238,3.238,0,0,0,1.747-2.028,5.4,5.4,0,0,1,2.7-3.562,6.639,6.639,0,0,1,4.912-.336,3.285,3.285,0,0,1,2.932,1.482c1.123,1.76.744,4.828-.271,6.778-.206.4-.41.866-.627,1.363a17.259,17.259,0,0,1-1.36,2.682,5.35,5.35,0,0,0-.721,2.333c-.177,1.23-.36,2.5-1.982,3.271a6.254,6.254,0,0,1-4.707.392,2.909,2.909,0,0,0-.37-.088,17.658,17.658,0,0,1-4.677.667M275,435.738h0a4.727,4.727,0,0,0-.468,1.817,3.189,3.189,0,0,1-.683,1.959,1.57,1.57,0,0,0-.439,1.537c.273.786,1.332,1.423,2.906,1.747a15.106,15.106,0,0,0,5.618-.555,1.292,1.292,0,0,1,.729.085,5.581,5.581,0,0,0,4.253-.353c1.316-.624,1.454-1.582,1.628-2.8a5.918,5.918,0,0,1,.819-2.587,16.764,16.764,0,0,0,1.307-2.585c.221-.507.429-.986.646-1.4.934-1.8,1.3-4.593.3-6.167a2.642,2.642,0,0,0-2.436-1.187h-.054l-.051-.017a5.968,5.968,0,0,0-4.455.277,4.8,4.8,0,0,0-2.384,3.172,3.837,3.837,0,0,1-2.019,2.393,4.06,4.06,0,0,0-2.069,2.406c-.247.761-.958,1.017-1.646,1.264a2.425,2.425,0,0,0-1.5.989",
    transform: "translate(-185.41 -291.962)",
    fill: "#09f"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18151",
    "data-name": "Path 18151",
    d: "M324.791,369.435c-.007,2.359-1.75,3.312-3.89,2.127l-25.645-14.3a8.115,8.115,0,0,1-3.864-6.422l.091-13.756-1.464-.075c.007-2.359,3.213-3.494,5.354-2.308L321.019,349a8.12,8.12,0,0,1,3.864,6.422l-.059,8.957h0c1.688,1.574,2.511,5.06,2.581,7.9l-1.488,1.106Z",
    transform: "translate(-197.182 -229.974)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18152",
    "data-name": "Path 18152",
    d: "M325.054,373.233l-.872-3.06a2.368,2.368,0,0,1-1.034,1.23,3.13,3.13,0,0,1-3.086-.252l-25.646-14.3a8.468,8.468,0,0,1-4.026-6.694l.089-13.46-1.462-.074v-.3a2.917,2.917,0,0,1,1.593-2.54,4.49,4.49,0,0,1,4.239-.038l25.646,14.3a8.471,8.471,0,0,1,4.025,6.695l-.058,8.825c1.8,1.783,2.516,5.418,2.581,8.025l0,.159Zm-1.258-6.745,1.622,5.691.982-.73c-.087-2.531-.786-5.609-2.175-7.212l-.41.8.067-10.3a7.785,7.785,0,0,0-3.7-6.15l-25.646-14.3a3.813,3.813,0,0,0-3.6.036,2.331,2.331,0,0,0-1.253,1.706l1.445.074-.093,14.054a7.783,7.783,0,0,0,3.7,6.149l25.646,14.3a2.517,2.517,0,0,0,2.448.254,2.283,2.283,0,0,0,.963-2.111Z",
    transform: "translate(-196.501 -229.292)",
    fill: "#09f"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18153",
    "data-name": "Path 18153",
    d: "M323.09,366.3c1.688,1.574,2.511,5.06,2.581,7.9a15.745,15.745,0,0,0-2.608-3.817h0l-.006.971c-.007,2.359-1.75,3.312-3.89,2.127l-25.645-14.3a8.117,8.117,0,0,1-3.865-6.423L289.748,339l0-.255c.007-2.359,1.748-3.314,3.889-2.127l25.645,14.3a8.121,8.121,0,0,1,3.864,6.423l-.059,8.957Z",
    transform: "translate(-196.936 -231.273)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18154",
    "data-name": "Path 18154",
    d: "M325.344,374.857l-.638-1.2a16.55,16.55,0,0,0-2.009-3.129v.141a2.865,2.865,0,0,1-1.282,2.648,3.13,3.13,0,0,1-3.086-.252l-25.646-14.3a8.469,8.469,0,0,1-4.025-6.694l.092-14.013a2.867,2.867,0,0,1,1.282-2.649,3.13,3.13,0,0,1,3.086.253l25.646,14.3a8.472,8.472,0,0,1,4.025,6.695l-.058,8.824c1.8,1.784,2.517,5.418,2.581,8.025Zm-34.123-39.128a1.745,1.745,0,0,0-.869.216,2.284,2.284,0,0,0-.963,2.112L289.3,352.07a7.784,7.784,0,0,0,3.7,6.149l25.646,14.3a2.517,2.517,0,0,0,2.448.254,2.284,2.284,0,0,0,.963-2.111l.01-1.551.554.372a14.274,14.274,0,0,1,1.956,2.624c-.243-2.261-.94-4.685-2.137-6.018l-.357.464.065-9.9a7.786,7.786,0,0,0-3.7-6.15L292.8,336.2a3.325,3.325,0,0,0-1.578-.471",
    transform: "translate(-196.256 -230.58)",
    fill: "#09f"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18155",
    "data-name": "Path 18155",
    d: "M320.735,385.128l-23.676-13.219a2.436,2.436,0,0,1-1.271-2.127l.007-2.415a1.2,1.2,0,0,1,1.794-.987l26.134,14.592a2.561,2.561,0,0,1,1.336,2.237l-.007,2.3a1.219,1.219,0,0,1-1.83,1.007Zm3.563,4.929-28.087-15.683a.833.833,0,0,1-.434-.727l0-.544a.486.486,0,0,1,.73-.4l28.119,15.7a.8.8,0,0,1,.415.694l0,.552a.494.494,0,0,1-.742.408",
    transform: "translate(-201.097 -251.991)",
    fill: "#00dcff",
    fillRule: "evenodd"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18156",
    "data-name": "Path 18156",
    d: "M379.192,454.292c1.012-.338,1.692-.044,2.231-.412a19.157,19.157,0,0,0,1.505-1.282c.266-.25.388-2.116-.1-2.272-1.031.441-1.46,1.154-2.089,1.3a6.3,6.3,0,0,1-1.275,0l.02-.012c.839-.115,1.41-.414,1.088-.931a2.383,2.383,0,0,1-.992.262,2.005,2.005,0,0,0-1.689,1.541,4.916,4.916,0,0,1-.852,1.133l.8,1.6a6.845,6.845,0,0,1,1.347-.928",
    transform: "translate(-256.35 -309.862)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18157",
    "data-name": "Path 18157",
    d: "M376.917,454.988l-1.087-2.171.164-.157a4.548,4.548,0,0,0,.784-1.041,2.322,2.322,0,0,1,1.961-1.723,2.059,2.059,0,0,0,.856-.223l.27-.148.16.258a.726.726,0,0,1,.086.692,4.25,4.25,0,0,0,.479-.352,5.378,5.378,0,0,1,1.289-.82l.112-.048.117.038a.8.8,0,0,1,.478.65,3.126,3.126,0,0,1-.26,2.142,19.15,19.15,0,0,1-1.544,1.313,2.051,2.051,0,0,1-1.15.275,3.973,3.973,0,0,0-1.135.168,6.486,6.486,0,0,0-1.265.876Zm-.312-2.047.523,1.046a6.982,6.982,0,0,1,1.085-.7l.051-.022a4.539,4.539,0,0,1,1.342-.21,1.51,1.51,0,0,0,.81-.163,19.18,19.18,0,0,0,1.466-1.25,3.25,3.25,0,0,0,.055-1.668,5.216,5.216,0,0,0-.939.637,2.626,2.626,0,0,1-1,.588,3.235,3.235,0,0,1-.977.024,3.385,3.385,0,0,0-.359-.018l-1,.042a3.475,3.475,0,0,0-.288.612l-.021.046a5.488,5.488,0,0,1-.746,1.041m2.375-2.44c-.066.008-.133.014-.2.018a1.285,1.285,0,0,0-.985.53l.736-.46.089-.022a3.577,3.577,0,0,0,.361-.067",
    transform: "translate(-255.525 -309.125)",
    fill: "#09f"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18158",
    "data-name": "Path 18158",
    d: "M343.759,459.781a4.085,4.085,0,0,1-.368.407c-.2.188-.59.17-.811.339-1.626,1.247-3.661,1.911-5.084,3.4-.163.171-.251.057-.507-.026-1.1-.38-6.966-1.868-6.987-1.869-2.748-.18-3.064,3.712-.738,4,1.929.341,5.37.469,7.019.793a8.865,8.865,0,0,0,1.384.155,2.476,2.476,0,0,0,1.936-.5,7.523,7.523,0,0,0,1.227-.964c1.082-1.032,2.193-2.075,3.3-3.1.109-.1.273-.657.385-.754a4.044,4.044,0,0,1,.592-.454,2.231,2.231,0,0,0-1.351-1.428",
    transform: "translate(-222.807 -316.367)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18159",
    "data-name": "Path 18159",
    d: "M337.358,466.59a1.57,1.57,0,0,1-.425-.056,9.258,9.258,0,0,1-1.395-.16c-.816-.16-2.078-.271-3.414-.389-1.294-.114-2.631-.232-3.6-.4a2.121,2.121,0,0,1-1.8-2.435,2.369,2.369,0,0,1,2.621-2.184c.179.005,6.173,1.575,7.073,1.886.066.021.127.047.181.069l.015.007a12.632,12.632,0,0,1,3-2.1,17.557,17.557,0,0,0,2.095-1.311,1.382,1.382,0,0,1,.5-.212.838.838,0,0,0,.279-.1,3.679,3.679,0,0,0,.34-.375l.123-.156.2.041a2.5,2.5,0,0,1,1.6,1.694l.025.192-.165.107a3.361,3.361,0,0,0-.488.369l-.069.059c-.008.018-.074.175-.113.269a1.369,1.369,0,0,1-.262.477c-1.152,1.066-2.262,2.11-3.3,3.1a7.932,7.932,0,0,1-1.281,1.006,3.474,3.474,0,0,1-1.734.6m-8.208-5.01a1.727,1.727,0,0,0-1.791,1.626,1.5,1.5,0,0,0,1.264,1.759c.956.169,2.28.285,3.559.4,1.354.119,2.633.232,3.483.4a8.536,8.536,0,0,0,1.33.149l.089.015a2.283,2.283,0,0,0,1.667-.47,7.264,7.264,0,0,0,1.173-.922c1.041-.994,2.154-2.039,3.308-3.108.01-.02.074-.171.111-.261a1.335,1.335,0,0,1,.282-.5l.069-.059a4.136,4.136,0,0,1,.369-.3,2.271,2.271,0,0,0-.885-.919c-.079.09-.161.175-.244.255a1.213,1.213,0,0,1-.56.261.949.949,0,0,0-.278.1,18.066,18.066,0,0,1-2.17,1.36,11.77,11.77,0,0,0-2.877,2.011.564.564,0,0,1-.707.11c-.039-.016-.083-.035-.135-.052-1.032-.356-6.491-1.748-6.934-1.856-.042,0-.084,0-.124,0",
    transform: "translate(-222.128 -315.604)",
    fill: "#09f"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18160",
    "data-name": "Path 18160",
    d: "M306.826,412.317c.6-1.027-.086-1.058-.652-1.75a2.512,2.512,0,0,0-.189-.694c.208-.789-.1-1.03-.511-1.092-.109.249-.333.738-.4.959-.018,1.341-.127,2.03,1.1,3.28l.75-.305Z",
    transform: "translate(-207.408 -281.275)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18161",
    "data-name": "Path 18161",
    d: "M305.406,412.628l-.152-.155a3.6,3.6,0,0,1-1.189-3.221l.019-.368c.063-.195.219-.545.344-.827l.169-.385.246.037a.967.967,0,0,1,.693.392,1.233,1.233,0,0,1,.1,1l.03.083a2.309,2.309,0,0,1,.138.5,3.688,3.688,0,0,0,.352.333,1.07,1.07,0,0,1,.327,1.587l.121.539Zm-.7-3.6,0,.233a2.975,2.975,0,0,0,.864,2.623l.3-.121-.059-.262.061-.1c.312-.533.235-.6-.134-.918a3.825,3.825,0,0,1-.49-.483l-.067-.082,0-.105a1.458,1.458,0,0,0-.111-.425c-.021-.058-.042-.118-.063-.18l-.028-.086.023-.087c.1-.375.047-.529.007-.588a.168.168,0,0,0-.033-.036c-.093.211-.207.47-.261.621",
    transform: "translate(-206.728 -280.513)",
    fill: "#09f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyArtLight);
export default __webpack_public_path__ + "static/media/empty_art_light.5e2182f5e8d37f44386cec7ca7320dd5.svg";
export { ForwardRef as ReactComponent };